import * as React from "react";
import type { SVGProps } from "react";
const SvgElSalvador = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <defs>
      <style>
        {
          ".El_Salvador_svg__cls-2,.El_Salvador_svg__cls-3{fill:#fff}.El_Salvador_svg__cls-10,.El_Salvador_svg__cls-11,.El_Salvador_svg__cls-13,.El_Salvador_svg__cls-14,.El_Salvador_svg__cls-177,.El_Salvador_svg__cls-183,.El_Salvador_svg__cls-185,.El_Salvador_svg__cls-3,.El_Salvador_svg__cls-4,.El_Salvador_svg__cls-5,.El_Salvador_svg__cls-59,.El_Salvador_svg__cls-6,.El_Salvador_svg__cls-7,.El_Salvador_svg__cls-8{stroke:#000}.El_Salvador_svg__cls-3{stroke-width:.3px}.El_Salvador_svg__cls-178,.El_Salvador_svg__cls-4{fill:#e60000}.El_Salvador_svg__cls-10,.El_Salvador_svg__cls-11,.El_Salvador_svg__cls-13,.El_Salvador_svg__cls-133,.El_Salvador_svg__cls-137,.El_Salvador_svg__cls-139,.El_Salvador_svg__cls-14,.El_Salvador_svg__cls-140,.El_Salvador_svg__cls-150,.El_Salvador_svg__cls-16,.El_Salvador_svg__cls-17,.El_Salvador_svg__cls-171,.El_Salvador_svg__cls-18,.El_Salvador_svg__cls-181,.El_Salvador_svg__cls-183,.El_Salvador_svg__cls-19,.El_Salvador_svg__cls-20,.El_Salvador_svg__cls-21,.El_Salvador_svg__cls-22,.El_Salvador_svg__cls-23,.El_Salvador_svg__cls-24,.El_Salvador_svg__cls-25,.El_Salvador_svg__cls-26,.El_Salvador_svg__cls-27,.El_Salvador_svg__cls-28,.El_Salvador_svg__cls-29,.El_Salvador_svg__cls-30,.El_Salvador_svg__cls-31,.El_Salvador_svg__cls-32,.El_Salvador_svg__cls-33,.El_Salvador_svg__cls-34,.El_Salvador_svg__cls-35,.El_Salvador_svg__cls-36,.El_Salvador_svg__cls-37,.El_Salvador_svg__cls-38,.El_Salvador_svg__cls-39,.El_Salvador_svg__cls-4,.El_Salvador_svg__cls-40,.El_Salvador_svg__cls-41,.El_Salvador_svg__cls-42,.El_Salvador_svg__cls-43,.El_Salvador_svg__cls-44,.El_Salvador_svg__cls-45,.El_Salvador_svg__cls-46,.El_Salvador_svg__cls-47,.El_Salvador_svg__cls-48,.El_Salvador_svg__cls-49,.El_Salvador_svg__cls-5,.El_Salvador_svg__cls-50,.El_Salvador_svg__cls-51,.El_Salvador_svg__cls-52,.El_Salvador_svg__cls-53,.El_Salvador_svg__cls-54,.El_Salvador_svg__cls-55,.El_Salvador_svg__cls-56,.El_Salvador_svg__cls-57,.El_Salvador_svg__cls-58,.El_Salvador_svg__cls-59,.El_Salvador_svg__cls-6,.El_Salvador_svg__cls-7,.El_Salvador_svg__cls-8{stroke-miterlimit:2.61}.El_Salvador_svg__cls-14,.El_Salvador_svg__cls-4,.El_Salvador_svg__cls-7{stroke-width:.13px}.El_Salvador_svg__cls-13,.El_Salvador_svg__cls-133,.El_Salvador_svg__cls-137,.El_Salvador_svg__cls-139,.El_Salvador_svg__cls-140,.El_Salvador_svg__cls-150,.El_Salvador_svg__cls-16,.El_Salvador_svg__cls-17,.El_Salvador_svg__cls-171,.El_Salvador_svg__cls-177,.El_Salvador_svg__cls-18,.El_Salvador_svg__cls-181,.El_Salvador_svg__cls-183,.El_Salvador_svg__cls-186,.El_Salvador_svg__cls-19,.El_Salvador_svg__cls-20,.El_Salvador_svg__cls-21,.El_Salvador_svg__cls-22,.El_Salvador_svg__cls-23,.El_Salvador_svg__cls-24,.El_Salvador_svg__cls-25,.El_Salvador_svg__cls-26,.El_Salvador_svg__cls-27,.El_Salvador_svg__cls-28,.El_Salvador_svg__cls-29,.El_Salvador_svg__cls-30,.El_Salvador_svg__cls-31,.El_Salvador_svg__cls-32,.El_Salvador_svg__cls-33,.El_Salvador_svg__cls-34,.El_Salvador_svg__cls-35,.El_Salvador_svg__cls-36,.El_Salvador_svg__cls-37,.El_Salvador_svg__cls-38,.El_Salvador_svg__cls-39,.El_Salvador_svg__cls-40,.El_Salvador_svg__cls-41,.El_Salvador_svg__cls-42,.El_Salvador_svg__cls-43,.El_Salvador_svg__cls-44,.El_Salvador_svg__cls-45,.El_Salvador_svg__cls-46,.El_Salvador_svg__cls-47,.El_Salvador_svg__cls-48,.El_Salvador_svg__cls-49,.El_Salvador_svg__cls-5,.El_Salvador_svg__cls-50,.El_Salvador_svg__cls-51,.El_Salvador_svg__cls-52,.El_Salvador_svg__cls-53,.El_Salvador_svg__cls-54,.El_Salvador_svg__cls-55,.El_Salvador_svg__cls-56,.El_Salvador_svg__cls-57,.El_Salvador_svg__cls-58,.El_Salvador_svg__cls-7,.El_Salvador_svg__cls-8{fill:none}.El_Salvador_svg__cls-5,.El_Salvador_svg__cls-6{stroke-width:.26px}.El_Salvador_svg__cls-6{fill:#1f601a}.El_Salvador_svg__cls-59,.El_Salvador_svg__cls-8{stroke-width:.13px}.El_Salvador_svg__cls-10,.El_Salvador_svg__cls-9{fill:#00209f}.El_Salvador_svg__cls-10,.El_Salvador_svg__cls-11,.El_Salvador_svg__cls-13,.El_Salvador_svg__cls-133,.El_Salvador_svg__cls-137,.El_Salvador_svg__cls-139,.El_Salvador_svg__cls-140,.El_Salvador_svg__cls-150,.El_Salvador_svg__cls-16,.El_Salvador_svg__cls-17,.El_Salvador_svg__cls-171,.El_Salvador_svg__cls-18,.El_Salvador_svg__cls-19,.El_Salvador_svg__cls-20,.El_Salvador_svg__cls-21,.El_Salvador_svg__cls-22,.El_Salvador_svg__cls-23,.El_Salvador_svg__cls-24,.El_Salvador_svg__cls-25,.El_Salvador_svg__cls-26,.El_Salvador_svg__cls-27,.El_Salvador_svg__cls-28,.El_Salvador_svg__cls-29,.El_Salvador_svg__cls-30,.El_Salvador_svg__cls-31,.El_Salvador_svg__cls-32,.El_Salvador_svg__cls-33,.El_Salvador_svg__cls-34,.El_Salvador_svg__cls-35,.El_Salvador_svg__cls-36,.El_Salvador_svg__cls-37,.El_Salvador_svg__cls-38,.El_Salvador_svg__cls-39,.El_Salvador_svg__cls-40,.El_Salvador_svg__cls-41,.El_Salvador_svg__cls-42,.El_Salvador_svg__cls-43,.El_Salvador_svg__cls-44,.El_Salvador_svg__cls-45,.El_Salvador_svg__cls-46,.El_Salvador_svg__cls-47,.El_Salvador_svg__cls-48,.El_Salvador_svg__cls-49,.El_Salvador_svg__cls-50,.El_Salvador_svg__cls-51,.El_Salvador_svg__cls-52,.El_Salvador_svg__cls-53,.El_Salvador_svg__cls-54,.El_Salvador_svg__cls-55,.El_Salvador_svg__cls-56,.El_Salvador_svg__cls-57{stroke-width:.17px}.El_Salvador_svg__cls-11{fill:#011322}.El_Salvador_svg__cls-12{fill:#011d33}.El_Salvador_svg__cls-14,.El_Salvador_svg__cls-15,.El_Salvador_svg__cls-185,.El_Salvador_svg__cls-59{fill:#fc0}.El_Salvador_svg__cls-16{stroke:#011322}.El_Salvador_svg__cls-17{stroke:#011d33}.El_Salvador_svg__cls-18,.El_Salvador_svg__cls-58{stroke:#022743}.El_Salvador_svg__cls-19{stroke:#033054}.El_Salvador_svg__cls-20{stroke:#053a65}.El_Salvador_svg__cls-21{stroke:#00209f}.El_Salvador_svg__cls-22{stroke:#022847}.El_Salvador_svg__cls-23{stroke:#032b4c}.El_Salvador_svg__cls-24{stroke:#032d4f}.El_Salvador_svg__cls-25{stroke:#032f53}.El_Salvador_svg__cls-26{stroke:#043258}.El_Salvador_svg__cls-27{stroke:#04345b}.El_Salvador_svg__cls-28{stroke:#04365e}.El_Salvador_svg__cls-29{stroke:#043862}.El_Salvador_svg__cls-30{stroke:#053b67}.El_Salvador_svg__cls-31{stroke:#053d6a}.El_Salvador_svg__cls-32{stroke:#053f6e}.El_Salvador_svg__cls-33{stroke:#064172}.El_Salvador_svg__cls-34{stroke:#022a49}.El_Salvador_svg__cls-35{stroke:#043359}.El_Salvador_svg__cls-36{stroke:#043760}.El_Salvador_svg__cls-37{stroke:#064171}.El_Salvador_svg__cls-38{stroke:#053e6c}.El_Salvador_svg__cls-39{stroke:#04355c}.El_Salvador_svg__cls-40{stroke:#032c4d}.El_Salvador_svg__cls-41{stroke:#011e34}.El_Salvador_svg__cls-42{stroke:#022037}.El_Salvador_svg__cls-43{stroke:#022139}.El_Salvador_svg__cls-44{stroke:#02223b}.El_Salvador_svg__cls-45{stroke:#02233d}.El_Salvador_svg__cls-46{stroke:#022540}.El_Salvador_svg__cls-47{stroke:#022541}.El_Salvador_svg__cls-48{stroke:#032a4a}.El_Salvador_svg__cls-49{stroke:#032e50}.El_Salvador_svg__cls-50{stroke:#033156}.El_Salvador_svg__cls-51{stroke:#053c68}.El_Salvador_svg__cls-52{stroke:#053f6f}.El_Salvador_svg__cls-53{stroke:#064374}.El_Salvador_svg__cls-54{stroke:#011f36}.El_Salvador_svg__cls-55{stroke:#02233e}.El_Salvador_svg__cls-56{stroke:#022845}.El_Salvador_svg__cls-57{stroke:#043963}.El_Salvador_svg__cls-58{stroke-width:.17px}.El_Salvador_svg__cls-181{stroke:#fff}.El_Salvador_svg__cls-133{stroke:#feede3}.El_Salvador_svg__cls-137{stroke:#fee0cc}.El_Salvador_svg__cls-139{stroke:#fdcdaa}.El_Salvador_svg__cls-140{stroke:#fdc59e}.El_Salvador_svg__cls-150{stroke:#fdd9bf}.El_Salvador_svg__cls-171{stroke:#fdb98a}.El_Salvador_svg__cls-177,.El_Salvador_svg__cls-186{stroke-width:.13px}.El_Salvador_svg__cls-181{stroke-width:.35px}.El_Salvador_svg__cls-183{stroke-width:.3px}.El_Salvador_svg__cls-185{stroke-width:.26px}.El_Salvador_svg__cls-186{stroke:#00633b}"
        }
      </style>
    </defs>
    <g id="El_Salvador_svg__El_Salvador" data-name="El Salvador">
      <path
        d="M.25-.34h1279.5v720.68H.25z"
        style={{
          fill: "#0f47af",
        }}
      />
      <path
        d="M.25 239.89h1279.5v240.23H.25z"
        className="El_Salvador_svg__cls-2"
      />
      <path
        d="M636.47 424.89c1.82 0 3.79 0 12.11-2s15.17-7 16.78-7.75a9.4 9.4 0 0 1 3.95-.52 10.05 10.05 0 0 0-7-3.27c-3.64 0-2.19 0-5.25 1.3s-9.46 5.14-20.27 5.14h-.21c-10.81 0-17.56-3.9-20.63-5.14s-1.66-1.3-5.25-1.3a10.23 10.23 0 0 0-7.07 3.27 9.6 9.6 0 0 1 4 .52c1.61.73 8.47 5.77 16.79 7.75s10.29 2 12.06 2Z"
        className="El_Salvador_svg__cls-3"
      />
      <path
        d="M604.56 417.81c.88-.52-.21-2-.21-2l3.27-.73a9.6 9.6 0 0 0-4-.52c-.62.52-.52 1.15-.62 1.61a2 2 0 0 0 .31 1.56c.31.31 1.25.05 1.25.05Z"
        className="El_Salvador_svg__cls-3"
      />
      <path
        d="m607.61 415.12-3.27.73s1.09 1.45.2 2l5.77-1.09a31 31 0 0 0-2.7-1.61ZM668.42 417.81c-.88-.52.16-2 .16-2l-3.22-.73a9.4 9.4 0 0 1 3.95-.52c.67.52.57 1.15.67 1.61a2.07 2.07 0 0 1-.31 1.56c-.36.31-1.25.05-1.25.05Z"
        className="El_Salvador_svg__cls-3"
      />
      <path
        d="m665.36 415.12 3.22.73s-1 1.45-.16 2l-5.76-1.09a31 31 0 0 1 2.7-1.61Z"
        className="El_Salvador_svg__cls-3"
      />
      <path d="m613.51 412.87-1.46 3.63.67.26a1.94 1.94 0 1 0 1.5-3.56zm.3.75h.11c.83.37 1.34 1 1 2a1.35 1.35 0 0 1-2 .6h-.15l1.09-2.54ZM615.15 417.87l1.61-3.58.42.16-1.61 3.58zM618.74 415.23a2.13 2.13 0 0 0-1.83 1.31 2 2 0 0 0 1 2.62 2 2 0 0 0 2.59-1.16 2.07 2.07 0 0 0-1-2.65 1.65 1.65 0 0 0-.75-.15Zm0 .6a1.3 1.3 0 0 1 .57.11 1.35 1.35 0 0 1 .67 1.87 1.41 1.41 0 0 1-1.83.79 1.39 1.39 0 0 1-.6-1.88 1.33 1.33 0 0 1 1.19-.89M623.05 417.72a.67.67 0 0 0-.41-.57.61.61 0 0 0-.78.31.71.71 0 0 0 .26.73l.26.2a1.14 1.14 0 0 1 .41 1.41 1.22 1.22 0 0 1-1.56.73 1.24 1.24 0 0 1-.67-1.46l.46.1a.74.74 0 0 0 .42.94.76.76 0 0 0 .94-.47c.15-.41-.11-.67-.37-.93l-.21-.21a1 1 0 0 1-.36-1.2 1.06 1.06 0 0 1 2 .31l-.42.11ZM625.91 417.92l-.62 2.18c-.16.63-.16 1.25.52 1.46s1-.31 1.25-.93l.62-2.24.41.16-.67 2.34a1.36 1.36 0 1 1-2.6-.73l.68-2.39zM631.16 423.33l-2.16-3.58-.58 2.85-.41-.05.78-4.05 2.11 3.5.57-2.8h.42ZM632.15 423.23l.46-3.85.42.05-.47 3.9ZM635.48 419.54a2 2 0 1 0 1.87 2.09 2 2 0 0 0-1.87-2.09m-.08.56a1.4 1.4 0 0 1 1.31 1.53 1.37 1.37 0 0 1-1.38 1.39 1.48 1.48 0 0 1-1.31-1.5 1.42 1.42 0 0 1 1.38-1.42M641.34 423.44l-3-2.81.21 2.91h-.47l-.31-4.05 3 2.8-.2-2.86.46-.05ZM643.79 422.86l-.73-3.84h.47l.67 3.37 1.1-.2.1.46ZM645.87 422.45l-.89-3.8.47-.1.88 3.79ZM647.08 418.15a3 3 0 0 0-.48.07l-.42.15 1.05 3.75.83-.19a1.18 1.18 0 0 0 .93-1.46.92.92 0 0 0-1-.71 1 1 0 0 0 .19-.86 1 1 0 0 0-1.13-.75Zm.08.49c.25-.05.48.05.6.44s-.16.61-.53.72h-.11l-.37-1.12h.15a.8.8 0 0 1 .26-.07Zm.6 1.57c.3 0 .63 0 .71.41s-.2.68-.56.79l-.34.11-.3-1.2h.22a3 3 0 0 1 .27-.11M651.12 418.45l.15.41-1.4.47.47 1.4 1.45-.52.16.47-1.87.63-1.3-3.69 1.92-.68.1.41-1.45.52.36 1ZM652.77 416.32a1.55 1.55 0 0 0-1 .18l-.52.23 1.46 3.63.41-.15-.56-1.57h.15l1.6 1.09.57-.19-1.76-1.16a1.06 1.06 0 0 0 .41-1.35 1 1 0 0 0-.79-.67Zm-.11.48a.6.6 0 0 1 .49.41c.2.52-.22.78-.64.94h-.07L652 417h.11a1.3 1.3 0 0 1 .6-.15ZM653.51 415.8l2-.89.2.37-.83.36 1.46 3.17-.34.19-1.45-3.17-.78.36ZM657.07 413.92l.26 4.46.49-.27-.07-1 1.53-.78.82.67.42-.26-3.45-2.81Zm.53 1.05 1.19 1-1.08.56-.11-1.53ZM660.79 412.35a2.35 2.35 0 0 0-1.16.38l-.68.37 2.06 3.37.6-.34a1.92 1.92 0 0 0 .82-2.81 1.76 1.76 0 0 0-1.64-1Zm.18.6a1.31 1.31 0 0 1 1 .67c.52.89 0 1.56-.74 2h-.08l-1.42-2.32.11-.11A2 2 0 0 1 661 413Z" />
      <g id="El_Salvador_svg__g3">
        <path
          d="M600.6 427.07a1.06 1.06 0 0 0 1.09-1.09 1.05 1.05 0 0 0-1.09-1 1.07 1.07 0 1 0 0 2.13ZM594.47 434.66a1.07 1.07 0 0 0 1.09-1.1 1.1 1.1 0 0 0-1.09-1.09 1.13 1.13 0 0 0-1.09 1.09 1.1 1.1 0 0 0 1.09 1.1ZM580.23 410.85a1.13 1.13 0 0 0 1.09-1.09 1.1 1.1 0 0 0-1.09-1.09 1.06 1.06 0 0 0-1.09 1.09 1.09 1.09 0 0 0 1.09 1.09ZM571.39 415.27a1.21 1.21 0 0 0 1.19-1.19 1.24 1.24 0 0 0-1.19-1.2 1.21 1.21 0 0 0-1.2 1.2 1.18 1.18 0 0 0 1.2 1.19ZM569.78 388.56a1.21 1.21 0 0 0 1.2-1.19 1.24 1.24 0 0 0-1.2-1.2 1.21 1.21 0 0 0-1.19 1.2 1.17 1.17 0 0 0 1.19 1.19ZM562.34 390.74a1.2 1.2 0 1 0 0-2.39 1.2 1.2 0 0 0 0 2.39ZM566.14 366.94a1.21 1.21 0 0 0 1.2-1.19 1.2 1.2 0 1 0-2.39 0 1.21 1.21 0 0 0 1.19 1.19ZM559.49 345.06a1.17 1.17 0 1 0 0-2.34 1.17 1.17 0 1 0 0 2.34ZM568 347.24a1.18 1.18 0 0 0 1.2-1.2 1.2 1.2 0 0 0-2.39 0 1.18 1.18 0 0 0 1.19 1.2ZM576.27 329a1.17 1.17 0 1 0 0-2.34 1.16 1.16 0 0 0-1.19 1.14 1.18 1.18 0 0 0 1.19 1.2ZM569.94 324a1.17 1.17 0 0 0 1.19-1.19 1.2 1.2 0 1 0-2.39 0 1.18 1.18 0 0 0 1.2 1.19ZM582.56 311.7a1.2 1.2 0 1 0-1.19-1.2 1.18 1.18 0 0 0 1.19 1.2ZM556.79 367.1a1.15 1.15 0 1 0-1.15-1.15 1.17 1.17 0 0 0 1.15 1.15Z"
          className="El_Salvador_svg__cls-4"
        />
        <path
          d="M601.63 431.54a26 26 0 0 1-.73-4.68l.94-.72M600.18 433a28 28 0 0 0-4.47.52 2.9 2.9 0 0 1-.36.94M579.29 415.85s-.2-4.52.73-4.89a3.6 3.6 0 0 0 1.4-1.09M575.86 414.39s-2.55-.37-3.28 0a1.35 1.35 0 0 1-.73.93M571 387.88l-.88.52c-.94.36-2.7 4.73-2.7 4.73s-2.92-2.19-4.16-2.39h-1.3M556.16 366.57s.73.73 1.46.36c0 0 3.58 2.34 3.79 3.28 0 0 3.8-3.79 4.52-3.43 0 0 .37.52 1.09-.21M560.16 344.39a3.3 3.3 0 0 0 1 .88s1.67 2.39 1.67 4.16c0 0 3.06-2.71 4-2.5a2.77 2.77 0 0 0 1.81 0M569 323.65s.73.88 1.25.16c0 0 2.18 2.7.88 4.73 0 0 3.07-.73 4-.21a.89.89 0 0 0 1.45.52"
          className="El_Salvador_svg__cls-5"
        />
        <path
          d="M657.76 454.83s-4.67-.37-5.4-.37-2.34-3.22-3.07-3.79-13-6.5-20.94-7.74-20.17-6-22.71-7.23c-13.21-6.34-28-18.08-31.24-22.92-3.43-5-7.07-16.79-8.68-23.07-.73-2.92-4.68-14.82-4.68-22.92a100.6 100.6 0 0 1 2.55-23.29c1.4-6.13 11.95-24.11 18.4-32.12 0 0-14.5 22.45-17 31a97 97 0 0 0-3.07 25.73c.16 5 4.37 23.49 10.5 37.05 4.89 10.87 9.15 12.17 16.79 18.25a109.7 109.7 0 0 0 16.22 10.29c5.76 2.86 18 6.49 21.3 7s19.65 5.41 21.83 6.5 7.75 6 9.2 7.59Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M575.5 413c.36-1.67.52-2.91 1.09-3.43a14.1 14.1 0 0 0 2.7-4.16 9.8 9.8 0 0 0 0-3.28 30 30 0 0 1 .52-3.22s-.88-3.07-1.61-3.64a18.4 18.4 0 0 1-2.91-3.79 3.52 3.52 0 0 1-.37 2.18 7.9 7.9 0 0 0-.72 3.59c0 1.09.36 3.64 0 4.88-.37 1.41-.89 2.55-.52 4.16.31 1.3 1.82 6.71 1.82 6.71Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M574.92 411.17s-4.1-5.25-4.1-7.44a7.8 7.8 0 0 0-.73-4 5.55 5.55 0 0 1-.57-6.65 9 9 0 0 0 1.61-2.91c.73-2 2.18-2 2.39-4a38 38 0 0 1 .68 4.31 11 11 0 0 1-.32 3.8c-.2 1.09.52 2.34.52 3.95s-.2 2.29-.2 3.27c0 .52-.68 7.38.72 9.57ZM621.18 439.34s-3.48-.37-4.78-.57a23.2 23.2 0 0 1-4.26-1.09 13.6 13.6 0 0 1-4.83-3.33c-3.33-3.54-3-5.41-3.59-5.56-1.2-.21 1.87-.52 3.33-.31a9.2 9.2 0 0 1 4.67 2.44 44 44 0 0 0 4.16 3.17 7.8 7.8 0 0 1 2 1.82 8.8 8.8 0 0 0 3.27 3.43Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M626 441.88s-8.73-3.9-9.61-4.63a30 30 0 0 1-3.33-3.06c-.88-1-4.57-2.86-5.2-4.06-.41-.83-2.7-4-4.05-6.49-.68-1.3 5.82.41 5.82.41 5.3 2.13 2.91.63 5.82 2.81a11.6 11.6 0 0 1 3.43 3.48c.68 1.56 1.46 4.26 2.24 5.67a24.4 24.4 0 0 0 4.88 5.87Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M630.69 443s-7.22-1.87-10.5-6.34c-2.34-3.07-2.34-2.13-3.32-3.17a27 27 0 0 1-4.63-5.35c.16.26-2.08-7.07-2-8 .05-.51 2.75.37 4.93 1.3 1.88.78 3 2.29 4.58 3.28 1.92 1.25 2.18 4.36 3.06 5.82a7.7 7.7 0 0 1 1.41 4.26c0 1.61.88 2.13 1.4 3.48.63 1.61 2.55 1.35 5 4.68ZM619.16 440.58s-6.14-2.7-7-2.91-1.3-.72-2.55-1.09c-1-.26-2-1-4.52-.52-1.09.26-5.56 1.25-6.65.73s1.61 3.07 2.86 3.79a9.5 9.5 0 0 0 5.25.89c1.82-.16 4.31 0 5.25 0a7 7 0 0 0 2.7-.16 8.5 8.5 0 0 1 4.68-.73Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M623.31 440.58s-6.86-1.71-8-1.71a46 46 0 0 0-5.77.47c-1.3.21-5.4-.21-6.6.41s-6.7 1.35-8.16 1 2.91 3.9 4.63 4.37c5.56 1.56 3.89 1.35 7.48.41a51 51 0 0 1 6.39-.88c1.09-.21.89-.83 2.34-1.46a22.7 22.7 0 0 1 7.69-2.6Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M628.92 443.45s-6.86-2.86-12.21-1.41a30 30 0 0 1-5.05 1.15c-1.71.26-3.17-.63-6 .52-1.4.57-7.38 3-9.05 2.91-1.5-.11 4.79 4 6.5 3.74 5.51-.78 10.71 1.09 13.25.05 2.29-.88 3.64-1.51 4.79-1.87s1.76-1.46 2.49-2 1.2-2 5.25-3.11ZM592.29 427.7s-3.95-4.37-4.73-4.94S585 420.84 584 420c-.83-.73-1.66-2.34-4.21-3-1.09-.26-3.74-.78-4.52-1.72s.16 3.49 1 4.68a9.73 9.73 0 0 0 4.31 3.07 40 40 0 0 1 4.68 2.28 7.8 7.8 0 0 0 2.55 1 9 9 0 0 1 4.52 1.41Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M596 429.52s-6.71-4.73-7.75-5.25-3-1.15-4.21-1.56-4.67-2.81-6-2.81-3.89-.1-5-1-.15 3.28 1.15 4.47c4.31 3.85 1.35 2.71 4.93 3.43 2.19.47 5.1 1.67 6.14 2s1.19-.36 2.75-.26a22.6 22.6 0 0 1 8.06 1Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M597.63 430.76a23 23 0 0 0-8.21-2.75 33 33 0 0 1-5-1.2c-1.66-.52-2-.52-5.09-.67-1.51-.11-7.43 1.81-8.84 1s1.46 1.82 3.12 2.45c2.39.88 2.08 2.44 4.68 3.27 2.75.88 5.66 2 7.28 1.67a22.4 22.4 0 0 1 3.95-1c1.71-.21 4.72-2.71 8.1-2.76ZM598.21 429.36s1.35-6.55.21-8.11a6.13 6.13 0 0 1-1.46-3.43 13.1 13.1 0 0 0-2-5.19c-.72-.94-2.18-5.1-1.81-6.14 0 0-3.8 3.75-3.59 6.14a8.2 8.2 0 0 1 0 2.86c-.21 1.09.88 4.67 1.61 5.76s.36 4.37 1.09 5 5.05 3.64 5.93 3.07Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M597.63 430.76a15.2 15.2 0 0 0-3.58-2.65c-1.25-.52-6.29-2-6.66-3.22s-4.52-5.61-4.67-6.71c-.16-.83-.94-2.54-.73-3.43a20.8 20.8 0 0 1 1.09-4.31c.52-1.3 1.77-4.31 3.07-4.89l1.4 4.68a10.7 10.7 0 0 0 1.3 3.43 21 21 0 0 1 2.49 5.46c.21 1.25 1.09 5.4 1.3 6.29s3.54 4.57 5 5.35ZM575.5 413c.15.93-2.71-.94-4.16-.94s-5.77.57-6.86-.52-2.7-3.07-3.28-3.43a19.5 19.5 0 0 1-3.06-5.4c-.52-1.82-4.32-5.1-4.84-5.46 0 0 5.2-1 8.48 1.09s3.43 1.66 4.15 2 6.29 5.09 6.66 6.86 2.7 4.88 2.91 5.82Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M575.5 413s-4.68-3.28-5.77-3.12-6.19-3.59-6.5-5.93c-.21-1.24-2.65-3-3.06-3.79-1.3-2.18-2-7-3.8-8.32 0 0 4.89 1.25 6.13 1.46 2.34.36 4.32.73 5.2 2.7s1.67 3.64 2.39 3.8 1.77 2.7 2.13 5.24 3.28 8 3.28 8ZM566.66 388.41c.78 1.24.72-7.23 1-8.11a13.1 13.1 0 0 1 2-3.43c.73-.73.73-3.22 1.09-3.95a19.7 19.7 0 0 0-.36-6.86 15.6 15.6 0 0 0-2.18 2c-.73.89-2 1.25-2.34 2.34s-1.09 1.09-1.61 2.19a6.68 6.68 0 0 0-.73 4.31 10.2 10.2 0 0 1 .16 3.27 28.3 28.3 0 0 0 2.91 8.27Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M566.81 389.13s-.36-2.34.57-3.23 1.77-.93 2.13-1.45.21-1.25.58-2a14 14 0 0 0 1.24-2.55c.37-2 1.46-4.15.52-6.28a17 17 0 0 0-2.49 1c-.57.36-2.19 1.82-2.34 3.27a4.64 4.64 0 0 1-.94 2.7c-.52.89-1.24 3.59-.36 5.25a8.8 8.8 0 0 1 1.09 3.23ZM561.57 361.54s-.37-5.25 1.09-6.86 1.82-4.68 5-6.34a9 9 0 0 0 0 2.18c.21.88.57 3.43 0 4.31s-2.34 2.55-2.34 3.28a4.86 4.86 0 0 1-2.13 2.91c-.94.31-1.66.52-1.66.52Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M561.57 364.39s0-3.74 1.09-4.83a25 25 0 0 0 2.18-2.34c.52-.73 1.09-2.55 2.34-3.28s3.43-2.54 3.64-3.22c0 0 .52 4.47-.73 6.86s-1.3 3.59-2.7 4.11a6.4 6.4 0 0 0-2.18 1.3 4.8 4.8 0 0 1-2.19.88 2.9 2.9 0 0 0-1.45.52ZM565.72 389c.21 1 .94-2.34-2.86-2.34a12.3 12.3 0 0 1-8.16-2.75c-1.24-1.25-2-2.14-2.49-2.71a10.6 10.6 0 0 1-2.18-3.79c-.16-1-1.25-5-1.09-5.77a8.2 8.2 0 0 1 2.91 1.09c.88.73 2.54.73 3.43 1.3s1.61 2 2.18 2.5 2.13.57 2.86 1.61a18 18 0 0 1 2.18 4.52c.16 1.09 1.46 2.18 2.34 2.7s.73 2.71.88 3.64Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M565.36 387.52s-2.49-3.07-3.79-3.07-4.47-3.27-4.68-4.67-1.25-4.16-2-4.73a4.34 4.34 0 0 1-1.82-3.95c.2-2.19.2-5.77.2-5.77s.73 2.18 1.77 2.7 3.07 1.25 3.43 2 1.82.73 2.39 2.91a8 8 0 0 0 .89 2.7 12 12 0 0 1 1.61 3.07c.36 1.45 2.34 5.19 2 8.83ZM561.63 367.61c-.11 1 1.45-1.92-2-3s-5.87-3.22-6.65-4.73-1.2-2.49-1.56-3.12a10.7 10.7 0 0 1-.88-4.05c.1-1 .26-4.94.62-5.56a7.5 7.5 0 0 1 2.29 1.76c.62.94 2.13 1.41 2.8 2.13s.89 2.24 1.25 2.92 1.82 1.09 2.18 2.23a15.2 15.2 0 0 1 .68 4.73 5 5 0 0 0 1.4 3.12c.68.73-.1 2.65-.15 3.53Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M561.67 366.16s-1.45-3.48-2.6-3.79-3-3.33-3.11-4.68c-.16-1.56-.37-4.16-.89-4.83a5.74 5.74 0 0 1-.72-4.83c.78-1.93 2-4.47 2-4.47s1 1.61 1.61 2.6c.94 1.87 1.87 2 2 2.75s1.25 1.25 1.66 2.75c.58 2 0 1.93.06 2.71a9.5 9.5 0 0 1 .62 3.22c0 1.4.73 5.4-.63 8.57ZM564.48 344.39c.15-.52 1.24-1.09 2.54-1.46s3.22-3.22 4.11-3.95 1.3-1.92 2.39-2.54 1.77-2.86 2.13-5.05c0 0-3.07.73-3.95.89a8.5 8.5 0 0 0-3.43 2.18c-.73.88-1.46 2.34-2.18 2.7s-1.62 2.55-1.62 4v3.23Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M564.32 342.77s-.21-2.13-.21-3.07-.67-4 .89-6.34c1.09-1.61 5.09-4.68 6.13-4.83a16 16 0 0 1 .57 3.74c-.21.93-1.14 4.52-2 4.88s-2.92 4.68-5.41 5.62Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M563.39 344.39c-.47.78-.16-2.71-1.25-3.59s-1.25-2.18-1.25-3.64a14 14 0 0 1 .52-3.43c.16-.88 2.91-4.68 2.7-5.77 0 0 1.56 3.54 2 4.52.57 1.25-.36 2.55-.16 3.59s1 3.07.37 4.16c-.57.93-2.19 2.91-2.91 4.16ZM572.94 325.78s.21-.52 1.82-.52 4-.15 4.68-.88a13.5 13.5 0 0 1 2.7-2 6.15 6.15 0 0 0 2.19-2.7c.15-.73 1.45-2.13 2-2.13a12.9 12.9 0 0 0-4.15.36c-2.13.52-5.2 1.61-5.93 3.07s-3.28 4.83-3.28 4.83Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M573.52 325.41c.42 1.25 3.43-1.24 4.11-2.13l1.82-2.34a35 35 0 0 0 2.18-2.91c1.09-2 .83-5.56.36-5.25a35 35 0 0 1-3.06 1.67 2.83 2.83 0 0 0-2 1.4 8.9 8.9 0 0 1-1.3 2.75c-.52.52-3.79 2.34-2.13 6.81Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M572.43 325.41a37 37 0 0 0 3.43-2.7c1.09-1 .52-2.49 1.09-3.22s1.77-2.34 1.4-3.43-1-4.16-1-4.16-1.3 1.25-2.19 2.18a5.34 5.34 0 0 0-1.45 2.71 30 30 0 0 1-1.46 2.7c-.36.88 0 2.7.21 3.79a8 8 0 0 1 0 2.13Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M612.29 439.12s-11.9-.15-13-1.61M619.16 440.58s-7.75 2.14-11.9 1.62-6.14.36-7.07.36-5.41-1.82-5.41-1.82M627.1 443.45s-6 1.09-7.22 1.45-7.38 2.71-9.2 2.71c-1.46 0-5-.16-6 0a21 21 0 0 1-7.59-.52M604.56 429.21s4.52 2.7 5.24 3.58 4.68 4.16 5.41 4.16M604.56 423.59s7.74 6.7 9 7.59 8.88 8.31 9.77 9.4M610.83 420.72s6.14 4.89 6.86 6.86a20.2 20.2 0 0 0 2.55 4.32s2.55 5 3.43 5.77a38 38 0 0 0 4.89 4M575.86 416.21s6.44 5.46 8.21 6.5M573.16 419.63s6.5 4.52 9.36 5.62a47.2 47.2 0 0 0 11.53 2.86M596.6 430.65s-7.22-.36-8.47 0-6.86-.93-8.32-1.3-7.22-1.4-7.95-1.61M585.58 406.28s-.36 4 .21 5.61 3.07 6.29 2.86 7.38 1.45 6 2.91 6.86M593 407s-1.3 3.95-.73 5.25a16.6 16.6 0 0 1 1.4 5 15.1 15.1 0 0 0 1.3 4.52c.37.88-.2 3.95.73 4.83a27 27 0 0 1 2 2.55M554.39 397.81s5.77 2.18 6.5 3.59 1.76 1.82 2.34 2.54M575.65 392.41s1.46 5.77 1.09 7.22a29 29 0 0 0-.36 5.41c0 1.09-1.61 5.4-1.46 6.13M573.32 387.52s-.52 3.43-.73 4.88 0 3.8-.36 4.68-.89 5.77 0 7.95M557.47 392.41s4.68 3.95 5.77 5 5.92 6.29 6.13 7.59 3.59 5.19 4.68 6.13M549.52 372.19s4.67 4.68 5 5.77 2.34 2.86 3.27 3.43M571.5 374.16s-1.77 2.71-1.77 3.59a9.3 9.3 0 0 1-1.46 4.16c-.46.62-2 3.27-1.82 4.88M570.09 366.57s-.72 2.55-1.09 4.31a44 44 0 0 1-1.61 4.73c-.36 1.09-1.82 6.29-1.3 9.57M553.67 366.41a9.2 9.2 0 0 0 1.77 3.8c1.3 1.25 3.27 3.07 3.43 4.1s1.82 6.5 3.64 8.32a6.43 6.43 0 0 1 2 3.64M551.85 348a34 34 0 0 0 .88 4c.37.88 1.82 4.88 3.28 6.13M567.39 348.9a26 26 0 0 0-1.09 3.59c-.21 1.09-1.3 2.34-1.46 2.91s-.88 2.34-.88 2.34M570.61 351.39c-.16 1.09-2.18 4.37-2.34 4.89s-1.25 3.07-2.34 3.79-4.31 3.07-4.16 4M556.52 344.39s-.15 3.95.57 5.4a46 46 0 0 1 2 4.73 25.5 25.5 0 0 1 .52 4.11c.21 1.3.73 3.63 1.45 4.52M575.14 332.12s-2.6 3-3.8 4.16-5.77 6.13-6 7M570.82 329.41s-2.54 5.56-3.11 6.45a19.5 19.5 0 0 0-1 2.39M564.32 329.21s.16 4.37 0 5.46a9.3 9.3 0 0 0 0 3.43 38 38 0 0 1-.73 5.4M585.21 318a78 78 0 0 0-6.65 4.32"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="m581.79 313.51-3.95 5.77-.89 1.66"
          className="El_Salvador_svg__cls-8"
        />
        <path
          d="M577.32 313a27 27 0 0 0-1.46 4.31 41.3 41.3 0 0 1-2.7 6.71"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="M581.63 310.66s-.57 1.24 1.61.88"
          className="El_Salvador_svg__cls-5"
        />
      </g>
      <g id="El_Salvador_svg__g3-2" data-name="g3">
        <path
          d="M672.37 427.07a1.07 1.07 0 1 1 0-2.13 1.07 1.07 0 1 1 0 2.13ZM678.5 434.66a1.07 1.07 0 0 1-1.09-1.1 1.09 1.09 0 0 1 1.09-1.09 1.13 1.13 0 0 1 1.09 1.09 1.1 1.1 0 0 1-1.09 1.1ZM692.74 410.85a1.13 1.13 0 0 1-1.09-1.09 1.1 1.1 0 0 1 1.09-1.09 1.07 1.07 0 0 1 1.09 1.09 1.1 1.1 0 0 1-1.09 1.09ZM701.58 415.27a1.21 1.21 0 0 1-1.19-1.19 1.24 1.24 0 0 1 1.19-1.2 1.21 1.21 0 0 1 1.2 1.2 1.18 1.18 0 0 1-1.2 1.19ZM703.19 388.56a1.21 1.21 0 0 1-1.2-1.19 1.24 1.24 0 0 1 1.2-1.2 1.21 1.21 0 0 1 1.19 1.2 1.17 1.17 0 0 1-1.19 1.19ZM710.62 390.74a1.2 1.2 0 0 1 0-2.39 1.2 1.2 0 1 1 0 2.39ZM706.83 366.94a1.21 1.21 0 0 1-1.2-1.19 1.2 1.2 0 1 1 2.39 0 1.21 1.21 0 0 1-1.19 1.19ZM713.47 345.06a1.17 1.17 0 1 1 0-2.34 1.17 1.17 0 1 1 0 2.34ZM705 347.24a1.18 1.18 0 0 1-1.2-1.2 1.2 1.2 0 0 1 2.39 0 1.18 1.18 0 0 1-1.19 1.2ZM696.69 329a1.17 1.17 0 1 1 0-2.34 1.17 1.17 0 0 1 1.2 1.14 1.18 1.18 0 0 1-1.2 1.2ZM703 324a1.18 1.18 0 0 1-1.2-1.19 1.2 1.2 0 1 1 2.39 0A1.16 1.16 0 0 1 703 324ZM690.4 311.7a1.2 1.2 0 1 1 1.2-1.2 1.18 1.18 0 0 1-1.2 1.2ZM716.18 367.1a1.15 1.15 0 1 1 1.15-1.15 1.17 1.17 0 0 1-1.15 1.15Z"
          className="El_Salvador_svg__cls-4"
        />
        <path
          d="M671.33 431.54a25 25 0 0 0 .73-4.68l-.93-.72M672.78 433a28 28 0 0 1 4.47.52 2.8 2.8 0 0 0 .37.94M693.67 415.85s.21-4.52-.72-4.89a3.6 3.6 0 0 1-1.41-1.09M697.11 414.39s2.55-.37 3.28 0a1.35 1.35 0 0 0 .73.93M702 387.88l.88.52c.94.36 2.7 4.73 2.7 4.73s2.91-2.19 4.16-2.39H711M716.8 366.57s-.72.73-1.45.36c0 0-3.59 2.34-3.79 3.28 0 0-3.8-3.79-4.53-3.43 0 0-.36.52-1.09-.21M712.8 344.39a3.2 3.2 0 0 1-1 .88s-1.67 2.39-1.67 4.16c0 0-3.06-2.71-4-2.5a2.8 2.8 0 0 1-1.82 0M704 323.65s-.72.88-1.24.16c0 0-2.19 2.7-.89 4.73 0 0-3.06-.73-4-.21a.89.89 0 0 1-1.45.52"
          className="El_Salvador_svg__cls-5"
        />
        <path
          d="M615.2 454.83s4.68-.37 5.41-.37 2.34-3.22 3.07-3.79 13-6.5 20.94-7.74 20.17-6 22.71-7.23c13.2-6.34 28-18.08 31.24-22.92 3.43-5 7.07-16.79 8.68-23.07.73-2.92 4.68-14.82 4.68-22.92a101.2 101.2 0 0 0-2.55-23.29c-1.4-6.13-12-24.11-18.4-32.12 0 0 14.5 22.45 17 31a96.5 96.5 0 0 1 3.02 25.76c-.15 5-4.36 23.49-10.5 37.05-4.88 10.87-9.14 12.17-16.78 18.25a109.7 109.7 0 0 1-16.22 10.29c-5.77 2.86-18 6.49-21.31 7s-19.64 5.41-21.82 6.5-7.75 6-9.21 7.59Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M697.47 413c-.36-1.67-.52-2.91-1.09-3.43a14.1 14.1 0 0 1-2.7-4.16 9.5 9.5 0 0 1 0-3.28 30 30 0 0 0-.52-3.22s.88-3.07 1.61-3.64a18.4 18.4 0 0 0 2.91-3.79 3.44 3.44 0 0 0 .37 2.18 7.9 7.9 0 0 1 .72 3.59c0 1.09-.36 3.64 0 4.88.37 1.41.89 2.55.52 4.16-.31 1.3-1.82 6.71-1.82 6.71Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M698.05 411.17s4.1-5.25 4.1-7.44a7.8 7.8 0 0 1 .73-4 5.57 5.57 0 0 0 .57-6.65 9 9 0 0 1-1.61-2.91c-.73-2-2.18-2-2.39-4a38 38 0 0 0-.68 4.31 11.3 11.3 0 0 0 .31 3.8c.21 1.09-.51 2.34-.51 3.95s.2 2.29.2 3.27c0 .52.68 7.38-.72 9.57ZM651.79 439.34s3.48-.37 4.78-.57a23.7 23.7 0 0 0 4.26-1.09 13.6 13.6 0 0 0 4.83-3.33c3.33-3.54 3-5.41 3.59-5.56 1.19-.21-1.87-.52-3.33-.31a9.25 9.25 0 0 0-4.68 2.44 45 45 0 0 1-4.15 3.17 7.8 7.8 0 0 0-2 1.82 8.8 8.8 0 0 1-3.27 3.43Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M647 441.88s8.73-3.9 9.61-4.63a30 30 0 0 0 3.33-3.06c.88-1 4.57-2.86 5.2-4.06.41-.83 2.7-4 4.05-6.49.68-1.3-5.82.41-5.82.41-5.3 2.13-2.91.63-5.82 2.81a11.6 11.6 0 0 0-3.43 3.48c-.68 1.56-1.46 4.26-2.24 5.67a24.7 24.7 0 0 1-4.88 5.87Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M642.28 443s7.22-1.87 10.49-6.34c2.34-3.07 2.34-2.13 3.33-3.17 1.2-1.3 3.07-2.7 4.62-5.35-.15.26 2.08-7.07 2-8-.05-.51-2.75.37-4.94 1.3-1.87.78-3 2.29-4.57 3.28-1.92 1.25-2.18 4.36-3.07 5.82a7.7 7.7 0 0 0-1.4 4.26c0 1.61-.88 2.13-1.4 3.48-.63 1.61-2.55 1.35-5 4.68ZM653.81 440.58s6.13-2.7 7-2.91 1.3-.72 2.54-1.09c1-.26 2-1 4.53-.52 1.09.26 5.56 1.25 6.65.73s-1.61 3.07-2.86 3.79a9.5 9.5 0 0 1-5.25.89c-1.82-.16-4.31 0-5.25 0a7 7 0 0 1-2.7-.16 8.5 8.5 0 0 0-4.68-.73Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M649.65 440.58s6.87-1.71 8-1.71a46 46 0 0 1 5.77.47c1.3.21 5.4-.21 6.6.41s6.7 1.35 8.16 1-2.91 3.9-4.63 4.37c-5.56 1.56-3.9 1.35-7.48.41a51 51 0 0 0-6.4-.88c-1.09-.21-.88-.83-2.34-1.46a22.6 22.6 0 0 0-7.69-2.6Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M644.05 443.45s6.86-2.86 12.21-1.41a30 30 0 0 0 5 1.15c1.72.26 3.17-.63 6 .52 1.4.57 7.38 3 9 2.91 1.51-.11-4.78 4-6.49 3.74-5.51-.78-10.71 1.09-13.26.05-2.28-.88-3.64-1.51-4.78-1.87s-1.77-1.46-2.49-2-1.2-2-5.25-3.11ZM680.68 427.7s4-4.37 4.73-4.94S688 420.84 689 420c.84-.73 1.67-2.34 4.21-3 1.09-.26 3.75-.78 4.52-1.72s-.15 3.49-1 4.68a9.76 9.76 0 0 1-4.32 3.07 40 40 0 0 0-4.67 2.28 7.8 7.8 0 0 1-2.55 1 9 9 0 0 0-4.52 1.41Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M676.94 429.52s6.71-4.73 7.74-5.25 3-1.15 4.21-1.56 4.68-2.81 6-2.81 3.9-.1 5-1 .16 3.28-1.14 4.47c-4.31 3.85-1.35 2.71-4.94 3.43-2.18.47-5.09 1.67-6.13 2s-1.19-.36-2.75-.26a22.6 22.6 0 0 0-8.06 1Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M675.34 430.76a23 23 0 0 1 8.21-2.75 33 33 0 0 0 5-1.2c1.66-.52 2-.52 5.09-.67 1.51-.11 7.43 1.81 8.83 1s-1.45 1.82-3.11 2.45c-2.39.88-2.08 2.44-4.68 3.27-2.76.88-5.67 2-7.28 1.67a22.4 22.4 0 0 0-3.95-1c-1.71-.21-4.73-2.71-8.1-2.76ZM674.76 429.36s-1.35-6.55-.21-8.11a6.2 6.2 0 0 0 1.46-3.43 13.1 13.1 0 0 1 2-5.19c.73-.94 2.19-5.1 1.82-6.14 0 0 3.8 3.75 3.59 6.14a7.7 7.7 0 0 0 0 2.86c.21 1.09-.88 4.67-1.61 5.76s-.37 4.37-1.09 5-5.05 3.64-5.93 3.07Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M675.34 430.76a15.2 15.2 0 0 1 3.58-2.65c1.25-.52 6.29-2 6.66-3.22s4.52-5.61 4.67-6.71c.16-.83.94-2.54.73-3.43a21.4 21.4 0 0 0-1.09-4.31c-.52-1.3-1.77-4.31-3.07-4.89 0 0-1 3.44-1.4 4.68a10.7 10.7 0 0 1-1.3 3.43 21 21 0 0 0-2.49 5.46c-.21 1.25-1.1 5.4-1.3 6.29s-3.54 4.57-5 5.35ZM697.47 413c-.15.93 2.7-.94 4.16-.94s5.77.57 6.86-.52 2.7-3.07 3.27-3.43a19.5 19.5 0 0 0 3.07-5.4c.52-1.82 4.31-5.1 4.83-5.46 0 0-5.19-1-8.47 1.09s-3.43 1.66-4.15 2-6.29 5.09-6.66 6.86-2.7 4.88-2.91 5.82Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M697.47 413s4.68-3.28 5.77-3.12 6.19-3.59 6.5-5.93c.2-1.24 2.65-3 3.06-3.79 1.3-2.18 2-7 3.8-8.32 0 0-4.89 1.25-6.14 1.46-2.34.36-4.31.73-5.19 2.7s-1.67 3.64-2.39 3.8-1.77 2.7-2.14 5.24-3.27 8-3.27 8ZM706.31 388.41c-.78 1.24-.73-7.23-1-8.11a13.4 13.4 0 0 0-2-3.43c-.73-.73-.73-3.22-1.09-3.95a19.5 19.5 0 0 1 .36-6.86 16 16 0 0 1 2.18 2c.73.89 2 1.25 2.34 2.34s1.09 1.09 1.61 2.19a6.68 6.68 0 0 1 .73 4.31 9.9 9.9 0 0 0-.16 3.27 28.3 28.3 0 0 1-2.91 8.27Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M706.16 389.13s.36-2.34-.57-3.23-1.77-.93-2.14-1.45-.2-1.25-.57-2a14 14 0 0 1-1.24-2.55c-.37-2-1.46-4.15-.52-6.28a17 17 0 0 1 2.49 1A5.67 5.67 0 0 1 706 378a4.7 4.7 0 0 0 .93 2.7c.52.89 1.25 3.59.37 5.25a8.8 8.8 0 0 0-1.09 3.23ZM711.4 361.54s.37-5.25-1.09-6.86-1.82-4.68-5-6.34a9 9 0 0 1 0 2.18c-.21.88-.57 3.43 0 4.31s2.34 2.55 2.34 3.28a4.86 4.86 0 0 0 2.13 2.91c.94.31 1.66.52 1.66.52Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M711.4 364.39s0-3.74-1.09-4.83a25 25 0 0 1-2.18-2.34c-.52-.73-1.09-2.55-2.34-3.28s-3.43-2.54-3.64-3.22c0 0-.52 4.47.73 6.86s1.3 3.59 2.7 4.11a6.5 6.5 0 0 1 2.18 1.3 4.8 4.8 0 0 0 2.19.88 2.9 2.9 0 0 1 1.45.52ZM707.25 389c-.21 1-.94-2.34 2.85-2.34s6.87-1.46 8.16-2.75 2-2.14 2.5-2.71a10.8 10.8 0 0 0 2.18-3.79c.16-1 1.25-5 1.09-5.77a8.2 8.2 0 0 0-2.91 1.09c-.88.73-2.54.73-3.43 1.3s-1.61 2-2.18 2.5-2.13.57-2.86 1.61a18 18 0 0 0-2.18 4.52c-.16 1.09-1.46 2.18-2.34 2.7s-.73 2.71-.88 3.64Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M707.61 387.52s2.49-3.07 3.79-3.07 4.47-3.27 4.68-4.67 1.24-4.16 2-4.73a4.34 4.34 0 0 0 1.82-3.95c-.21-2.19-.21-5.77-.21-5.77s-.72 2.18-1.76 2.7-3.07 1.25-3.43 2-1.82.73-2.39 2.91a8 8 0 0 1-.89 2.7 11.7 11.7 0 0 0-1.61 3.07c-.36 1.45-2.34 5.19-2 8.83ZM711.34 367.61c.11 1-1.45-1.92 2-3s5.87-3.22 6.65-4.73 1.2-2.49 1.56-3.12a10.7 10.7 0 0 0 .88-4.05c-.1-1-.26-4.94-.62-5.56a7.5 7.5 0 0 0-2.31 1.85c-.62.94-2.13 1.41-2.8 2.13s-.89 2.24-1.25 2.92-1.82 1.09-2.19 2.23a15.5 15.5 0 0 0-.67 4.73 5 5 0 0 1-1.4 3.12c-.68.73.1 2.65.15 3.53Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M711.29 366.16s1.46-3.48 2.6-3.79 3-3.33 3.12-4.68c.16-1.56.36-4.16.88-4.83a5.73 5.73 0 0 0 .73-4.83c-.78-1.93-2-4.47-2-4.47s-1 1.61-1.61 2.6c-.94 1.87-1.88 2-2 2.75s-1.25 1.25-1.67 2.75c-.57 2 .06 1.93-.05 2.71a9.5 9.5 0 0 0-.62 3.22c.05 1.4-.73 5.4.62 8.57ZM708.49 344.39c-.15-.52-1.25-1.09-2.54-1.46s-3.23-3.22-4.11-3.95-1.3-1.92-2.39-2.54-1.77-2.86-2.13-5.05c0 0 3.06.73 3.95.89a8.5 8.5 0 0 1 3.43 2.18c.73.88 1.45 2.34 2.18 2.7s1.61 2.55 1.61 4z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M708.65 342.77s.2-2.13.2-3.07.68-4-.88-6.34c-1.09-1.61-5.09-4.68-6.13-4.83a16 16 0 0 0-.57 3.74c.2.93 1.14 4.52 2 4.88s2.91 4.68 5.41 5.62Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M709.58 344.39c.47.78.16-2.71 1.25-3.59s1.25-2.18 1.25-3.64a14.5 14.5 0 0 0-.52-3.43c-.16-.88-2.91-4.68-2.71-5.77 0 0-1.56 3.54-2 4.52-.57 1.25.36 2.55.15 3.59s-1 3.07-.36 4.16c.57.93 2.18 2.91 2.91 4.16ZM700 325.78s-.2-.52-1.82-.52-4-.15-4.67-.88a13.3 13.3 0 0 0-2.71-2 6.2 6.2 0 0 1-2.18-2.7c-.15-.73-1.45-2.13-2-2.13a12.9 12.9 0 0 1 4.15.36c2.13.52 5.2 1.61 5.93 3.07s3.27 4.83 3.27 4.83Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M699.45 325.41c-.42 1.25-3.43-1.24-4.11-2.13l-1.82-2.34a35 35 0 0 1-2.18-2.91c-1.09-2-.83-5.56-.36-5.25a35 35 0 0 0 3.06 1.67 2.87 2.87 0 0 1 2 1.4 8.9 8.9 0 0 0 1.3 2.75c.52.52 3.79 2.34 2.13 6.81Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M700.54 325.41a37 37 0 0 1-3.43-2.7c-1.09-1-.52-2.49-1.09-3.22s-1.77-2.34-1.41-3.43 1-4.16 1-4.16 1.3 1.25 2.18 2.18a5.3 5.3 0 0 1 1.46 2.71 30 30 0 0 0 1.46 2.7c.36.88 0 2.7-.21 3.79a8 8 0 0 0 0 2.13Z"
          className="El_Salvador_svg__cls-6"
        />
        <path
          d="M660.67 439.12s11.91-.15 13-1.61M653.81 440.58s7.74 2.14 11.9 1.62 6.14.36 7.07.36 5.41-1.82 5.41-1.82M645.87 443.45s6 1.09 7.22 1.45 7.38 2.71 9.2 2.71c1.46 0 5-.16 6 0a21 21 0 0 0 7.59-.52M668.41 429.21s-4.52 2.7-5.25 3.58-4.67 4.16-5.4 4.16M668.41 423.59s-7.74 6.7-9 7.59-8.89 8.31-9.77 9.4M662.14 420.72s-6.14 4.89-6.87 6.86a19.9 19.9 0 0 1-2.54 4.32s-2.55 5-3.43 5.77a38.6 38.6 0 0 1-4.89 4M697.11 416.21s-6.44 5.46-8.21 6.5M699.81 419.63s-6.5 4.52-9.36 5.62a47.3 47.3 0 0 1-11.54 2.86M676.37 430.65s7.22-.36 8.47 0 6.86-.93 8.31-1.3 7.23-1.4 8-1.61M687.39 406.28s.36 4-.21 5.61-3.07 6.29-2.86 7.38-1.46 6-2.91 6.86M680 407s1.3 3.95.73 5.25a16.6 16.6 0 0 0-1.41 5 14.8 14.8 0 0 1-1.3 4.52c-.36.88.21 3.95-.72 4.83a25 25 0 0 0-2 2.55M718.58 397.81s-5.77 2.18-6.5 3.59-1.77 1.82-2.34 2.54M697.32 392.41s-1.46 5.77-1.1 7.22a28.2 28.2 0 0 1 .37 5.41c0 1.09 1.61 5.4 1.45 6.13M699.65 387.52s.52 3.43.73 4.88 0 3.8.36 4.68.89 5.77 0 7.95M715.5 392.41s-4.68 3.95-5.77 5-5.92 6.29-6.13 7.59-3.59 5.19-4.68 6.13M723.45 372.19s-4.67 4.68-5 5.77-2.34 2.86-3.27 3.43M701.47 374.16s1.77 2.71 1.77 3.59a9.3 9.3 0 0 0 1.46 4.16c.46.62 2 3.27 1.81 4.88M702.87 366.57s.73 2.55 1.1 4.31a42 42 0 0 0 1.61 4.73c.36 1.09 1.82 6.29 1.3 9.57M719.3 366.41a9.2 9.2 0 0 1-1.77 3.8c-1.3 1.25-3.28 3.07-3.43 4.1s-1.82 6.5-3.64 8.32a6.5 6.5 0 0 0-2 3.64M721.12 348a32 32 0 0 1-.89 4c-.36.88-1.82 4.88-3.27 6.13M705.58 348.9a26 26 0 0 1 1.09 3.59c.21 1.09 1.3 2.34 1.46 2.91s.88 2.34.88 2.34M702.36 351.39c.16 1.09 2.18 4.37 2.34 4.89s1.25 3.07 2.34 3.79 4.31 3.07 4.15 4M716.45 344.39s.15 3.95-.58 5.4a46 46 0 0 0-2 4.73 25.5 25.5 0 0 0-.52 4.11c-.21 1.3-.73 3.63-1.45 4.52M697.83 332.12s2.6 3 3.8 4.16 5.76 6.13 6 7M702.14 329.41s2.55 5.56 3.12 6.45a19.5 19.5 0 0 1 1 2.39M708.65 329.21s-.16 4.37 0 5.46a9.8 9.8 0 0 1 0 3.43 39 39 0 0 0 .72 5.4M687.76 318a78 78 0 0 1 6.65 4.32"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="m691.18 313.51 4 5.77.89 1.66"
          className="El_Salvador_svg__cls-8"
        />
        <path
          d="M695.65 313a27 27 0 0 1 1.46 4.31 40.4 40.4 0 0 0 2.7 6.71"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="M691.34 310.66s.57 1.24-1.61.88"
          className="El_Salvador_svg__cls-5"
        />
      </g>
      <path
        d="M635.94 440.21s.88-2.18 2.7-.2c0 0 2.18 5.09.52 5.24s-3.22.52-3.38-.36a31 31 0 0 1 .16-4.68"
        className="El_Salvador_svg__cls-9"
      />
      <path
        d="M638.28 439.49s.57-7.74 1.61-8.1 4.36-2.19 6.34-.58.15 9.67-.58 10.4-1.76 3-5.92 2.44l-.57-2a12.5 12.5 0 0 0 3.64-.94c1.45-.73 1.92-1.4 1.82-2.13-.21-1.09-.11-5.09-1.2-5.46s-2.81-.88-2.81-.88-1.61 6-2 7.74l-.36-.52Z"
        className="El_Salvador_svg__cls-9"
      />
      <path
        d="M635.78 444.9s-7.43 4.31-3.64 10.81l-2.54-1.61s-1.4 2.54-.16 4c0 0-5-4.52-1.09-9.93s7.23-5.09 7.23-5.09z"
        className="El_Salvador_svg__cls-10"
      />
      <path
        d="M635.78 441.32a10.28 10.28 0 0 0-7.95-.94s-2.08-6.7-1.3-8.84a1.55 1.55 0 0 1 1.09-1.09s-2.34-1.4-1.61 4.89 2 8.11 2 8.11 6.13.36 7.58-.37l.21-1.76Z"
        className="El_Salvador_svg__cls-10"
      />
      <path
        d="M635.78 441.32s-6.49-10.87-8.16-10.87c0 0-1.87-.26 2.34-.73 1.46-.15 3.8 0 4.89 2s2 6.65 2.34 7.38a2.32 2.32 0 0 0-1.41 2.19Z"
        className="El_Salvador_svg__cls-10"
      />
      <path
        d="M635.78 441.32a46 46 0 0 1-4.88-2.55c-.57-.52-1.46-6.65-.94-6.29 0 0-1.76-2-2.34-2-.36 0-1.61.94-1.24 3.07a44.5 44.5 0 0 0 1.45 6.86s3.43-1.4 7.95.94Z"
        className="El_Salvador_svg__cls-11"
      />
      <path
        d="M639.74 444.9a5.25 5.25 0 0 1 2.34 4.15c0 2.71 1.09 7.59 3.27 8.68 0 0 .52-2 1.25-2.39 0 0 2.18 2.55 2.86 2.55a11.5 11.5 0 0 1-1.25-3.43c0-1.09-1.09-5.25-2.18-6.29s-3.23-3.64-6.29-4.52z"
        className="El_Salvador_svg__cls-10"
      />
      <path
        d="m640.62 432.27-2 7.74.52 1.67a1.86 1.86 0 0 0 1.09-1.09c.36-.94 1.46-7.59 2-7.8l-1.67-.52Z"
        className="El_Salvador_svg__cls-11"
      />
      <path
        d="M635.68 444s-3.54 1.09-4.89 3.85c0 0-.47-1.77 4.78-4.32zM639.84 444s2.45 1 3.07 2.44a28 28 0 0 0-3.07-1.82zM635.68 441.94s-5.51.88-6.71.62c0 0 1.66.37 6.81-.1zM644.62 438.61s.63 2.75 1 2.6 1.41-4.63 1.46-6.71-.89-2.49-1.72-2.39-1.24 1.87-1.14 2.7.26 3.33.36 3.8Z"
        className="El_Salvador_svg__cls-12"
      />
      <path
        d="M638.65 440s2.23 5 .52 5.25.72.21-.42-3.22c-.47-1.3-1.2-2.91-1.56-2.91 0 0 1.3.46 1.46.88"
        className="El_Salvador_svg__cls-12"
      />
      <path
        d="M635.94 440.21s.88-2.18 2.7-.2c0 0 2.18 5.09.52 5.24s-3.22.52-3.38-.36a31 31 0 0 1 .16-4.68Z"
        className="El_Salvador_svg__cls-13"
      />
      <path
        d="M638.28 439.49s.57-7.74 1.61-8.1 4.36-2.19 6.34-.58.15 9.67-.58 10.4-1.76 3-5.92 2.44l-.57-2a12.5 12.5 0 0 0 3.64-.94c1.45-.73 1.92-1.4 1.82-2.13-.21-1.09-.11-5.09-1.2-5.46s-2.81-.88-2.81-.88-1.61 6-2 7.74l-.36-.52Z"
        className="El_Salvador_svg__cls-13"
      />
      <path
        d="M630.27 308.16c-.46-1.14-.57-8.83-.46-10 .15-2.08 3.74-12.26 4.46-13.46a6.6 6.6 0 0 0 .89-2.18l1-1.4a12.85 12.85 0 0 1 1.5 4.93s-.67 4.89-1.24 7.07a41 41 0 0 1-2.19 5.82c-.67 1.51-.62 2.91-.2 3l-3.8 6.23Z"
        className="El_Salvador_svg__cls-9"
      />
      <path
        d="m636.47 297.92.57.62c1.61-1.71 1.71-5.3 1.71-5.3l-1-7.22s-.67 4.89-1.24 7.07a41 41 0 0 1-2.19 5.82c-1 2.6-.26 2.91-.2 3l2.39-4Z"
        className="El_Salvador_svg__cls-2"
      />
      <path
        d="M637 298.54c1.61-1.71 1.71-5.3 1.71-5.3s1.15 5.88.52 7.13-.62.88-.52 1.5z"
        className="El_Salvador_svg__cls-9"
      />
      <path
        d="M638.74 301.87c-.1-.62-.1-.26.52-1.5s-.52-7.12-.52-7.12l-1-7.23a13 13 0 0 0-1.5-4.94l-1 1.41a7 7 0 0 1-.89 2.18c-.72 1.2-4.31 11.38-4.47 13.46-.1 1.2 0 8.89.47 10"
        className="El_Salvador_svg__cls-5"
      />
      <path
        d="M636.47 282.06s-.11-1.14-.21-1.56c0-.2.62 1 1.19.89a6.9 6.9 0 0 1 2.5 2.08c-.47.67-1.56 2-2.34 1.71s-.52-1.19-.73-1.82a2.7 2.7 0 0 1-.41-1.3Z"
        className="El_Salvador_svg__cls-14"
      />
      <path
        d="M636.51 281.13c.06.05.37.41.42.47.26.15.52 0 .83.2a12 12 0 0 1 1.87 1.82M637.24 281.92a6.5 6.5 0 0 1 2.19 2.08s.05-.11 0-.11"
        className="El_Salvador_svg__cls-7"
      />
      <path
        d="M635.36 281.24s1-.52 1.41-.73c.21-.1-.78.93-.42 1.4a6.3 6.3 0 0 1-1.14 3.07c-.78-.21-1.56-.21-2.18-1.4-.26-.42.46-.89.93-1.3a4.4 4.4 0 0 1 1.4-1Z"
        className="El_Salvador_svg__cls-14"
      />
      <path
        d="M636.3 280.92c0 .11-.31.47-.31.63s.15.47.1.83a14.6 14.6 0 0 1-1 2.39M635.78 281.92a6.14 6.14 0 0 1-1.19 2.75c0-.05.15 0 .15 0"
        className="El_Salvador_svg__cls-7"
      />
      <path
        d="M637 280.51c.73-.89 2-1.67 2.65-1.15a2.8 2.8 0 0 1 .73.68c.31.36.26.52.1.93-.46.94-1.71.47-2.49.06-.16-.11-.62-.52-.88-.42-.42.16-.26.16-.42.16.15.1.31.05.42.1a16 16 0 0 1 2.13 1c.62.26 1.76-.57 1.71-1.14s-1.09-1.88-1.61-1.88a4 4 0 0 0-3 1.67c.21-.16.46.15.62-.05Z"
        className="El_Salvador_svg__cls-14"
      />
      <path
        d="M636.3 280.51c-.68-.89-2-1.67-2.6-1.15a2.8 2.8 0 0 0-.73.68c-.31.31-.31.52-.1.93.42.94 1.71.47 2.44.06.21-.11.68-.52.94-.42s.26.16.41.16c-.15.1-.31.05-.47.1-.67.21-1.19.62-2.13 1-.62.26-1.71-.57-1.71-1.14 0-.73 1.14-1.88 1.66-1.88a3.85 3.85 0 0 1 2.91 1.67c-.15-.16-.41.15-.62-.05Z"
        className="El_Salvador_svg__cls-14"
      />
      <path
        d="M636.56 280c-.31-.1-.67.21-.78.42a.59.59 0 0 0 .42.72c.41.16 1 .05 1.09-.41s-.36-.53-.73-.73Z"
        className="El_Salvador_svg__cls-14"
      />
      <path
        d="M636.51 272.77a13.7 13.7 0 0 0 1.88 4.83c1.4 2-1.72 1.77-1.93 2.5a6.8 6.8 0 0 0-1.92-2.55 15.6 15.6 0 0 0 2-4.73v-.05Z"
        className="El_Salvador_svg__cls-15"
      />
      <path
        d="M636.51 272.77a13.7 13.7 0 0 0 1.88 4.83 11.6 11.6 0 0 0-1.93 2.5 6.8 6.8 0 0 0-1.92-2.55 15.6 15.6 0 0 0 2-4.73"
        className="El_Salvador_svg__cls-7"
      />
      <path
        d="M636.47 275.73a15 15 0 0 0 .78 2.08s-.68.52-.78.83a3 3 0 0 0-.73-1 5.5 5.5 0 0 0 .73-1.87Z"
        className="El_Salvador_svg__cls-7"
      />
      <path
        d="M636.47 414.34c-.11 0-.26-.21-.42-.26-.47-.31-1.35-.31-1.56-.57-1.25-1.41-.41-4.11.1-5.77 1-3.12 1.2-6 1.88-8.94.67 3 .83 5.82 1.82 8.94.57 1.66 1.4 4.36.15 5.77-.26.26-1.09.26-1.56.57-.15.05-.31.26-.46.26Z"
        className="El_Salvador_svg__cls-2"
      />
      <path
        d="M636.47 398.7c.67 3 .88 6 1.87 9.09.52 1.56 1.3 4.06.36 5.46v-.05a3.6 3.6 0 0 0 1.3-.32c.16-.05.31-.1.36-.26a2.5 2.5 0 0 1 .58-.62c.31-.21.67-.05 1-.26.11-.1.16-.21.21-.21a2.72 2.72 0 0 0 1.51-1.35 2.85 2.85 0 0 0 .1-1.51 4.4 4.4 0 0 0-.31-.93c-.21-.47-.41-.94-.62-1.4s-.52-.89-.73-1.36a2.9 2.9 0 0 0-.36-.67c-.11-.21-.26-.42-.37-.63s-.36-.36-.52-.57-.26-.21-.41-.36-.32-.11-.26-.21a.57.57 0 0 1-.32-.16c-.41-.88-.78-1.35-1.19-2.23a3.4 3.4 0 0 1-.26-1.46h-1.92ZM636.47 398.7c-.63 3-.83 6-1.88 9.09-.46 1.56-1.24 4.06-.31 5.46v-.05a4.2 4.2 0 0 1-1.35-.32.75.75 0 0 1-.36-.26 1.8 1.8 0 0 0-.57-.62c-.26-.21-.63-.05-.94-.26-.1-.1-.15-.21-.26-.21a2.63 2.63 0 0 1-1.45-1.35 3 3 0 0 1-.11-1.51 5 5 0 0 1 .32-.93c.2-.47.41-.94.62-1.4s.47-.89.73-1.36a2.5 2.5 0 0 1 .36-.67 4 4 0 0 1 .36-.63c.11-.2.37-.36.52-.57s.26-.21.42-.36.31-.11.26-.21.26-.1.26-.16c.46-.88.83-1.35 1.24-2.23a3.4 3.4 0 0 0 .26-1.46h1.88Z"
        className="El_Salvador_svg__cls-9"
      />
      <g id="El_Salvador_svg__g1">
        <path
          d="M635.58 398.8a48 48 0 0 1-1.87 6.14c-.73 1.24-3.54 3.53-1.72 7.06"
          className="El_Salvador_svg__cls-16"
        />
        <path
          d="M635.68 398.8a40.6 40.6 0 0 1-1.88 6.2c-.72 1.3-3.48 3.64-1.61 7.17"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M635.83 398.8a44 44 0 0 1-1.92 6.29c-.68 1.25-3.43 3.69-1.51 7.23"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M635.94 398.8s-1.14 5.1-1.87 6.34-3.43 3.75-1.51 7.38"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M636.09 398.8a45 45 0 0 1-1.92 6.45c-.73 1.25-3.38 3.79-1.4 7.43"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M635.47 398.8a39 39 0 0 1-1.92 6.08c-.73 1.3-3.54 3.59-1.66 7.07"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M635.32 398.85a38 38 0 0 1-1.93 6c-.72 1.25-3.53 3.54-1.66 7"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M635.21 398.85a37.3 37.3 0 0 1-2 6c-.67 1.25-3.53 3.53-1.66 7.07"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M635.05 398.85a30 30 0 0 1-2 5.93c-.68 1.3-3.48 3.53-1.66 7.06"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M635 398.9a34 34 0 0 1-2 5.87c-.73 1.25-3.53 3.54-1.66 7"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M636.2 398.8s-1.14 5.25-1.87 6.5-3.33 3.9-1.4 7.59"
          className="El_Salvador_svg__cls-21"
        />
      </g>
      <g id="El_Salvador_svg__g1-2" data-name="g1">
        <path
          d="M637.39 398.8a47 47 0 0 0 1.87 6.14c.73 1.24 3.53 3.53 1.71 7.06"
          className="El_Salvador_svg__cls-16"
        />
        <path
          d="M637.29 398.8a41.5 41.5 0 0 0 1.87 6.19c.73 1.3 3.49 3.64 1.62 7.17"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M637.14 398.8a44 44 0 0 0 1.92 6.29c.68 1.25 3.43 3.69 1.51 7.23"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M637 398.8s1.14 5.1 1.87 6.34 3.43 3.75 1.51 7.38"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M636.87 398.8a45 45 0 0 0 1.93 6.45c.72 1.25 3.37 3.79 1.4 7.43"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M637.5 398.8a39 39 0 0 0 1.92 6.08c.73 1.3 3.53 3.59 1.66 7.07"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M637.65 398.85a38.6 38.6 0 0 0 1.92 6c.73 1.25 3.54 3.54 1.67 7"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M637.76 398.85a38 38 0 0 0 2 6c.68 1.25 3.54 3.53 1.67 7.07"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M637.92 398.85a30 30 0 0 0 2 5.93c.68 1.3 3.48 3.53 1.66 7.06"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M638 398.9a34 34 0 0 0 2 5.87c.72 1.25 3.53 3.54 1.66 7"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M636.77 398.8s1.14 5.25 1.87 6.5 3.32 3.9 1.4 7.59"
          className="El_Salvador_svg__cls-21"
        />
      </g>
      <path
        d="M640.83 403.12c.15.2.41.36.52.57s.26.41.36.62a2.6 2.6 0 0 1 .36.68c.21.47.52.88.73 1.35l.63 1.4a5.5 5.5 0 0 1 .31.94 3 3 0 0 1-.11 1.51 2.77 2.77 0 0 1-1.5 1.35c-.06 0-.11.1-.21.21-.31.2-.68.05-1 .26a2 2 0 0 0-.57.62c-.05.15-.21.21-.36.26a3.9 3.9 0 0 1-1.3.31c-.06.11-.16.21-.21.31-.26.26-1.09.26-1.56.57-.16.06-.31.27-.47.27s-.26-.21-.41-.27c-.47-.31-1.36-.31-1.56-.57a1 1 0 0 1-.21-.31v.05-.05a4.4 4.4 0 0 1-1.35-.31.84.84 0 0 1-.37-.26 1.55 1.55 0 0 0-.55-.63c-.26-.21-.62-.06-.93-.26-.11-.11-.16-.21-.26-.21a2.65 2.65 0 0 1-1.46-1.35 3.1 3.1 0 0 1-.1-1.51 5.5 5.5 0 0 1 .31-.94c.21-.47.42-.93.62-1.4s.47-.88.73-1.35a3 3 0 0 1 .37-.68 3.3 3.3 0 0 1 .36-.62c.1-.21.36-.37.52-.57"
        className="El_Salvador_svg__cls-13"
      />
      <g id="El_Salvador_svg__g2">
        <path
          d="M603.36 353.27c-1.77-4.41-3.64-13.46-3.54-15.54.37-8.52.26-11.06 1-19.8l8.79 10a30 30 0 0 0 0 6.55 35 35 0 0 0 1.19 6.14Z"
          className="El_Salvador_svg__cls-2"
        />
        <path
          d="M610.83 340.64a35 35 0 0 1-1.19-6.14 29.8 29.8 0 0 1 0-6.54l5.4 6-4.21 6.71ZM588.49 348.9c-.15-2-.31-4.16-.31-5.14.05-6.14-.67-9.57 0-16.06.52-5.09 1.77-11.8 1.51-17.31a41 41 0 0 1 .26-4.62l10.91 12.16c-.78 8.73-.67 11.28-1 19.8-.1 2.08 1.77 11.12 3.54 15.54l-2.29 3.84-12.58-8.21ZM596.13 365.38c-.72-1.19-1.35-4.62-1.5-5.3a21.8 21.8 0 0 1-.26-6l6 3.95-4.27 7.32ZM578.92 394.17a6.3 6.3 0 0 1-2.18-2.65 26 26 0 0 1-1.09-4.32c-.31-1.29-.31-2.75-.63-4.1s-2.18-5.67-2.23-7.43c-.21-5.67-2.08-9.51-1.61-15.7.31-4.78 1.4-11.28.88-16.27a29 29 0 0 1 .1-4.26l12.27 8c-.47 8.21-.26 10.49-.26 18.45 0 1.92 1.66 9.71 3.74 13.2l-9 15.07ZM599.3 398.7c2.28 2.08 6.49 3.17 7.17 3.63a13.1 13.1 0 0 0 7.54 2.92c2.8.2 4-.52 6.91-.89 3.27-.41-.42.11 2.75-.57 1.61-.42 1.61-.68 3.8-1.2 1.61-.36 3.22-.78 4.21-2.13a3 3 0 0 0 .72-1.76h2.19c.2.62-.42 1.82-.63 2.23l-.57.78c-.31.68-.26.52-.83 1a13 13 0 0 1-1 .78 3.06 3.06 0 0 1-1.3.78 40 40 0 0 0-5 1.4c-1.92.58-.88.47-2.34.84-.73.15-2.18.72-2.91.83-1.3.2-1.51.41-2.86.72a36 36 0 0 1-10.29.37c-1.4-.11-4.83-.83-6-1.67-2.13-1.5-6.81-2.07-8.88-3.53-.31-.21-1.61-.83-1.87-1.09-2-1.66-3.64-2.13-5.77-3.48Z"
          className="El_Salvador_svg__cls-9"
        />
        <path
          d="M615.78 398.7h16.63a3 3 0 0 1-.73 1.76c-1 1.35-2.59 1.77-4.21 2.13s-3.48-.52-5.3-.52c-4.36-1.35-4.88-2.7-6.39-3.37"
          className="El_Salvador_svg__cls-9"
        />
        <path
          d="M615.78 398.7c1.51.78 2.23 2.08 6.39 3.37 1.61 0 3.38.73 4.89.68-1.82.42-1.87.68-3.38 1-3.17.68.52.16-2.75.57-2.86.37-4.11 1.09-6.92.89a13.07 13.07 0 0 1-7.53-2.92c-.68-.46-4.89-1.55-7.18-3.63Z"
          className="El_Salvador_svg__cls-2"
        />
        <path
          d="M590.52 312.73s2 17.93 9 17.25"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M599.51 329.88c-3.48.16-5.77-4.26-7.07-8.42a55.6 55.6 0 0 1-1.92-8.78"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M599.51 329.83c-3.48-.1-5.77-4.57-7-8.47a52.5 52.5 0 0 1-2-8.73"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M599.56 329.78c-3.48-.31-5.82-4.88-7-8.52a66 66 0 0 1-2.08-8.68"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M599.56 329.72c-3.48-.57-5.82-5.24-6.91-8.57a64 64 0 0 1-2.13-8.68"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M599.61 329.63c-3.54-.73-5.87-5.51-6.86-8.58a71 71 0 0 1-2.24-8.62"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M599.61 329.57c-3.48-1-5.87-5.82-6.81-8.63a55 55 0 0 1-2.23-8.57"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M599.67 329.52c-3.54-1.19-5.93-6.13-6.81-8.73a58 58 0 0 1-2.29-8.47"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M599.67 329.47c-3.54-1.45-5.93-6.44-6.71-8.78a58.4 58.4 0 0 1-2.39-8.47"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M599.67 329.37c-3.48-1.62-5.93-6.76-6.65-8.79a56.4 56.4 0 0 1-2.45-8.42"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M599.72 329.31c-3.54-1.82-6-7.07-6.66-8.84a59 59 0 0 1-2.49-8.37"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M599.72 329.26c-3.54-2.08-6-7.38-6.55-8.89a55 55 0 0 1-2.6-8.31"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M599.76 329.21c-3.53-2.29-6-7.69-6.54-9a60 60 0 0 1-2.65-8.26"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M590.57 311.9a55.5 55.5 0 0 0 2.7 8.21c.47 1 3 6.5 6.49 9"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M590.78 308.68s5.82 14.24 9.51 12.63"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M600.29 321.3c-1.61.68-4-2.18-5.92-5.5a78 78 0 0 1-3.59-7.18"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M600.29 321.26c-1.4.62-3.9-2.14-5.87-5.56-2.13-3.8-3.64-7.12-3.64-7.12"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M600.29 321.21c-1.19.52-3.79-2.08-5.82-5.61-2.23-4-3.64-7.07-3.64-7.07"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M600.29 321.21c-1 .41-3.74-2.08-5.72-5.72-2.33-4.16-3.74-7-3.74-7"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M600.34 321.15c-.83.36-3.69-2-5.72-5.77-2.39-4.37-3.74-7-3.74-7"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M600.34 321.15c-.62.26-3.59-2-5.67-5.87-2.44-4.53-3.79-7-3.79-7"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M600.34 321.1c-.42.21-3.48-2-5.61-5.92-2.55-4.73-3.8-6.92-3.8-6.92"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M600.34 321.1c-.21 0-3.38-2-5.56-6-2.6-4.93-3.85-6.91-3.85-6.91"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="M590.94 308.16a63 63 0 0 1 3.89 6.86 16.25 16.25 0 0 0 5.51 6M610 335.5l4.51-.84M609.65 330.87l4.88 2.65"
          className="El_Salvador_svg__cls-21"
        />
        <path d="m609.54 331.08 5 2.44" className="El_Salvador_svg__cls-37" />
        <path d="m609.54 331.28 5 2.29" className="El_Salvador_svg__cls-38" />
        <path d="m609.54 331.55 5 2.08" className="El_Salvador_svg__cls-30" />
        <path d="m609.59 331.75 5 1.93" className="El_Salvador_svg__cls-29" />
        <path d="m609.59 332 5.1 1.72" className="El_Salvador_svg__cls-39" />
        <path
          d="m609.59 332.17 5.15 1.56"
          className="El_Salvador_svg__cls-26"
        />
        <path d="m609.59 332.37 5.2 1.42" className="El_Salvador_svg__cls-25" />
        <path
          d="m609.59 332.64 5.26 1.19"
          className="El_Salvador_svg__cls-40"
        />
        <path d="m609.59 332.85 5.3 1" className="El_Salvador_svg__cls-34" />
        <path d="m609.9 335.28 4.63-.67" className="El_Salvador_svg__cls-37" />
        <path d="m609.9 335 4.68-.53" className="El_Salvador_svg__cls-38" />
        <path d="m609.85 334.77 4.78-.31" className="El_Salvador_svg__cls-30" />
        <path d="m609.85 334.56 4.84-.15" className="El_Salvador_svg__cls-29" />
        <path d="M609.8 334.3h4.94" className="El_Salvador_svg__cls-39" />
        <path d="m609.8 334 5 .21" className="El_Salvador_svg__cls-26" />
        <path d="m609.8 333.83 5.05.31" className="El_Salvador_svg__cls-25" />
        <path d="m609.74 333.57 5.2.53" className="El_Salvador_svg__cls-40" />
        <path d="m609.74 333.32 5.26.68" className="El_Salvador_svg__cls-34" />
        <path
          d="m609.69 333.1 5.36.84M588.49 334.41s.26 3.79 1.09 5.4c1.2 2.24 4.68 5.67 8.68 8.16"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M598.36 348a32.6 32.6 0 0 1-6.54-5.56 16 16 0 0 1-2.08-2.71 21 21 0 0 1-1.2-5.4"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M598.47 348a32.7 32.7 0 0 1-6.5-5.67 11.1 11.1 0 0 1-2-2.75 19.8 19.8 0 0 1-1.41-5.35"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M598.52 348a37.3 37.3 0 0 1-6.39-5.72 14.5 14.5 0 0 1-2-2.81 21.1 21.1 0 0 1-1.56-5.35"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M598.63 347.92a38 38 0 0 1-6.4-5.77 16 16 0 0 1-2-2.81 22.4 22.4 0 0 1-1.72-5.35"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M598.72 347.92a40 40 0 0 1-6.34-5.87 15 15 0 0 1-2-2.81 22.4 22.4 0 0 1-1.82-5.35"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M598.83 347.92a41.8 41.8 0 0 1-6.29-6 18 18 0 0 1-2-2.8 25.4 25.4 0 0 1-2-5.36"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M598.88 347.92a50 50 0 0 1-6.19-6.08 17 17 0 0 1-2-2.81 27.4 27.4 0 0 1-2.13-5.35"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M599 347.87a42 42 0 0 1-6.14-6.13 18 18 0 0 1-2-2.81 31 31 0 0 1-2.29-5.35"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M599.09 347.87a44.5 44.5 0 0 1-6.08-6.24 16 16 0 0 1-2-2.8 34.4 34.4 0 0 1-2.39-5.36"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M599.14 347.87c-2.39-1.82-4.68-4.94-6-6.34a20.4 20.4 0 0 1-2-2.81 49 49 0 0 1-2.55-5.35"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M599.25 347.87c-2.39-1.87-4.68-5-5.93-6.39a23.4 23.4 0 0 1-2-2.86c-1.35-2.29-2.7-5.35-2.7-5.35"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M599.36 347.81c-2.39-1.87-4.68-5.14-5.88-6.44a20.3 20.3 0 0 1-1.92-2.86c-1.45-2.39-2.91-5.35-2.91-5.35"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M588.65 333.05s3.38 6.4 5 8.22c1.14 1.24 3.43 4.67 5.82 6.54"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M588.74 348.9c3.69 2.44 4.63 3.07 12.27 8l2.34-3.58s-.88-2.13-1.25-3.12"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M588.8 348.85c3.54 2.4 4.73 3.17 12.22 7.85l.1-.1c0-.05 2.08-3.48 2.08-3.48a6 6 0 0 0-.36-.94 21 21 0 0 1-.73-2"
          className="El_Salvador_svg__cls-41"
        />
        <path
          d="M588.8 348.85c3.43 2.29 4.94 3.28 12.22 7.75l.1-.16c0-.1 2-3.48 2-3.48a9 9 0 0 0-.31-.88c-.26-.63-.52-1.41-.67-1.93"
          className="El_Salvador_svg__cls-42"
        />
        <path
          d="M588.8 348.85c3.33 2.19 5.15 3.33 12.22 7.59l.1-.15c0-.11 1.87-3.43 1.82-3.43a3.4 3.4 0 0 0-.26-.84c-.21-.62-.47-1.35-.62-1.87"
          className="El_Salvador_svg__cls-43"
        />
        <path
          d="M588.8 348.81c3.23 2.13 5.36 3.43 12.22 7.48l.1-.16c0-.15 1.72-3.43 1.72-3.43a2.1 2.1 0 0 0-.21-.78 9.4 9.4 0 0 1-.57-1.76"
          className="El_Salvador_svg__cls-44"
        />
        <path
          d="M588.85 348.81c3.07 2 5.51 3.53 12.16 7.32l.11-.15c0-.21 1.61-3.38 1.61-3.43a6 6 0 0 0-.21-.73 12 12 0 0 1-.47-1.66"
          className="El_Salvador_svg__cls-45"
        />
        <path
          d="M588.85 348.75c3 2 5.72 3.63 12.22 7.22 0 0 0-.16.1-.16 0-.25 1.46-3.37 1.4-3.37a1.5 1.5 0 0 0-.1-.73 6 6 0 0 1-.42-1.56"
          className="El_Salvador_svg__cls-46"
        />
        <path
          d="M588.85 348.75a139 139 0 0 0 12.22 7.06l.1-.15c0-.26 1.3-3.33 1.3-3.38a.77.77 0 0 0-.1-.62 5.6 5.6 0 0 1-.37-1.51"
          className="El_Salvador_svg__cls-47"
        />
        <path
          d="M588.85 348.75a135 135 0 0 0 12.22 7 .8.8 0 0 1 .1-.21c0-.31 1.2-3.32 1.14-3.38s.16-.15 0-.57a5 5 0 0 1-.31-1.4"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M588.9 348.7a110 110 0 0 0 12.16 6.86c0-.05.11-.16.11-.21 0-.36 1-3.33 1-3.33s.16-.15 0-.57a2.9 2.9 0 0 1-.2-1.3"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M588.9 348.7a97 97 0 0 0 12.16 6.7.4.4 0 0 0 .11-.2c0-.42.93-3.28.88-3.33a.39.39 0 0 0 .1-.52 2.4 2.4 0 0 1-.15-1.2"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M588.9 348.7a95 95 0 0 0 12.16 6.55c.05-.05.11-.16.16-.21-.05-.42.78-3.28.72-3.28s.26-.15.11-.51a2.5 2.5 0 0 1-.11-1.1"
          className="El_Salvador_svg__cls-48"
        />
        <path
          d="M589 348.65a81 81 0 0 0 12.11 6.45 2 2 0 0 1 .16-.21c0-.47.62-3.22.57-3.28a.31.31 0 0 0 .2-.41c-.2-.42-.1-.57 0-1"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M589 348.65a75.3 75.3 0 0 0 12.11 6.29s.16-.16.16-.21c0-.52.52-3.22.46-3.27s.37-.06.21-.37 0-.46.05-.93"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M589 348.65a75.5 75.5 0 0 0 12.16 6.19c0-.06.11-.21.11-.26 0-.52.41-3.18.36-3.23h-.05s.41-.05.31-.36 0-.36.1-.83"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M589 348.59a64.7 64.7 0 0 0 12.16 6.08.6.6 0 0 0 .11-.26c0-.57.25-3.17.2-3.22l.31-.31c-.15-.31.06-.31.21-.73"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M589 348.59a58 58 0 0 0 12.11 5.93.6.6 0 0 0 .1-.26c0-.63.16-3.18.1-3.23s.47.05.37-.2.1-.26.21-.68"
          className="El_Salvador_svg__cls-50"
        />
        <path
          d="M589 348.54a53.2 53.2 0 0 0 12.11 5.82c0-.05.1-.2.15-.26 0-.67 0-3.12-.1-3.17s.52.05.41-.2.16-.16.32-.57"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M589 348.54c1.56 1 8 4.68 12.11 5.67 0 0 .1-.21.15-.26 0-.68-.15-3.12-.2-3.17s.51.1.46-.16.16-.05.37-.47"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M589 348.54c1.45.94 8.16 4.78 12.11 5.51a.42.42 0 0 0 .15-.26 19.7 19.7 0 0 0-.36-3.17s.62.16.52-.1.26.05.47-.36"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M589.06 348.49c1.29.89 8.31 4.89 12.05 5.46.06-.1.16-.21.16-.31a20.4 20.4 0 0 0-.47-3.12s.62.11.52 0 .31.1.52-.31"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M589.06 348.49c1.19.78 8.52 5 12.05 5.31a.45.45 0 0 0 .16-.32 14.4 14.4 0 0 0-.62-3.11s.67.15.62 0 .36.15.57-.21"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M589.06 348.49c1.09.68 8.73 5.05 12.11 5.15l.15-.31a14.3 14.3 0 0 0-.78-3.12s.73.21.63.05.41.26.67-.1"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M589.12 348.43c.93.63 8.88 5.15 12 5.05a1.4 1.4 0 0 0 .16-.32 11.4 11.4 0 0 0-.89-3.06h-.05s.78.2.73 0 .42.36.73 0"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M589.12 348.43c.83.58 9.09 5.25 12 4.89a.55.55 0 0 0 .16-.31 9.5 9.5 0 0 0-1-3.07s.78.26.73.16.52.41.83 0"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M589.12 348.43c.72.47 9.3 5.31 12 4.73a.52.52 0 0 0 .16-.31 8.1 8.1 0 0 0-1.15-3s.84.31.78.21.52.51.84.15"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M589.12 348.39c.62.41 9.51 5.4 12 4.67a.5.5 0 0 0 .16-.36 7.9 7.9 0 0 0-1.3-3s.88.31.83.21.57.62.93.26"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M589.16 348.39c.47.31 9.67 5.51 12 4.52a1.7 1.7 0 0 0 .21-.37 8.1 8.1 0 0 0-1.46-3s.88.36.88.26.63.73 1 .36"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M589.16 348.39c.37.21 9.83 5.56 12 4.36a1.7 1.7 0 0 0 .21-.36c0-1-1.51-2.91-1.61-3s1 .36.93.31.68.73 1.09.41"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M589.16 348.33c.26.15 10 5.66 12 4.26a1 1 0 0 0 .21-.37c0-1.09-1.61-2.85-1.72-3a8 8 0 0 0 1 .37c0-.06.73.83 1.09.52"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="M589.16 348.33c.16.05 10.24 5.77 12.06 4.1 0-.1.16-.21.16-.36 0-1.14-1.72-2.86-1.88-3l1 .41s.78.94 1.2.63"
          className="El_Salvador_svg__cls-53"
        />
        <path
          d="M589.22 348.28s11.65 6.55 12.17 3.64c0-1.2-2-2.91-2-2.91l1.09.41s.78 1 1.25.73"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="m587.87 379.1-9 15.07a6.25 6.25 0 0 1-2.19-2.65 36 36 0 0 1-1.09-4.31c-.26-1.3-.31-2.76-.57-4.11s-2.23-5.66-2.29-7.43"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M572.69 375.67c.06 1.77 2 6 2.29 7.33s.31 2.81.57 4.11a28 28 0 0 0 1.14 4.26 6.23 6.23 0 0 0 2.14 2.65s9-14.92 9-14.92"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M572.69 375.67c.06 1.72 2 5.93 2.24 7.28s.36 2.76.67 4.05a29 29 0 0 0 1.09 4.26 6.7 6.7 0 0 0 2.14 2.6s8.94-14.71 9-14.76"
          className="El_Salvador_svg__cls-41"
        />
        <path
          d="M572.69 375.67c.06 1.72 1.93 5.88 2.24 7.23s.36 2.7.67 4a29 29 0 0 0 1.09 4.21 6.6 6.6 0 0 0 2.14 2.55c.1 0 8.94-14.5 9-14.56"
          className="El_Salvador_svg__cls-41"
        />
        <path
          d="M572.69 375.67c.06 1.67 1.93 5.82 2.24 7.12s.36 2.71.67 4a36 36 0 0 0 1.09 4.15 6.6 6.6 0 0 0 2.14 2.55c.15.05 8.88-14.34 9-14.4"
          className="El_Salvador_svg__cls-54"
        />
        <path
          d="M572.69 375.67c.06 1.67 1.93 5.77 2.24 7.07s.36 2.71.67 3.95a26.5 26.5 0 0 0 1.15 4.11 6.1 6.1 0 0 0 2.13 2.54c.1.06 8.78-14.19 9-14.24"
          className="El_Salvador_svg__cls-54"
        />
        <path
          d="M572.69 375.67c.06 1.67 1.87 5.67 2.24 7s.36 2.7.67 3.95a25.5 25.5 0 0 0 1.15 4.05 6.1 6.1 0 0 0 2.13 2.55c.15.05 8.78-14 9-14.09"
          className="El_Salvador_svg__cls-42"
        />
        <path
          d="M572.69 375.67c.06 1.62 1.87 5.62 2.24 6.92s.36 2.65.67 3.89a29 29 0 0 0 1.15 4 5.6 5.6 0 0 0 2.13 2.5c.21.1 8.73-13.77 9-13.88"
          className="El_Salvador_svg__cls-42"
        />
        <path
          d="M572.69 375.67c.06 1.62 1.87 5.56 2.24 6.86s.36 2.6.67 3.85a26.7 26.7 0 0 0 1.2 4 6.3 6.3 0 0 0 2.08 2.44c.21.06 8.73-13.61 9-13.72"
          className="El_Salvador_svg__cls-43"
        />
        <path
          d="M572.69 375.67c.06 1.56 1.87 5.51 2.24 6.76s.36 2.6.67 3.85a24.6 24.6 0 0 0 1.2 3.94 6.4 6.4 0 0 0 2.08 2.45c.26.05 8.68-13.46 9-13.57"
          className="El_Salvador_svg__cls-43"
        />
        <path
          d="M572.69 375.67c.06 1.56 1.82 5.46 2.24 6.71s.36 2.55.73 3.79a23 23 0 0 0 1.14 3.9 6.4 6.4 0 0 0 2.08 2.44c.31.05 8.63-13.3 9-13.41"
          className="El_Salvador_svg__cls-43"
        />
        <path
          d="M572.69 375.67c.06 1.56 1.82 5.36 2.24 6.66s.36 2.54.73 3.69a27 27 0 0 0 1.14 3.89 5.8 5.8 0 0 0 2.08 2.39c.31.11 8.63-13.09 9-13.2"
          className="El_Salvador_svg__cls-44"
        />
        <path
          d="M572.69 375.67c.06 1.51 1.82 5.31 2.24 6.55s.36 2.55.73 3.69a20 20 0 0 0 1.19 3.85 6.2 6.2 0 0 0 2 2.39c.36.1 8.57-12.89 9-13"
          className="El_Salvador_svg__cls-44"
        />
        <path
          d="M572.69 375.67c.06 1.51 1.82 5.25 2.24 6.5s.36 2.5.73 3.64a22.5 22.5 0 0 0 1.19 3.84 6 6 0 0 0 2.08 2.34c.36.11 8.47-12.73 8.94-12.88"
          className="El_Salvador_svg__cls-45"
        />
        <path
          d="M572.69 375.67c.06 1.46 1.77 5.2 2.24 6.45.31 1.19.36 2.44.73 3.59a25.4 25.4 0 0 0 1.19 3.79 6.6 6.6 0 0 0 2.08 2.34c.36.1 8.47-12.58 8.94-12.73"
          className="El_Salvador_svg__cls-45"
        />
        <path
          d="M572.69 375.67c.06 1.46 1.77 5.15 2.24 6.34.31 1.2.41 2.45.73 3.59a27 27 0 0 0 1.19 3.74 6.4 6.4 0 0 0 2.08 2.29c.42.16 8.42-12.37 8.94-12.52"
          className="El_Salvador_svg__cls-55"
        />
        <path
          d="M572.69 375.67c.06 1.41 1.77 5.05 2.24 6.29.31 1.2.41 2.39.73 3.54a19.8 19.8 0 0 0 1.24 3.69 5.9 5.9 0 0 0 2 2.28c.47.16 8.42-12.21 8.94-12.36"
          className="El_Salvador_svg__cls-55"
        />
        <path
          d="M572.69 375.61c.06 1.46 1.77 5.05 2.19 6.29s.46 2.39.78 3.49a19 19 0 0 0 1.24 3.61 6.26 6.26 0 0 0 2 2.29c.47.16 8.37-12 8.94-12.21"
          className="El_Salvador_svg__cls-46"
        />
        <path
          d="M572.69 375.61c.06 1.46 1.72 5 2.19 6.19s.46 2.39.78 3.48c.57 1.87.57 1.87 1.24 3.64a6 6 0 0 0 2 2.18c.52.16 8.32-11.79 8.94-12"
          className="El_Salvador_svg__cls-46"
        />
        <path
          d="M572.69 375.61c.06 1.41 1.72 4.94 2.19 6.14.31 1.14.46 2.34.83 3.43a21.3 21.3 0 0 0 1.24 3.58 5.9 5.9 0 0 0 2 2.19c.57.15 8.32-11.64 8.94-11.85"
          className="El_Salvador_svg__cls-46"
        />
        <path
          d="M572.69 375.61c.06 1.41 1.72 4.84 2.19 6.08.31 1.1.46 2.29.83 3.38a21 21 0 0 0 1.24 3.54 6.3 6.3 0 0 0 2 2.18c.57.16 8.26-11.48 8.94-11.69"
          className="El_Salvador_svg__cls-47"
        />
        <path
          d="M572.69 375.61c.06 1.36 1.72 4.79 2.19 6 .31 1.15.46 2.29.83 3.38a25.6 25.6 0 0 0 1.24 3.48 6.1 6.1 0 0 0 2 2.19c.57.15 8.21-11.33 8.89-11.54"
          className="El_Salvador_svg__cls-47"
        />
        <path
          d="M572.69 375.61c.06 1.36 1.67 4.73 2.19 5.93.31 1.09.46 2.23.83 3.33a26 26 0 0 0 1.29 3.43 6.3 6.3 0 0 0 2 2.13c.63.21 8.16-11.07 8.89-11.33"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M572.69 375.61c.06 1.36 1.67 4.68 2.19 5.88.31 1 .46 2.23.83 3.27a20.7 20.7 0 0 0 1.3 3.43 5.8 5.8 0 0 0 2 2.08c.63.21 8.11-10.91 8.89-11.17"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M572.69 375.61c.06 1.3 1.67 4.63 2.19 5.77.31 1.09.46 2.24.83 3.28A19 19 0 0 0 577 388a5.9 5.9 0 0 0 2 2.08c.68.2 8.11-10.76 8.89-11"
          className="El_Salvador_svg__cls-56"
        />
        <path
          d="M572.69 375.61c.06 1.3 1.67 4.53 2.19 5.72.31 1 .46 2.18.83 3.22a25 25 0 0 0 1.3 3.33 6.3 6.3 0 0 0 2 2.08c.73.21 8.06-10.6 8.89-10.86"
          className="El_Salvador_svg__cls-56"
        />
        <path
          d="M572.69 375.61c.06 1.25 1.61 4.47 2.19 5.67.31 1 .46 2.13.83 3.17a29 29 0 0 0 1.3 3.27 5.66 5.66 0 0 0 2 2c.73.26 8-10.39 8.89-10.65"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M572.69 375.61c.06 1.25 1.61 4.42 2.19 5.56.31 1 .46 2.14.88 3.18a19 19 0 0 0 1.3 3.22 6.06 6.06 0 0 0 1.92 2c.78.26 8-10.24 8.89-10.55"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M572.69 375.61c.06 1.25 1.61 4.37 2.19 5.51a29 29 0 0 0 .88 3.07 19.3 19.3 0 0 0 1.3 3.22 6 6 0 0 0 1.92 2c.83.21 7.95-10 8.89-10.39"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M572.69 375.61c.06 1.2 1.61 4.32 2.19 5.46a28 28 0 0 0 .88 3 21.7 21.7 0 0 0 1.3 3.22 6.4 6.4 0 0 0 2 2c.78.21 7.9-9.87 8.84-10.23"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M572.69 375.61c.06 1.2 1.56 4.21 2.19 5.36a27 27 0 0 0 .88 3 20.7 20.7 0 0 0 1.3 3.17 5.84 5.84 0 0 0 2 1.93c.84.26 7.85-9.67 8.84-10"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M572.69 375.61c.06 1.15 1.56 4.16 2.19 5.31.31 1 .52 2 .88 3a16.6 16.6 0 0 0 1.35 3.12 5.27 5.27 0 0 0 1.92 1.92c.89.26 7.8-9.51 8.84-9.87"
          className="El_Salvador_svg__cls-48"
        />
        <path
          d="M572.69 375.61c.06 1.15 1.56 4.11 2.13 5.25.37.94.58 2 .94 2.91a19.7 19.7 0 0 0 1.35 3.07 6.2 6.2 0 0 0 1.92 1.92c.89.26 7.8-9.35 8.84-9.71"
          className="El_Salvador_svg__cls-48"
        />
        <path
          d="M572.74 375.61c0 1.15 1.46 4.06 2.08 5.15.36 1 .57 2 .94 2.91a18 18 0 0 0 1.35 3 6 6 0 0 0 1.92 1.88c.94.31 7.74-9.1 8.84-9.51"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M572.74 375.61c0 1.1 1.46 4 2.08 5.1.36.93.57 1.92.94 2.86a19.7 19.7 0 0 0 1.4 3 5.6 5.6 0 0 0 1.84 1.83c1 .31 7.69-8.94 8.84-9.35"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M572.74 375.61c0 1.1 1.46 3.9 2.08 5 .36.94.57 2 .94 2.86a19 19 0 0 0 1.4 3 5.65 5.65 0 0 0 1.87 1.81c1 .32 7.69-8.78 8.84-9.19"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="M572.74 375.61c0 1 1.46 3.85 2.08 4.94.36.94.57 1.92 1 2.81a18.4 18.4 0 0 0 1.35 2.91 6.2 6.2 0 0 0 1.87 1.82c1 .31 7.64-8.63 8.84-9"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="M572.74 375.61c0 1 1.4 3.8 2.08 4.89.36.88.57 1.87 1 2.75a17.4 17.4 0 0 0 1.35 2.86 5.56 5.56 0 0 0 1.92 1.77c1 .36 7.59-8.42 8.79-8.83"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="M572.74 375.61c0 1 1.4 3.75 2.08 4.79.36.93.57 1.87 1 2.75a14.2 14.2 0 0 0 1.4 2.81 5.07 5.07 0 0 0 1.87 1.76c1 .32 7.54-8.21 8.79-8.67"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M572.74 375.61c0 1 1.4 3.69 2.08 4.73.36.89.57 1.82 1 2.71a20 20 0 0 0 1.4 2.8 5.9 5.9 0 0 0 1.87 1.72c1.09.31 7.49-8.06 8.79-8.52"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M572.74 375.61c0 1 1.4 3.59 2.08 4.68.36.88.57 1.77 1 2.65a19.3 19.3 0 0 0 1.4 2.76 6.5 6.5 0 0 0 1.87 1.71c1.15.31 7.49-7.9 8.79-8.36"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M572.74 375.61c0 .94 1.35 3.54 2.08 4.58.36.88.57 1.82 1 2.65a16.4 16.4 0 0 0 1.4 2.7 5.6 5.6 0 0 0 1.87 1.66c1.15.37 7.43-7.69 8.79-8.15"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M572.74 375.61c0 .94 1.35 3.49 2.08 4.53.36.83.57 1.76 1 2.6a15 15 0 0 0 1.45 2.65 6.2 6.2 0 0 0 1.82 1.66c1.2.36 7.43-7.54 8.79-8"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M572.74 375.61c0 .89 1.35 3.44 2.08 4.47.36.84.57 1.72 1 2.55a22 22 0 0 0 1.45 2.6 6.2 6.2 0 0 0 1.82 1.66c1.25.37 7.38-7.33 8.79-7.84"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M572.74 375.61c0 .89 1.35 3.38 2.08 4.37.36.83.57 1.71 1 2.55.57 1.24.78 1.35 1.45 2.6a6.3 6.3 0 0 0 1.87 1.61c1.2.36 7.28-7.18 8.74-7.69"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M572.74 375.61c0 .89 1.3 3.28 2.08 4.32a24 24 0 0 0 1 2.49 18 18 0 0 0 1.4 2.55 5.5 5.5 0 0 0 1.87 1.56c1.25.41 7.28-7 8.74-7.48"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M572.74 375.61c0 .84 1.3 3.23 2.08 4.27a23 23 0 0 0 1 2.39 16 16 0 0 0 1.45 2.54 6.4 6.4 0 0 0 1.82 1.56c1.3.42 7.23-6.81 8.74-7.32"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M572.74 375.61c0 .84 1.3 3.18 2 4.16.36.78.67 1.66 1.09 2.39a15.5 15.5 0 0 0 1.45 2.5 6.6 6.6 0 0 0 1.82 1.56c1.3.41 7.18-6.66 8.74-7.17"
          className="El_Salvador_svg__cls-50"
        />
        <path
          d="M572.74 375.61c0 .78 1.3 3.12 2 4.11.36.78.67 1.61 1.09 2.34a15 15 0 0 0 1.45 2.44 6.6 6.6 0 0 0 1.82 1.56c1.36.37 7.18-6.44 8.74-7"
          className="El_Salvador_svg__cls-50"
        />
        <path
          d="M572.74 375.61a11.4 11.4 0 0 0 2 4.06c.36.73.67 1.56 1.09 2.28a13.5 13.5 0 0 0 1.51 2.45 5.14 5.14 0 0 0 1.76 1.45c1.41.42 7.13-6.23 8.74-6.8"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M572.74 375.61c0 .78 1.25 3 2 3.95.36.78.67 1.56 1.09 2.29a16.5 16.5 0 0 0 1.51 2.39 5.2 5.2 0 0 0 1.76 1.46c1.41.41 7.13-6.08 8.74-6.65"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M572.74 375.57c0 .78 1.25 3 2 3.95.36.72.67 1.5 1.09 2.23a17.7 17.7 0 0 0 1.51 2.34 6 6 0 0 0 1.76 1.46c1.46.41 7.07-5.93 8.74-6.5"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M572.74 375.57c0 .78 1.25 2.91 2 3.89.36.73.67 1.46 1.09 2.19a21 21 0 0 0 1.51 2.28 5.1 5.1 0 0 0 1.82 1.41c1.45.47 7-5.72 8.68-6.29"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M572.74 375.57a9.8 9.8 0 0 0 2 3.79 16 16 0 0 0 1.14 2.18 12.6 12.6 0 0 0 1.51 2.24 5 5 0 0 0 1.77 1.4c1.45.47 7-5.51 8.68-6.13"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M572.74 375.57c0 .72 1.2 2.75 2 3.74a21 21 0 0 0 1.14 2.13 14 14 0 0 0 1.51 2.18 5.05 5.05 0 0 0 1.77 1.41c1.5.46 6.91-5.36 8.68-6"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M572.74 375.57c0 .72 1.2 2.7 2 3.69a19 19 0 0 0 1.14 2.07 14.3 14.3 0 0 0 1.51 2.19 5.5 5.5 0 0 0 1.77 1.35c1.56.47 6.91-5.2 8.68-5.82"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M572.74 375.57a8.74 8.74 0 0 0 2 3.58 19 19 0 0 0 1.14 2.08 17 17 0 0 0 1.51 2.13 5.9 5.9 0 0 0 1.77 1.3c1.56.52 6.86-5 8.68-5.61"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M572.74 375.57a8.6 8.6 0 0 0 2 3.53 19 19 0 0 0 1.14 2 15 15 0 0 0 1.56 2.08 5.2 5.2 0 0 0 1.72 1.3c1.61.52 6.81-4.84 8.68-5.46"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M572.74 375.57a8.86 8.86 0 0 0 2 3.48c.36.62.67 1.3 1.14 2a11.6 11.6 0 0 0 1.56 2 5.2 5.2 0 0 0 1.72 1.3c1.66.52 6.81-4.68 8.68-5.3"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M572.74 375.57a8.6 8.6 0 0 0 2 3.38 16.8 16.8 0 0 0 2.7 3.95 6.6 6.6 0 0 0 1.72 1.3c1.66.46 6.75-4.47 8.68-5.15"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M572.74 375.57a7.84 7.84 0 0 0 2 3.32 18 18 0 0 0 1.14 1.93c.57.93.94 1.09 1.56 2a5.7 5.7 0 0 0 1.77 1.2c1.66.52 6.65-4.26 8.63-4.94"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M572.74 375.57a8 8 0 0 0 2 3.27c.36.57.67 1.25 1.14 1.87.57.89.94 1 1.61 1.93a5.9 5.9 0 0 0 1.72 1.19c1.71.52 6.65-4.1 8.63-4.78"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M572.74 375.57a7.9 7.9 0 0 0 2 3.17c.41.62.78 1.24 1.24 1.87a13.5 13.5 0 0 0 1.56 1.87 5.7 5.7 0 0 0 1.72 1.2c1.71.52 6.6-3.95 8.63-4.68"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M572.74 375.57a8.1 8.1 0 0 0 2 3.12c.41.57.78 1.19 1.24 1.76a10.7 10.7 0 0 0 1.56 1.87 6.4 6.4 0 0 0 1.72 1.2c1.77.52 6.6-3.79 8.63-4.52"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M572.74 375.57a7.3 7.3 0 0 0 2 3c.41.62.78 1.2 1.24 1.77a11 11 0 0 0 1.61 1.82 4.6 4.6 0 0 0 1.67 1.14c1.82.57 6.55-3.53 8.63-4.31"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M572.74 375.57a7.2 7.2 0 0 0 2 3c.41.57.78 1.19 1.24 1.71a13 13 0 0 0 1.61 1.82 5.2 5.2 0 0 0 1.67 1.1c1.82.57 6.5-3.38 8.63-4.16"
          className="El_Salvador_svg__cls-57"
        />
        <path
          d="M572.74 375.57a7.55 7.55 0 0 0 2 2.91c.41.52.78 1.14 1.24 1.66a13 13 0 0 0 1.61 1.77 8.7 8.7 0 0 0 1.67 1.09c1.87.57 6.5-3.22 8.63-4"
          className="El_Salvador_svg__cls-57"
        />
        <path
          d="M572.74 375.57a7 7 0 0 0 2 2.8A19 19 0 0 0 576 380c.58.78 1 1 1.61 1.71a8.3 8.3 0 0 0 1.67 1.09c1.92.58 6.44-3.06 8.63-3.84"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M572.74 375.57a6.7 6.7 0 0 0 2 2.75c.41.52.78 1.09 1.24 1.61a13 13 0 0 0 1.67 1.67 5.1 5.1 0 0 0 1.66 1c1.92.62 6.34-2.86 8.58-3.64"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M572.74 375.57a7 7 0 0 0 2 2.7c.41.52.78 1 1.24 1.56a17 17 0 0 0 1.67 1.61 5.5 5.5 0 0 0 1.66 1c1.92.57 6.34-2.65 8.58-3.48"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M572.74 375.57a6.55 6.55 0 0 0 2 2.6 16 16 0 0 0 1.3 1.55 11.7 11.7 0 0 0 1.61 1.62 6.4 6.4 0 0 0 1.66 1c2 .58 6.29-2.49 8.58-3.32"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M572.74 375.57a6.8 6.8 0 0 0 2 2.54 16 16 0 0 0 1.3 1.51 20 20 0 0 0 1.61 1.56 6.6 6.6 0 0 0 1.66.94c2 .62 6.29-2.29 8.58-3.12"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M572.74 375.57a6.2 6.2 0 0 0 2 2.49 16 16 0 0 0 1.3 1.46 12.2 12.2 0 0 0 1.66 1.51 6.3 6.3 0 0 0 1.61.93c2 .62 6.24-2.13 8.58-3"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M572.74 375.57a6.1 6.1 0 0 0 2 2.39 10 10 0 0 0 1.3 1.45 15.4 15.4 0 0 0 1.66 1.46 7 7 0 0 0 1.61.93c2.08.63 6.19-2 8.58-2.8"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M572.74 375.57a6.55 6.55 0 0 0 2 2.34 11 11 0 0 0 1.3 1.4 15 15 0 0 0 1.66 1.4 7.1 7.1 0 0 0 1.61.94c2.13.62 6.19-1.77 8.58-2.65"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M572.74 375.57a6.9 6.9 0 0 0 2 2.28 13 13 0 0 0 1.3 1.35 20 20 0 0 0 1.66 1.36 5.7 5.7 0 0 0 1.61.88c2.13.68 6.13-1.56 8.58-2.44"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M572.74 375.57a5.8 5.8 0 0 0 2 2.18 10 10 0 0 0 1.3 1.35c.57.57 1 .78 1.71 1.35a7.6 7.6 0 0 0 1.61.83c2.13.68 6.08-1.4 8.53-2.28"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M572.74 375.57a6 6 0 0 0 1.92 2.13c.42.41.89.83 1.36 1.3s1 .78 1.71 1.3a8 8 0 0 0 1.61.83c2.19.67 6-1.25 8.53-2.13"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M572.74 375.57a6.6 6.6 0 0 0 1.92 2.08c.42.36.89.83 1.36 1.24s1.09.73 1.71 1.25a8 8 0 0 0 1.61.83c2.19.68 6-1.09 8.53-2"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M572.74 375.57a6.8 6.8 0 0 0 1.92 2 18 18 0 0 0 1.41 1.25 15 15 0 0 0 1.71 1.19 5.2 5.2 0 0 0 1.56.78c2.24.68 6-.83 8.53-1.76"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M572.74 375.57a6.8 6.8 0 0 0 1.92 1.92 17 17 0 0 0 1.41 1.14 8.7 8.7 0 0 0 1.71 1.2 9 9 0 0 0 1.56.78c2.29.67 5.93-.68 8.53-1.61"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M572.74 375.57a6.9 6.9 0 0 0 1.92 1.87 17 17 0 0 0 1.41 1.09 15 15 0 0 0 1.71 1.19 15 15 0 0 0 1.56.73c2.29.68 5.88-.52 8.53-1.45"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M572.74 375.57a6.4 6.4 0 0 0 1.92 1.76 17 17 0 0 0 1.41 1.1 16 16 0 0 0 1.71 1.14 15 15 0 0 0 1.56.73c2.34.67 5.88-.37 8.53-1.3"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M572.74 375.57a7.6 7.6 0 0 0 1.92 1.71c.42.31.89.68 1.41 1a13 13 0 0 0 1.77 1.09 8 8 0 0 0 1.5.68c2.39.73 5.82-.16 8.53-1.09"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="M572.74 375.57a8 8 0 0 0 1.92 1.66 17 17 0 0 0 1.41 1 16 16 0 0 0 1.77 1 6.6 6.6 0 0 0 1.55.67c2.34.73 5.77 0 8.48-.93"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="M572.74 375.57a9 9 0 0 0 1.92 1.56c.42.31.89.67 1.41 1a11 11 0 0 0 1.77 1 14 14 0 0 0 1.55.68c2.39.72 5.72.2 8.48-.78"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M572.74 375.52a7.6 7.6 0 0 0 1.92 1.56q.63.46 1.41.93c.57.37 1.14.63 1.77 1l1.55.62a14.56 14.56 0 0 0 8.48-.62"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M572.74 375.52a7 7 0 0 0 1.92 1.51c.42.26.89.57 1.41.88a16 16 0 0 0 1.82.94 15 15 0 0 0 1.5.57 14 14 0 0 0 8.48-.42"
          className="El_Salvador_svg__cls-53"
        />
        <path
          d="M572.74 375.52a10.2 10.2 0 0 0 1.92 1.4 14 14 0 0 0 1.46.89 18 18 0 0 0 1.77.88 11 11 0 0 0 1.5.57 14 14 0 0 0 8.48-.26"
          className="El_Salvador_svg__cls-53"
        />
        <path
          d="M572.74 375.52a11.6 11.6 0 0 0 1.92 1.35c.42.26.89.52 1.46.83a14 14 0 0 0 1.77.83 13 13 0 0 0 1.5.58 14.36 14.36 0 0 0 8.48-.11"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M572.74 375.52s7.75 6.08 15.13 3.48"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M572.43 351.61s1.51 9.72 2.08 11.12c.52 1.25 3.59 6.81 8.26 8.11"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M572.43 351.61s1.61 9.61 2.24 11c.52 1.25 3.37 6.55 8.15 8.16"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M572.48 351.56s1.66 9.56 2.29 11c.52 1.25 3.22 6.24 8.05 8.21"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M572.48 351.56s1.76 9.51 2.39 10.92a17.5 17.5 0 0 0 8 8.26"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M572.54 351.56s1.82 9.41 2.44 10.81a18.2 18.2 0 0 0 7.9 8.32"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M572.54 351.56s1.92 9.36 2.6 10.76a19 19 0 0 0 7.74 8.37"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M572.54 351.5s2 9.3 2.7 10.71a19.76 19.76 0 0 0 7.64 8.42"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M572.59 351.5s2.07 9.25 2.75 10.66 2.29 4.78 7.53 8.47"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M572.59 351.5s2.18 9.15 2.85 10.55 2.14 4.52 7.49 8.53"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M572.63 351.45s2.24 9.15 3 10.5 1.87 4.21 7.32 8.63"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M572.63 351.45s2.39 9.05 3.07 10.45 1.72 3.9 7.22 8.63"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M572.69 351.45s2.45 9 3.12 10.35 1.56 3.63 7.17 8.68"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M572.69 351.39s2.55 8.94 3.23 10.29 1.4 3.38 7.06 8.79"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M573.05 345.63s1.25 13.72 11 17.52"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M573.05 345.63a35.3 35.3 0 0 0 2.55 8.68c1.56 3.28 4.16 7 8.47 8.78"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M573.1 345.63a32.4 32.4 0 0 0 2.6 8.63c1.45 3 4 6.91 8.37 8.83"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M573.1 345.63a36 36 0 0 0 2.7 8.53c1.41 2.8 4 6.86 8.27 8.88"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M573.16 345.63a33.6 33.6 0 0 0 2.84 8.47c1.24 2.6 3.79 6.76 8.11 8.89"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M573.16 345.63a37.6 37.6 0 0 0 2.91 8.37c1.14 2.39 3.74 6.7 8 9"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M573.21 345.63a36.3 36.3 0 0 0 3 8.32c1.09 2.13 3.64 6.6 7.9 9"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M573.21 345.58a39.3 39.3 0 0 0 3.06 8.32c1 1.87 3.54 6.5 7.8 9"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M573.21 345.58a43.6 43.6 0 0 0 3.17 8.22c.93 1.71 3.43 6.44 7.69 9"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M573.27 345.58a40 40 0 0 0 3.22 8.16c.83 1.46 3.33 6.35 7.59 9.1"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M573.27 345.58c.1.32 1.71 5.51 3.38 8.06.72 1.25 3.17 6.29 7.43 9.15"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M573.32 345.58a37 37 0 0 0 3.43 8c.62 1 3.06 6.18 7.32 9.14"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M573.32 345.58c.1.37 2 5.77 3.53 7.9.57.78 3 6.14 7.22 9.25"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M573.16 341.83s2.86 11 10.81 13.73"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M573.16 341.83a29.3 29.3 0 0 0 3.69 7.7c1.72 2.54 4.21 5 7.12 6"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M573.16 341.79a30.6 30.6 0 0 0 3.74 7.64c1.82 2.59 4.37 5.19 7.07 6.13"
          className="El_Salvador_svg__cls-48"
        />
        <path
          d="M573.16 341.74a31.5 31.5 0 0 0 3.85 7.59c1.87 2.65 4.47 5.35 7 6.18"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="M573.21 341.68a31.2 31.2 0 0 0 3.9 7.59c1.92 2.65 4.62 5.45 6.86 6.23"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M573.21 341.68a32.5 32.5 0 0 0 4 7.48c2 2.71 4.73 5.62 6.81 6.29"
          className="El_Salvador_svg__cls-50"
        />
        <path
          d="M573.21 341.63a33.2 33.2 0 0 0 4 7.43c2.08 2.81 4.94 5.77 6.76 6.4"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M573.21 341.57a34 34 0 0 0 4.16 7.38c2.13 2.86 5 5.93 6.65 6.5"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M573.27 341.57a32.4 32.4 0 0 0 4.21 7.33c2.18 2.86 5.2 6 6.55 6.5"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M573.27 341.52a33.5 33.5 0 0 0 4.31 7.28c2.24 2.91 5.3 6.24 6.45 6.6"
          className="El_Salvador_svg__cls-57"
        />
        <path
          d="M573.27 341.48a35.7 35.7 0 0 0 4.36 7.22c2.29 3 5.51 6.39 6.4 6.7"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M573.27 341.42a38 38 0 0 0 4.47 7.22c2.34 3 5.61 6.5 6.29 6.7"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M573.32 341.42a38.3 38.3 0 0 0 4.52 7.12 52.7 52.7 0 0 0 6.18 6.8"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M573.32 341.37a40 40 0 0 0 4.62 7.07 72 72 0 0 0 6.13 6.91"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M573.32 341.32a44.5 44.5 0 0 0 4.67 7c2.55 3.17 6.08 7 6.08 7M594.41 356.86l5.46 1M595 361l4.88-2.07"
          className="El_Salvador_svg__cls-21"
        />
        <path d="m594.36 357 5.46.84" className="El_Salvador_svg__cls-37" />
        <path d="m594.36 357.22 5.51.68" className="El_Salvador_svg__cls-38" />
        <path d="m594.41 357.43 5.51.47" className="El_Salvador_svg__cls-30" />
        <path d="m594.41 357.63 5.59.37" className="El_Salvador_svg__cls-29" />
        <path d="m594.41 357.85 5.62.1" className="El_Salvador_svg__cls-39" />
        <path d="M594.47 358.05h5.61" className="El_Salvador_svg__cls-26" />
        <path d="m594.47 358.21 5.67-.2" className="El_Salvador_svg__cls-25" />
        <path d="m594.47 358.41 5.71-.36" className="El_Salvador_svg__cls-40" />
        <path d="m594.52 358.63 5.71-.58" className="El_Salvador_svg__cls-34" />
        <path d="m594.94 360.76 5-1.93" className="El_Salvador_svg__cls-37" />
        <path d="m594.88 360.55 5.1-1.83" className="El_Salvador_svg__cls-38" />
        <path
          d="m594.88 360.34 5.15-1.66"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="m594.83 360.13 5.25-1.56"
          className="El_Salvador_svg__cls-29"
        />
        <path d="m594.78 359.92 5.36-1.4" className="El_Salvador_svg__cls-39" />
        <path d="m594.78 359.72 5.4-1.31" className="El_Salvador_svg__cls-26" />
        <path d="m594.72 359.46 5.51-1.1" className="El_Salvador_svg__cls-25" />
        <path d="m594.67 359.25 5.62-1" className="El_Salvador_svg__cls-40" />
        <path d="m594.67 359 5.67-.83" className="El_Salvador_svg__cls-34" />
        <path d="m594.63 358.83 5.76-.73" className="El_Salvador_svg__cls-18" />
        <path
          d="M599.61 398.8s-2.91.16-3.17.26-11.85-.2-11.85-.2"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M599.67 398.85s-2.86.26-3.28.37-11.69-.32-11.69-.32"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M599.67 398.9s-2.76.36-3.33.47-11.54-.37-11.54-.37"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M599.72 399s-2.71.41-3.43.57-11.44-.52-11.44-.52"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M599.72 399s-2.6.57-3.54.73-11.22-.63-11.22-.63"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M599.72 399s-2.5.62-3.59.83-11.07-.73-11.07-.73"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M599.76 399.06s-2.44.72-3.68 1-10.92-.88-10.92-.88"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M599.76 399.12a37 37 0 0 1-3.74 1.09c-1.35.26-10.81-.94-10.81-.94"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M599.82 399.16a32 32 0 0 1-3.84 1.2c-1.51.31-10.66-1-10.66-1"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M599.82 399.21a22 22 0 0 1-3.89 1.3c-1.67.36-10.5-1.14-10.5-1.14"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M585.52 399.43s8.53 1.61 10.34 1.24a20.8 20.8 0 0 0 4-1.4"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M601.79 405.39s5.46.83 5.66.78l3.28-.21 2.65-.62"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M601.48 405.3s5.61.88 6 .78c.2-.06 3-.21 3.17-.21s2.49-.57 2.49-.57"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M601.17 405.14a58 58 0 0 0 6.34.83c.31-.05 2.86-.21 3.12-.21s2.28-.52 2.28-.52"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M600.85 405s5.88 1 6.71.89c.41-.05 2.7-.21 3-.21l2.08-.42"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M600.54 404.88s6 1.09 7 .88c.52-.1 2.6-.21 3-.26s1.87-.31 1.87-.31"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M600.23 404.72s6.19 1.2 7.38.94c.63-.11 2.39-.21 2.86-.26a14 14 0 0 0 1.66-.26"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M599.92 404.57s6.29 1.29 7.69 1c.78-.15 2.29-.26 2.81-.31s1.45-.21 1.45-.21"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M599.61 404.46s6.44 1.35 8 1a13.5 13.5 0 0 1 2.71-.32l1.3-.1"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="m602.11 405.56 5.3.73 3.38-.17 2.85-.73"
          className="El_Salvador_svg__cls-58"
        />
        <path
          d="M599.3 404.3s6.6 1.46 8.42 1.09a21.3 21.3 0 0 1 3.69-.36M625.39 405.08l5.14-1.87a5.69 5.69 0 0 0 3.59-4.42"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M625 404.05s2.08-.83 3.79-1.45c4.57-1.72 4-3.9 4-3.9"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="m624.72 404.25 4.1-1.56a12 12 0 0 0 2.13-1 5.4 5.4 0 0 0 1.61-1.46 3.1 3.1 0 0 0 .42-1.51"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M624.4 404.52s3.38-1.3 4.42-1.67a18 18 0 0 0 2.08-.93 10.4 10.4 0 0 0 1.72-1.46 7 7 0 0 0 .52-1.71"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="m624.09 404.72 4.73-1.77c.37-.1 1.82-.72 2-.83a21 21 0 0 0 1.82-1.51 11.3 11.3 0 0 0 .57-1.87"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M623.78 405s4.68-1.76 5-1.87c.16-.1 1.93-.72 2-.83a18 18 0 0 0 1.87-1.5c.1-.16.68-2 .68-2"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="m625 405.14 5.56-2.08a6.36 6.36 0 0 0 2.49-1.87 7.2 7.2 0 0 0 .94-2.39"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M624.61 405.14s5-1.82 6-2.23a7.1 7.1 0 0 0 2.34-1.77 8.9 8.9 0 0 0 .88-2.34"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M624.25 405.19s5.77-2.18 6.44-2.39a10 10 0 0 0 2.24-1.72 12 12 0 0 0 .83-2.28"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M623.88 405.19s6.49-2.44 6.86-2.55a22 22 0 0 0 2.13-1.61c.15-.26.78-2.23.78-2.23"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="m623.47 405.18 7.33-2.7 2-1.49.73-2.2"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M632 398.8s-3 .16-3.33.26-12.32-.2-12.32-.2"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M632.05 398.85s-3 .26-3.43.37-12.17-.32-12.17-.32"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M632.05 398.9s-2.86.36-3.49.47-12-.42-12-.42"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M632.05 399s-2.76.41-3.54.57-11.85-.52-11.85-.52"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M632.09 399s-2.7.57-3.63.73-11.7-.63-11.7-.63"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M632.09 399s-2.59.62-3.69.83-11.58-.73-11.58-.73"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M632.14 399.06s-2.54.72-3.79 1-11.44-.88-11.44-.88"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M632.14 399.12a36 36 0 0 1-3.9 1.09c-1.4.26-11.22-.94-11.22-.94"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M632.2 399.16a35 35 0 0 1-4 1.2c-1.56.31-11.07-1-11.07-1"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M632.2 399.21a24 24 0 0 1-4.05 1.3c-1.72.36-10.92-1.14-10.92-1.14"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M617.28 399.43s8.94 1.61 10.81 1.24a22.6 22.6 0 0 0 4.16-1.4"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M588.49 348.9c-.15-1.51-.21-3-.21-3.84.06-6.19-.77-10.87-.1-17.36.52-5.09 1.77-11.8 1.51-17.31a41 41 0 0 1 .26-4.62l25.1 28.17M578.92 394.17a6.3 6.3 0 0 1-2.18-2.65 26 26 0 0 1-1.09-4.32c-.31-1.29-.31-2.75-.63-4.1s-2.18-5.67-2.23-7.43c-.21-5.67-2.08-9.51-1.61-15.7.31-4.78 1.4-11.28.88-16.27a29 29 0 0 1 .1-4.26l28.23 18.66M634.59 398.7c.2.62-.42 1.82-.63 2.23l-.57.78c-.31.68-.26.52-.83 1-.16.11-.83.68-1 .78a3.06 3.06 0 0 1-1.3.78 40 40 0 0 0-5 1.4c-1.92.58-.88.47-2.34.84-.73.15-2.18.72-2.91.83-1.3.2-1.51.41-2.86.72a36 36 0 0 1-10.29.37c-1.4-.11-4.83-.83-6-1.67-2.13-1.5-6.81-2.07-8.88-3.53a21 21 0 0 1-1.87-1.09c-2-1.66-3.64-2.13-5.77-3.48"
          className="El_Salvador_svg__cls-13"
        />
        <path
          d="m601.07 357.12-28.64-18.71-.52.78 28.48 18.91z"
          className="El_Salvador_svg__cls-59"
        />
        <path
          d="M572 338.1c-.21-1.09.11-2.55.89-2.71a2.4 2.4 0 0 1 1-.1c.47 0 .57.16.78.52.42 1-.78 1.61-1.61 1.92-.21.06-.78.16-.88.42-.16.41 0 .26-.16.41.16-.05.21-.2.36-.31.63-.36 1.25-.46 2.14-.88a1.5 1.5 0 0 0 .31-2.08 2.68 2.68 0 0 0-2.5 0 4 4 0 0 0-.67 3.28c0-.26.41-.21.36-.52Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M571.5 338.61c-1.1-.05-2.5.42-2.55 1.2a3.5 3.5 0 0 0 0 1c0 .46.21.57.62.67 1 .31 1.51-.93 1.67-1.82 0-.2 0-.78.31-.93.41-.21.31-.11.41-.21-.05.16-.21.26-.26.36-.26.68-.31 1.36-.62 2.29a1.46 1.46 0 0 1-2 .52 2.47 2.47 0 0 1-.31-2.44 4 4 0 0 1 3.23-1.05c-.2.05-.15.46-.46.41Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M571.29 338.15a.58.58 0 0 0-.15.83c.1.26.57.31.77.2a.84.84 0 0 0 .42-1.14c-.26-.36-.67-.05-1 .11Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M565.25 334.35a19.4 19.4 0 0 0 5.46 1.25 7.1 7.1 0 0 0 .62 2.75s-2.18-.42-3.17.1c0 0-1.29-3-2.91-4.1Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M567.7 335.86a6.6 6.6 0 0 0 2.18.52 2.8 2.8 0 0 0 .26 1.09 2.6 2.6 0 0 0-1.25 0 4.8 4.8 0 0 0-1.19-1.66Z"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="M571.5 340.48s.57-1 .72-1.35c.11-.21-.05 1.2.47 1.35a6.6 6.6 0 0 1 .83 3.17 2.89 2.89 0 0 1-2.65.16c-.41-.26-.1-1 0-1.67a5.3 5.3 0 0 1 .58-1.66Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M572.07 339.7c0 .16.1.78 0 .68 0-.26.31.26.37.36a6.64 6.64 0 0 1 .72 2.86"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="M572.32 341a8 8 0 0 1 .47 2.81l.1-.11M572.27 342.1a8.5 8.5 0 0 1 .21 1.66c-.05 0-.31.21-.36.21"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="m615.83 333.21-25.57-28.43-.52.62 25.31 28.54z"
          className="El_Salvador_svg__cls-59"
        />
        <path
          d="M590.47 304.79c0-1.15.68-2.5 1.45-2.45a2.4 2.4 0 0 1 1 .11c.47.1.52.31.62.72.21 1-1.09 1.36-2 1.46-.21 0-.83-.05-1 .21s-.1.26-.26.36c.16 0 .32-.15.42-.21a24 24 0 0 1 2.34-.36c.67-.1 1.09-1.45.73-1.92a2.57 2.57 0 0 0-2.4-.57 3.86 3.86 0 0 0-1.4 3.06c0-.26.42-.16.47-.41Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M589.89 305.14c-1.09-.31-2.54-.15-2.8.58a3.2 3.2 0 0 0-.21 1 .68.68 0 0 0 .47.84c.88.52 1.66-.58 2-1.41.1-.21.26-.72.51-.83.42-.1.32 0 .42-.1 0 .15-.21.21-.31.31-.42.62-.62 1.19-1.14 2.08a1.53 1.53 0 0 1-2.08.05 2.62 2.62 0 0 1 .31-2.44 3.56 3.56 0 0 1 3.32-.32c-.2-.05-.26.37-.52.27Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M589.79 304.63c-.37.05-.42.52-.37.78a.6.6 0 0 0 .73.36c.42-.15.83-.52.67-1s-.67-.21-1-.16Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M584.85 299.53a18.4 18.4 0 0 0 4.94 2.49s-.37 2.13 0 2.81a7.2 7.2 0 0 0-3.12-.63s-.52-3.17-1.82-4.67Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M586.83 301.61a7.9 7.9 0 0 0 2 1 2.6 2.6 0 0 0 0 1.09 3 3 0 0 0-1.24-.21 4.6 4.6 0 0 0-.73-1.87Z"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="M589.43 307s.78-.84 1-1.15-.37 1.15.1 1.46a6.26 6.26 0 0 1 0 3.27 2.83 2.83 0 0 1-2.54-.52c-.37-.31.1-1 .41-1.56a4.4 4.4 0 0 1 .94-1.5Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M590.16 306.39v.62c0 .32.31.42.36.78a11.3 11.3 0 0 1-.11 2.6M590.05 307.43a7.5 7.5 0 0 1-.1 3c-.06 0 .1 0 .1-.05M589.89 309.25a4.3 4.3 0 0 0-.2 1.15c-.05-.06-.26.15-.31.1"
          className="El_Salvador_svg__cls-7"
        />
      </g>
      <g id="El_Salvador_svg__g2-2" data-name="g2">
        <path
          d="M669.61 353.27c1.77-4.41 3.64-13.46 3.53-15.54-.36-8.52-.26-11.06-1-19.8l-8.79 10a30 30 0 0 1 0 6.55 35 35 0 0 1-1.19 6.14Z"
          className="El_Salvador_svg__cls-2"
        />
        <path
          d="M662.14 340.64a35 35 0 0 0 1.19-6.14 29.8 29.8 0 0 0 0-6.54l-5.4 6 4.21 6.71ZM684.48 348.9c.15-2 .31-4.16.31-5.14 0-6.14.67-9.57 0-16.06-.52-5.09-1.77-11.8-1.51-17.31.1-1.56-.21-3.12-.26-4.62l-10.91 12.16c.77 8.73.67 11.28 1 19.8.11 2.08-1.76 11.12-3.53 15.54l2.29 3.84 12.58-8.21ZM676.83 365.38c.73-1.19 1.35-4.62 1.51-5.3a22.6 22.6 0 0 0 .26-6l-6 3.95 4.26 7.32ZM694.05 394.17a6.3 6.3 0 0 0 2.18-2.65 26 26 0 0 0 1.09-4.32c.31-1.29.31-2.75.62-4.1s2.19-5.67 2.24-7.43c.21-5.67 2.08-9.51 1.61-15.7-.31-4.78-1.4-11.28-.88-16.27a29 29 0 0 0-.11-4.26l-12.26 8c.47 8.21.26 10.49.26 18.45.05 1.92-1.67 9.71-3.74 13.2l9 15.07ZM673.67 398.7c-2.29 2.08-6.5 3.17-7.17 3.63a13.1 13.1 0 0 1-7.54 2.92c-2.8.2-4.05-.52-6.91-.89-3.27-.41.42.11-2.75-.57-1.62-.42-1.62-.68-3.8-1.2-1.61-.36-3.22-.78-4.21-2.13a3.12 3.12 0 0 1-.73-1.76h-2.18c-.21.62.42 1.82.62 2.23l.58.78c.31.68.26.52.83 1a13 13 0 0 0 1 .78 3.06 3.06 0 0 0 1.3.78 40 40 0 0 1 5 1.4c1.92.58.88.47 2.34.84.72.15 2.18.72 2.91.83 1.3.2 1.5.41 2.86.72a36 36 0 0 0 10.29.37c1.4-.11 4.83-.83 6-1.67 2.14-1.5 6.81-2.07 8.89-3.53.31-.21 1.61-.83 1.87-1.09 2-1.66 3.64-2.13 5.77-3.48Z"
          className="El_Salvador_svg__cls-9"
        />
        <path
          d="M657.19 398.7h-16.63a3 3 0 0 0 .72 1.76c1 1.35 2.6 1.77 4.21 2.13s3.49-.52 5.31-.52c4.36-1.35 4.88-2.7 6.39-3.37"
          className="El_Salvador_svg__cls-9"
        />
        <path
          d="M657.19 398.7c-1.51.78-2.24 2.08-6.39 3.37-1.62 0-3.38.73-4.89.68 1.82.42 1.87.68 3.38 1 3.17.68-.52.16 2.75.57 2.86.37 4.11 1.09 6.91.89a13.1 13.1 0 0 0 7.54-2.92c.68-.46 4.89-1.55 7.17-3.63Z"
          className="El_Salvador_svg__cls-2"
        />
        <path
          d="M682.45 312.73s-2 17.93-9 17.25"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M673.46 329.88c3.48.16 5.76-4.26 7.06-8.42a56 56 0 0 0 1.93-8.78"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M673.46 329.83c3.48-.1 5.76-4.57 7-8.47a52.5 52.5 0 0 0 2-8.73"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M673.41 329.78c3.48-.31 5.82-4.88 7-8.52a66 66 0 0 0 2.08-8.68"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M673.41 329.72c3.48-.57 5.82-5.24 6.91-8.57a64 64 0 0 0 2.13-8.68"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M673.36 329.63c3.53-.73 5.87-5.51 6.86-8.58a68 68 0 0 0 2.23-8.62"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M673.36 329.57c3.48-1 5.87-5.82 6.81-8.63a55 55 0 0 0 2.23-8.57"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M673.3 329.52c3.53-1.19 5.92-6.13 6.81-8.73a58 58 0 0 0 2.28-8.47"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M673.3 329.47c3.53-1.45 5.92-6.44 6.7-8.78a56 56 0 0 0 2.39-8.47"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M673.3 329.37c3.48-1.62 5.92-6.76 6.65-8.79a56 56 0 0 0 2.44-8.42"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M673.25 329.31c3.54-1.82 6-7.07 6.65-8.84a60 60 0 0 0 2.5-8.37"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M673.25 329.26c3.54-2.08 6-7.38 6.55-8.89a55 55 0 0 0 2.6-8.31"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M673.2 329.21c3.54-2.29 6-7.69 6.55-9a60 60 0 0 0 2.65-8.21"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M682.4 311.9a55.5 55.5 0 0 1-2.7 8.21c-.47 1-3 6.5-6.5 9"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M682.19 308.68s-5.82 14.24-9.51 12.63"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M672.68 321.3c1.61.68 4-2.18 5.92-5.5a78 78 0 0 0 3.59-7.18"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M672.68 321.26c1.4.62 3.89-2.14 5.87-5.56 2.13-3.8 3.64-7.12 3.64-7.12"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M672.68 321.21c1.19.52 3.79-2.08 5.82-5.61 2.23-4 3.64-7.07 3.64-7.07"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M672.68 321.21c1 .41 3.74-2.08 5.71-5.72 2.34-4.16 3.74-7 3.74-7"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M672.63 321.15c.83.36 3.69-2 5.72-5.77 2.39-4.37 3.74-7 3.74-7"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M672.63 321.15c.62.26 3.59-2 5.66-5.87 2.45-4.53 3.8-7 3.8-7"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M672.63 321.1c.41.21 3.48-2 5.61-5.92 2.55-4.73 3.79-6.92 3.79-6.92"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M672.63 321.1c.21 0 3.38-2 5.56-6 2.6-4.93 3.85-6.91 3.85-6.91"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="M682 308.16a61 61 0 0 0-3.9 6.86 16.2 16.2 0 0 1-5.5 6M663 335.5l-4.52-.84M663.32 330.87l-4.89 2.65"
          className="El_Salvador_svg__cls-21"
        />
        <path d="m663.43 331.08-5 2.44" className="El_Salvador_svg__cls-37" />
        <path d="m663.43 331.28-5 2.29" className="El_Salvador_svg__cls-38" />
        <path d="m663.43 331.55-5 2.08" className="El_Salvador_svg__cls-30" />
        <path d="m663.38 331.75-5 1.93" className="El_Salvador_svg__cls-29" />
        <path d="m663.38 332-5.1 1.72" className="El_Salvador_svg__cls-39" />
        <path
          d="m663.38 332.17-5.15 1.56"
          className="El_Salvador_svg__cls-26"
        />
        <path d="m663.38 332.37-5.2 1.42" className="El_Salvador_svg__cls-25" />
        <path
          d="m663.38 332.64-5.26 1.19"
          className="El_Salvador_svg__cls-40"
        />
        <path d="m663.38 332.85-5.3 1" className="El_Salvador_svg__cls-34" />
        <path d="m663.07 335.28-4.64-.67" className="El_Salvador_svg__cls-37" />
        <path d="m663.07 335-4.68-.53" className="El_Salvador_svg__cls-38" />
        <path d="m663.12 334.77-4.78-.31" className="El_Salvador_svg__cls-30" />
        <path d="m663.12 334.56-4.84-.15" className="El_Salvador_svg__cls-29" />
        <path d="M663.17 334.3h-4.94" className="El_Salvador_svg__cls-39" />
        <path d="m663.17 334-5 .21" className="El_Salvador_svg__cls-26" />
        <path d="m663.17 333.83-5 .31" className="El_Salvador_svg__cls-25" />
        <path d="m663.23 333.57-5.2.53" className="El_Salvador_svg__cls-40" />
        <path d="M663.23 333.32 658 334" className="El_Salvador_svg__cls-34" />
        <path
          d="m663.27 333.1-5.35.84M684.48 334.41s-.26 3.79-1.1 5.4c-1.19 2.24-4.67 5.67-8.67 8.16"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M674.61 348a32.8 32.8 0 0 0 6.54-5.56 16.4 16.4 0 0 0 2.08-2.71 21.4 21.4 0 0 0 1.2-5.4"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M674.5 348a32.3 32.3 0 0 0 6.5-5.7 11 11 0 0 0 2-2.75 19.6 19.6 0 0 0 1.4-5.35"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M674.45 348a37.7 37.7 0 0 0 6.39-5.72 15 15 0 0 0 2-2.81 21.1 21.1 0 0 0 1.56-5.35"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M674.34 347.92a37.4 37.4 0 0 0 6.39-5.77 16 16 0 0 0 2-2.81 22.4 22.4 0 0 0 1.72-5.35"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M674.25 347.92a40 40 0 0 0 6.34-5.87 15.4 15.4 0 0 0 2-2.81 23 23 0 0 0 1.82-5.35"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M674.14 347.92a42.3 42.3 0 0 0 6.29-6 18.7 18.7 0 0 0 2-2.8 25.4 25.4 0 0 0 2-5.36"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M674.09 347.92a50 50 0 0 0 6.19-6.08 17 17 0 0 0 2-2.81 27.4 27.4 0 0 0 2.13-5.35"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M674 347.87a42.6 42.6 0 0 0 6.14-6.13 18 18 0 0 0 2-2.81 31 31 0 0 0 2.29-5.35"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M673.87 347.87a44 44 0 0 0 6.09-6.24 16 16 0 0 0 2-2.8 34.4 34.4 0 0 0 2.39-5.36"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M673.83 347.87c2.39-1.82 4.67-4.94 6-6.34a19.5 19.5 0 0 0 2-2.81 49 49 0 0 0 2.55-5.35"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M673.72 347.87c2.39-1.87 4.68-5 5.92-6.39a23 23 0 0 0 2-2.86c1.35-2.29 2.7-5.35 2.7-5.35"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M673.61 347.81c2.39-1.87 4.68-5.14 5.87-6.44a19.4 19.4 0 0 0 1.93-2.86c1.45-2.39 2.91-5.35 2.91-5.35"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M684.32 333.05s-3.38 6.4-5 8.22c-1.14 1.24-3.43 4.67-5.82 6.54"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M684.22 348.9c-3.69 2.44-4.62 3.07-12.26 8l-2.34-3.58s.88-2.13 1.25-3.12"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M684.16 348.85c-3.53 2.4-4.72 3.17-12.21 7.85l-.1-.1c0-.05-2.08-3.48-2.08-3.48a5 5 0 0 1 .36-.94c.26-.67.57-1.45.73-2"
          className="El_Salvador_svg__cls-41"
        />
        <path
          d="M684.16 348.85c-3.43 2.29-4.93 3.28-12.21 7.75l-.1-.16c0-.1-2-3.48-2-3.48s.11-.36.31-.88.52-1.41.68-1.93"
          className="El_Salvador_svg__cls-42"
        />
        <path
          d="M684.16 348.85c-3.32 2.19-5.14 3.33-12.21 7.59l-.1-.15c0-.11-1.87-3.43-1.82-3.43a3.4 3.4 0 0 1 .26-.84c.21-.62.47-1.35.62-1.87"
          className="El_Salvador_svg__cls-43"
        />
        <path
          d="M684.16 348.81c-3.22 2.13-5.35 3.43-12.21 7.48l-.1-.16c0-.15-1.72-3.43-1.72-3.43a2.1 2.1 0 0 1 .21-.78 9.4 9.4 0 0 0 .57-1.76"
          className="El_Salvador_svg__cls-44"
        />
        <path
          d="M684.12 348.81c-3.07 2-5.51 3.53-12.16 7.32-.06 0-.11-.15-.11-.15 0-.21-1.61-3.38-1.61-3.43a6 6 0 0 1 .21-.73 12 12 0 0 0 .47-1.66"
          className="El_Salvador_svg__cls-45"
        />
        <path
          d="M684.12 348.75c-3 2-5.72 3.63-12.22 7.22 0 0 0-.16-.1-.16 0-.25-1.46-3.37-1.41-3.37a1.6 1.6 0 0 1 .11-.73 5.6 5.6 0 0 0 .41-1.56"
          className="El_Salvador_svg__cls-46"
        />
        <path
          d="M684.12 348.75a139 139 0 0 1-12.22 7.06l-.1-.15c0-.26-1.3-3.33-1.3-3.38s-.11-.21.1-.62a6 6 0 0 0 .37-1.51"
          className="El_Salvador_svg__cls-47"
        />
        <path
          d="M684.12 348.75a135 135 0 0 1-12.22 7 .8.8 0 0 0-.1-.21c0-.31-1.2-3.32-1.15-3.38s-.15-.15 0-.57a5.1 5.1 0 0 0 .32-1.4"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M684.07 348.7a110 110 0 0 1-12.16 6.86c0-.05-.11-.16-.11-.21 0-.36-1-3.33-1-3.33s-.15-.15 0-.57a2.8 2.8 0 0 0 .21-1.3"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M684.07 348.7a97.6 97.6 0 0 1-12.16 6.7.34.34 0 0 1-.11-.2c0-.42-.93-3.28-.88-3.33a.39.39 0 0 1-.1-.52 2.5 2.5 0 0 0 .15-1.2"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M684.07 348.7a95 95 0 0 1-12.16 6.55c-.06-.05-.11-.16-.16-.21 0-.42-.78-3.28-.73-3.28s-.26-.15-.1-.51a2.5 2.5 0 0 0 .1-1.1"
          className="El_Salvador_svg__cls-48"
        />
        <path
          d="M684 348.65a81.5 81.5 0 0 1-12.11 6.45c0-.06-.11-.16-.16-.21 0-.47-.62-3.22-.57-3.28a.32.32 0 0 1-.21-.41c.21-.42.11-.57.06-1"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M684 348.65a75.3 75.3 0 0 1-12.11 6.29s-.16-.16-.16-.21c0-.52-.52-3.22-.46-3.27s-.37-.06-.21-.37 0-.46-.05-.93"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M684 348.65a76 76 0 0 1-12.16 6.19c0-.06-.11-.21-.11-.26 0-.52-.41-3.18-.36-3.23s-.41-.05-.31-.36 0-.36-.1-.83"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M684 348.59a64.7 64.7 0 0 1-12.16 6.08.5.5 0 0 1-.11-.26c0-.57-.26-3.17-.2-3.22l-.32-.31c.16-.31-.05-.31-.2-.73"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M684 348.59a58.4 58.4 0 0 1-12.11 5.93.6.6 0 0 1-.1-.26c0-.63-.16-3.18-.11-3.23s-.46.05-.36-.2-.1-.26-.21-.68"
          className="El_Salvador_svg__cls-50"
        />
        <path
          d="M684 348.54a53.2 53.2 0 0 1-12.11 5.82c-.05-.05-.1-.2-.15-.26 0-.67 0-3.12.1-3.17s-.52.05-.42-.2-.15-.16-.31-.57"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M684 348.54c-1.56 1-8 4.68-12.11 5.67-.05 0-.1-.21-.15-.26 0-.68.15-3.12.2-3.17s-.52.1-.46-.16-.16-.05-.37-.47"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M684 348.54c-1.45.94-8.16 4.78-12.11 5.51a.42.42 0 0 1-.15-.26 19.7 19.7 0 0 1 .36-3.17s-.62.16-.52-.1-.26.05-.47-.36"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M683.91 348.49c-1.3.89-8.31 4.89-12.06 5.46-.05-.1-.15-.21-.15-.31a20.4 20.4 0 0 1 .47-3.12s-.63.11-.52 0-.31.1-.52-.31"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M683.91 348.49c-1.19.78-8.52 5-12.06 5.31a.47.47 0 0 1-.15-.32 14.4 14.4 0 0 1 .62-3.11s-.67.15-.62 0-.36.15-.57-.21"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M683.91 348.49c-1.09.68-8.73 5.05-12.11 5.15l-.15-.31a14.3 14.3 0 0 1 .78-3.12s-.73.21-.63.05-.41.26-.67-.1"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M683.85 348.43c-.93.63-8.88 5.15-12.05 5.05a1.4 1.4 0 0 1-.16-.32 11.8 11.8 0 0 1 .88-3.06h.06s-.78.2-.73 0-.42.36-.73 0"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M683.85 348.43c-.83.58-9.09 5.25-12.05 4.89a.55.55 0 0 1-.16-.31 9.5 9.5 0 0 1 1-3.07s-.78.26-.73.16-.52.41-.83 0"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M683.85 348.43c-.72.47-9.3 5.31-12.05 4.73a.52.52 0 0 1-.16-.31 8.3 8.3 0 0 1 1.14-3s-.83.31-.78.21-.52.51-.83.15"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M683.85 348.39c-.62.41-9.51 5.4-12.05 4.67a.5.5 0 0 1-.16-.36 7.9 7.9 0 0 1 1.3-3s-.88.31-.83.21-.57.62-.94.26"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M683.8 348.39c-.46.31-9.66 5.51-12 4.52a1.4 1.4 0 0 1-.21-.37 7.9 7.9 0 0 1 1.46-3s-.89.36-.89.26-.62.73-1 .36"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M683.8 348.39c-.36.21-9.82 5.56-12 4.36a1.4 1.4 0 0 1-.21-.36c0-1 1.51-2.91 1.61-3s-1 .36-.93.31-.68.73-1.09.41"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M683.8 348.33c-.26.15-10 5.66-12 4.26a.9.9 0 0 1-.21-.37c0-1.09 1.61-2.85 1.72-3a8 8 0 0 1-1 .37c0-.06-.73.83-1.09.52"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="M683.8 348.33c-.15.05-10.23 5.77-12 4.1 0-.1-.16-.21-.16-.36 0-1.14 1.72-2.86 1.87-3l-1 .41s-.77.94-1.19.63"
          className="El_Salvador_svg__cls-53"
        />
        <path
          d="M683.74 348.28s-11.64 6.55-12.16 3.64c0-1.2 2-2.91 2-2.91l-1.09.41s-.78 1-1.25.73"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="m685.1 379.1 9 15.07a6.25 6.25 0 0 0 2.19-2.65 36 36 0 0 0 1.09-4.31c.25-1.3.31-2.76.57-4.11s2.23-5.66 2.28-7.43"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M700.27 375.67c0 1.77-2 6-2.28 7.33s-.31 2.81-.57 4.11a27 27 0 0 1-1.15 4.26 6.14 6.14 0 0 1-2.13 2.65s-9-14.92-9-14.92"
          className="El_Salvador_svg__cls-17"
        />
        <path
          d="M700.27 375.67c0 1.72-2 5.93-2.23 7.28s-.36 2.76-.68 4.05a26.6 26.6 0 0 1-1.09 4.26 6.6 6.6 0 0 1-2.13 2.6s-8.94-14.71-9-14.76"
          className="El_Salvador_svg__cls-41"
        />
        <path
          d="M700.27 375.67c0 1.72-1.92 5.88-2.23 7.23s-.36 2.7-.68 4a26.5 26.5 0 0 1-1.09 4.21 6.5 6.5 0 0 1-2.13 2.55c-.1 0-8.94-14.5-9-14.56"
          className="El_Salvador_svg__cls-41"
        />
        <path
          d="M700.27 375.67c0 1.67-1.92 5.82-2.23 7.12s-.36 2.71-.68 4a32 32 0 0 1-1.09 4.15 6.5 6.5 0 0 1-2.13 2.55c-.15.05-8.89-14.34-9-14.4"
          className="El_Salvador_svg__cls-54"
        />
        <path
          d="M700.27 375.67c0 1.67-1.92 5.77-2.23 7.07s-.36 2.71-.68 3.95a25.4 25.4 0 0 1-1.14 4.11 6.1 6.1 0 0 1-2.13 2.54c-.1.06-8.78-14.19-9-14.24"
          className="El_Salvador_svg__cls-54"
        />
        <path
          d="M700.27 375.67c0 1.67-1.87 5.67-2.23 7s-.36 2.7-.68 3.95a24.5 24.5 0 0 1-1.14 4.05 6.1 6.1 0 0 1-2.13 2.55c-.16.05-8.78-14-9-14.09"
          className="El_Salvador_svg__cls-42"
        />
        <path
          d="M700.27 375.67c0 1.62-1.87 5.62-2.23 6.92s-.36 2.65-.68 3.89a28 28 0 0 1-1.14 4 5.6 5.6 0 0 1-2.13 2.5c-.21.1-8.73-13.77-9-13.88"
          className="El_Salvador_svg__cls-42"
        />
        <path
          d="M700.27 375.67c0 1.62-1.87 5.56-2.23 6.86s-.36 2.6-.68 3.85a25.5 25.5 0 0 1-1.19 4 6.4 6.4 0 0 1-2.08 2.44c-.21.06-8.73-13.61-9-13.72"
          className="El_Salvador_svg__cls-43"
        />
        <path
          d="M700.27 375.67c0 1.56-1.87 5.51-2.23 6.76s-.36 2.6-.68 3.85a23.6 23.6 0 0 1-1.19 3.94 6.5 6.5 0 0 1-2.08 2.45c-.26.05-8.68-13.46-9-13.57"
          className="El_Salvador_svg__cls-43"
        />
        <path
          d="M700.27 375.67c0 1.56-1.81 5.46-2.23 6.71s-.36 2.55-.73 3.79a23.7 23.7 0 0 1-1.14 3.9 6.5 6.5 0 0 1-2.08 2.44c-.31.05-8.63-13.3-9-13.41"
          className="El_Salvador_svg__cls-43"
        />
        <path
          d="M700.27 375.67c0 1.56-1.81 5.36-2.23 6.66s-.36 2.54-.73 3.69a28 28 0 0 1-1.14 3.89 5.9 5.9 0 0 1-2.08 2.39c-.31.11-8.63-13.09-9-13.2"
          className="El_Salvador_svg__cls-44"
        />
        <path
          d="M700.27 375.67c0 1.51-1.81 5.31-2.23 6.55s-.36 2.55-.73 3.69a20.6 20.6 0 0 1-1.19 3.85 6.4 6.4 0 0 1-2 2.39c-.36.1-8.58-12.89-9-13"
          className="El_Salvador_svg__cls-44"
        />
        <path
          d="M700.27 375.67c0 1.51-1.81 5.25-2.23 6.5s-.36 2.5-.73 3.64a23.5 23.5 0 0 1-1.19 3.84A6.1 6.1 0 0 1 694 392c-.36.11-8.47-12.73-8.94-12.88"
          className="El_Salvador_svg__cls-45"
        />
        <path
          d="M700.27 375.67c0 1.46-1.76 5.2-2.23 6.45-.31 1.19-.36 2.44-.73 3.59a28 28 0 0 1-1.19 3.79 6.7 6.7 0 0 1-2.08 2.34c-.36.1-8.47-12.58-8.94-12.73"
          className="El_Salvador_svg__cls-45"
        />
        <path
          d="M700.27 375.67c0 1.46-1.76 5.15-2.23 6.34-.31 1.2-.42 2.45-.73 3.59a30 30 0 0 1-1.19 3.74 6.4 6.4 0 0 1-2.08 2.29c-.42.16-8.42-12.37-8.94-12.52"
          className="El_Salvador_svg__cls-55"
        />
        <path
          d="M700.27 375.67c0 1.41-1.76 5.05-2.23 6.29-.31 1.2-.42 2.39-.73 3.54a21.3 21.3 0 0 1-1.24 3.69 5.9 5.9 0 0 1-2 2.28c-.47.16-8.42-12.21-8.94-12.36"
          className="El_Salvador_svg__cls-55"
        />
        <path
          d="M700.27 375.61c0 1.46-1.76 5.05-2.18 6.29s-.47 2.39-.78 3.49a20.4 20.4 0 0 1-1.24 3.63 6.26 6.26 0 0 1-2 2.29c-.47.16-8.37-12-8.94-12.21"
          className="El_Salvador_svg__cls-46"
        />
        <path
          d="M700.27 375.61c0 1.46-1.71 5-2.18 6.19s-.47 2.39-.78 3.48c-.57 1.87-.57 1.87-1.24 3.64a6 6 0 0 1-2 2.18c-.52.16-8.32-11.79-8.94-12"
          className="El_Salvador_svg__cls-46"
        />
        <path
          d="M700.27 375.61c0 1.41-1.71 4.94-2.18 6.14-.31 1.14-.47 2.34-.83 3.43a20.5 20.5 0 0 1-1.25 3.58 5.8 5.8 0 0 1-2 2.19c-.57.15-8.32-11.64-8.94-11.85"
          className="El_Salvador_svg__cls-46"
        />
        <path
          d="M700.27 375.61c0 1.41-1.71 4.84-2.18 6.08-.31 1.1-.47 2.29-.83 3.38a20.4 20.4 0 0 1-1.25 3.54 6.2 6.2 0 0 1-2 2.18c-.57.16-8.27-11.48-8.94-11.69"
          className="El_Salvador_svg__cls-47"
        />
        <path
          d="M700.27 375.61c0 1.36-1.71 4.79-2.18 6-.31 1.15-.47 2.29-.83 3.38a24 24 0 0 1-1.25 3.48 6 6 0 0 1-2 2.19c-.58.15-8.22-11.33-8.89-11.54"
          className="El_Salvador_svg__cls-47"
        />
        <path
          d="M700.27 375.61c0 1.36-1.66 4.73-2.18 5.93-.31 1.09-.47 2.23-.83 3.33a24.6 24.6 0 0 1-1.26 3.43 6.2 6.2 0 0 1-2 2.13c-.63.21-8.16-11.07-8.89-11.33"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M700.27 375.61c0 1.36-1.66 4.68-2.18 5.88-.31 1-.47 2.23-.83 3.27a20.7 20.7 0 0 1-1.3 3.43 5.8 5.8 0 0 1-2 2.08c-.63.21-8.11-10.91-8.89-11.17"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M700.27 375.61c0 1.3-1.66 4.63-2.18 5.77-.31 1.09-.47 2.24-.83 3.28A19 19 0 0 1 696 388a5.9 5.9 0 0 1-2 2.08c-.68.2-8.11-10.76-8.89-11"
          className="El_Salvador_svg__cls-56"
        />
        <path
          d="M700.27 375.61c0 1.3-1.66 4.53-2.18 5.72-.31 1-.47 2.18-.83 3.22a25 25 0 0 1-1.3 3.33 6.3 6.3 0 0 1-2 2.08c-.73.21-8.06-10.6-8.89-10.86"
          className="El_Salvador_svg__cls-56"
        />
        <path
          d="M700.27 375.61c0 1.25-1.61 4.47-2.18 5.67-.31 1-.47 2.13-.83 3.17a29 29 0 0 1-1.3 3.27 5.66 5.66 0 0 1-2 2c-.73.26-8-10.39-8.89-10.65"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M700.27 375.61c0 1.25-1.61 4.42-2.18 5.56-.31 1-.47 2.14-.88 3.18a19 19 0 0 1-1.3 3.22 6.06 6.06 0 0 1-1.92 2c-.78.26-8-10.24-8.89-10.55"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M700.27 375.61c0 1.25-1.61 4.37-2.18 5.51a31 31 0 0 1-.88 3.07 19.3 19.3 0 0 1-1.3 3.22 6 6 0 0 1-1.92 2c-.84.21-8-10-8.89-10.39"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M700.27 375.61c0 1.2-1.61 4.32-2.18 5.46a30 30 0 0 1-.88 3 21.7 21.7 0 0 1-1.3 3.22 6.4 6.4 0 0 1-2 2c-.78.21-7.9-9.87-8.83-10.23"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M700.27 375.61c0 1.2-1.55 4.21-2.18 5.36a30 30 0 0 1-.88 3 20.7 20.7 0 0 1-1.3 3.17 5.86 5.86 0 0 1-2 1.93c-.83.26-7.84-9.67-8.83-10"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M700.27 375.61c0 1.15-1.55 4.16-2.18 5.31-.31 1-.52 2-.88 3a16.6 16.6 0 0 1-1.35 3.12 5.3 5.3 0 0 1-1.93 1.92c-.88.26-7.79-9.51-8.83-9.87"
          className="El_Salvador_svg__cls-48"
        />
        <path
          d="M700.27 375.61c0 1.15-1.55 4.11-2.13 5.25-.36.94-.57 2-.93 2.91a20.7 20.7 0 0 1-1.35 3.07 6.1 6.1 0 0 1-1.93 1.92c-.88.26-7.79-9.35-8.83-9.71"
          className="El_Salvador_svg__cls-48"
        />
        <path
          d="M700.23 375.61c0 1.15-1.46 4.06-2.08 5.15-.37 1-.57 2-.94 2.91a19 19 0 0 1-1.35 3 6 6 0 0 1-1.92 1.88c-.94.31-7.75-9.1-8.84-9.51"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M700.23 375.61c0 1.1-1.46 4-2.08 5.1-.37.93-.57 1.92-.94 2.86a19.7 19.7 0 0 1-1.4 3 5.6 5.6 0 0 1-1.87 1.82c-1 .31-7.69-8.94-8.84-9.35"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M700.23 375.61c0 1.1-1.46 3.9-2.08 5-.37.94-.57 2-.94 2.86a19 19 0 0 1-1.4 3 5.65 5.65 0 0 1-1.87 1.81c-1 .32-7.69-8.78-8.84-9.19"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="M700.23 375.61c0 1-1.46 3.85-2.08 4.94-.37.94-.57 1.92-1 2.81a18.4 18.4 0 0 1-1.35 2.91 6.3 6.3 0 0 1-1.87 1.82c-1 .31-7.64-8.63-8.84-9"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="M700.23 375.61c0 1-1.41 3.8-2.08 4.89-.37.88-.57 1.87-1 2.75a17.4 17.4 0 0 1-1.35 2.86 5.65 5.65 0 0 1-1.92 1.77c-1 .36-7.59-8.42-8.79-8.83"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="M700.23 375.61c0 1-1.41 3.75-2.08 4.79-.37.93-.57 1.87-1 2.75a14.2 14.2 0 0 1-1.4 2.81 5.15 5.15 0 0 1-1.87 1.76c-1 .32-7.54-8.21-8.79-8.67"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M700.23 375.61c0 1-1.41 3.69-2.08 4.73-.37.89-.57 1.82-1 2.71a21 21 0 0 1-1.4 2.8 5.9 5.9 0 0 1-1.87 1.72c-1.1.31-7.49-8.06-8.79-8.52"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M700.23 375.61c0 1-1.41 3.59-2.08 4.68-.37.88-.57 1.77-1 2.65a20.4 20.4 0 0 1-1.4 2.76 6.5 6.5 0 0 1-1.87 1.71c-1.15.31-7.49-7.9-8.79-8.36"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M700.23 375.61c0 .94-1.35 3.54-2.08 4.58-.37.88-.57 1.82-1 2.65a17 17 0 0 1-1.4 2.7 5.6 5.6 0 0 1-1.87 1.66c-1.15.37-7.44-7.69-8.79-8.15"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M700.23 375.61c0 .94-1.35 3.49-2.08 4.53-.37.83-.57 1.76-1 2.6a15.7 15.7 0 0 1-1.45 2.65 6.2 6.2 0 0 1-1.82 1.66c-1.2.36-7.44-7.54-8.79-8"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M700.23 375.61c0 .89-1.35 3.44-2.08 4.47-.37.84-.57 1.72-1 2.55a22 22 0 0 1-1.45 2.6 6.2 6.2 0 0 1-1.82 1.66c-1.25.37-7.38-7.33-8.79-7.84"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M700.23 375.61c0 .89-1.35 3.38-2.08 4.37-.37.83-.57 1.71-1 2.55-.57 1.24-.78 1.35-1.45 2.6a6.2 6.2 0 0 1-1.88 1.61c-1.19.36-7.27-7.18-8.73-7.69"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M700.23 375.61c0 .89-1.3 3.28-2.08 4.32a26 26 0 0 1-1 2.49 18 18 0 0 1-1.4 2.55 5.4 5.4 0 0 1-1.88 1.56c-1.24.41-7.27-7-8.73-7.48"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M700.23 375.61c0 .84-1.3 3.23-2.08 4.27a25 25 0 0 1-1 2.39 15 15 0 0 1-1.46 2.54 6.1 6.1 0 0 1-1.82 1.56c-1.3.42-7.22-6.81-8.73-7.32"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M700.23 375.61c0 .84-1.3 3.18-2 4.16-.36.78-.68 1.66-1.09 2.39a15 15 0 0 1-1.46 2.5 6.3 6.3 0 0 1-1.82 1.56c-1.3.41-7.17-6.66-8.73-7.17"
          className="El_Salvador_svg__cls-50"
        />
        <path
          d="M700.23 375.61c0 .78-1.3 3.12-2 4.11-.36.78-.68 1.61-1.09 2.34a14.3 14.3 0 0 1-1.46 2.44 6.3 6.3 0 0 1-1.82 1.56c-1.35.37-7.17-6.44-8.73-7"
          className="El_Salvador_svg__cls-50"
        />
        <path
          d="M700.23 375.61a11.4 11.4 0 0 1-2 4.06c-.36.73-.68 1.56-1.09 2.28a13.5 13.5 0 0 1-1.51 2.45 5.1 5.1 0 0 1-1.77 1.45c-1.4.42-7.12-6.23-8.73-6.8"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M700.23 375.61c0 .78-1.25 3-2 3.95-.36.78-.68 1.56-1.09 2.29a16.5 16.5 0 0 1-1.51 2.39 5.1 5.1 0 0 1-1.77 1.46c-1.4.41-7.12-6.08-8.73-6.65"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M700.23 375.57c0 .78-1.25 3-2 3.95-.36.72-.68 1.5-1.09 2.23a17.7 17.7 0 0 1-1.51 2.34 5.9 5.9 0 0 1-1.77 1.46c-1.45.41-7.07-5.93-8.73-6.5"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M700.23 375.57c0 .78-1.25 2.91-2 3.89-.36.73-.68 1.46-1.09 2.19a21 21 0 0 1-1.51 2.28 5.1 5.1 0 0 1-1.82 1.41c-1.45.47-7-5.72-8.68-6.29"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M700.23 375.57a9.8 9.8 0 0 1-2 3.79 17 17 0 0 1-1.14 2.18 12.6 12.6 0 0 1-1.51 2.24 5.1 5.1 0 0 1-1.77 1.4c-1.45.47-7-5.51-8.68-6.13"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M700.23 375.57c0 .72-1.2 2.75-2 3.74a23 23 0 0 1-1.14 2.13 14 14 0 0 1-1.51 2.18 5.14 5.14 0 0 1-1.77 1.41c-1.51.46-6.91-5.36-8.68-6"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M700.23 375.57c0 .72-1.2 2.7-2 3.69a21 21 0 0 1-1.14 2.07 14.3 14.3 0 0 1-1.51 2.19 5.6 5.6 0 0 1-1.77 1.35c-1.56.47-6.91-5.2-8.68-5.82"
          className="El_Salvador_svg__cls-27"
        />
        <path
          d="M700.23 375.57a8.85 8.85 0 0 1-2 3.58 20 20 0 0 1-1.14 2.08 17 17 0 0 1-1.51 2.13 6 6 0 0 1-1.77 1.3c-1.56.52-6.86-5-8.68-5.61"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M700.23 375.57a8.7 8.7 0 0 1-2 3.53 21 21 0 0 1-1.14 2 15.7 15.7 0 0 1-1.56 2.08 5.3 5.3 0 0 1-1.72 1.3c-1.61.52-6.81-4.84-8.68-5.46"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M700.23 375.57a9 9 0 0 1-2 3.48c-.36.62-.68 1.3-1.14 2a12 12 0 0 1-1.56 2 5.3 5.3 0 0 1-1.72 1.3c-1.66.52-6.81-4.68-8.68-5.3"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M700.23 375.57a8.7 8.7 0 0 1-2 3.38 20 20 0 0 1-1.14 2 19 19 0 0 1-1.56 2 6.6 6.6 0 0 1-1.72 1.3c-1.66.46-6.76-4.47-8.68-5.15"
          className="El_Salvador_svg__cls-28"
        />
        <path
          d="M700.23 375.57a7.84 7.84 0 0 1-2 3.32 20 20 0 0 1-1.14 1.93c-.57.93-.94 1.09-1.56 2a5.7 5.7 0 0 1-1.77 1.2c-1.66.52-6.65-4.26-8.63-4.94"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M700.23 375.57a8 8 0 0 1-2 3.27c-.36.57-.68 1.25-1.14 1.87-.57.89-.94 1-1.61 1.93a5.9 5.9 0 0 1-1.72 1.19c-1.72.52-6.65-4.1-8.63-4.78"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M700.23 375.57a7.9 7.9 0 0 1-2 3.17c-.41.62-.78 1.24-1.25 1.87a13.4 13.4 0 0 1-1.55 1.87 5.7 5.7 0 0 1-1.72 1.2c-1.72.52-6.6-3.95-8.63-4.68"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M700.23 375.57a8.1 8.1 0 0 1-2 3.12c-.41.57-.78 1.19-1.25 1.76a10.6 10.6 0 0 1-1.55 1.87 6.4 6.4 0 0 1-1.72 1.2c-1.77.52-6.6-3.79-8.63-4.52"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M700.23 375.57a7.3 7.3 0 0 1-2 3 20 20 0 0 1-1.25 1.77 10.6 10.6 0 0 1-1.61 1.82 4.5 4.5 0 0 1-1.66 1.14c-1.82.57-6.55-3.53-8.63-4.31"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M700.23 375.57a7.2 7.2 0 0 1-2 3 19 19 0 0 1-1.25 1.71 12.4 12.4 0 0 1-1.61 1.82 5.1 5.1 0 0 1-1.66 1.1c-1.82.57-6.5-3.38-8.63-4.16"
          className="El_Salvador_svg__cls-57"
        />
        <path
          d="M700.23 375.57a7.55 7.55 0 0 1-2 2.91c-.41.52-.78 1.14-1.25 1.66a12.6 12.6 0 0 1-1.61 1.77 8.3 8.3 0 0 1-1.66 1.09c-1.87.57-6.5-3.22-8.63-4"
          className="El_Salvador_svg__cls-57"
        />
        <path
          d="M700.23 375.57a7 7 0 0 1-2 2.8A17 17 0 0 1 697 380a22 22 0 0 1-1.61 1.71 8 8 0 0 1-1.66 1.09c-1.92.58-6.45-3.06-8.63-3.84"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M700.23 375.57a6.7 6.7 0 0 1-2 2.75c-.41.52-.78 1.09-1.25 1.61a12.5 12.5 0 0 1-1.66 1.67 5.1 5.1 0 0 1-1.66 1c-1.93.62-6.34-2.86-8.58-3.64"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M700.23 375.57a7 7 0 0 1-2 2.7c-.41.52-.78 1-1.25 1.56a16 16 0 0 1-1.66 1.61 5.6 5.6 0 0 1-1.66 1c-1.93.57-6.34-2.65-8.58-3.48"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M700.23 375.57a6.55 6.55 0 0 1-2 2.6 16 16 0 0 1-1.3 1.55 11.7 11.7 0 0 1-1.61 1.62 6.6 6.6 0 0 1-1.66 1c-2 .58-6.29-2.49-8.58-3.32"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M700.23 375.57a6.8 6.8 0 0 1-2 2.54 16 16 0 0 1-1.3 1.51 22 22 0 0 1-1.61 1.56 6.8 6.8 0 0 1-1.66.94c-2 .62-6.29-2.29-8.58-3.12"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M700.23 375.57a6.2 6.2 0 0 1-2 2.49 16 16 0 0 1-1.3 1.46 13 13 0 0 1-1.66 1.51 6.4 6.4 0 0 1-1.61.93c-2 .62-6.24-2.13-8.58-3"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M700.23 375.57a6.1 6.1 0 0 1-2 2.39 10 10 0 0 1-1.3 1.45 16.4 16.4 0 0 1-1.66 1.46 7 7 0 0 1-1.61.93c-2.08.63-6.19-2-8.58-2.8"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M700.23 375.57a6.55 6.55 0 0 1-2 2.34 11 11 0 0 1-1.3 1.4 15 15 0 0 1-1.66 1.4 7.1 7.1 0 0 1-1.61.94c-2.13.62-6.19-1.77-8.58-2.65"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M700.23 375.57a6.9 6.9 0 0 1-2 2.28 13 13 0 0 1-1.3 1.35 20 20 0 0 1-1.66 1.36 5.7 5.7 0 0 1-1.61.88c-2.13.68-6.14-1.56-8.58-2.44"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M700.23 375.57a5.9 5.9 0 0 1-2 2.18 10 10 0 0 1-1.3 1.35c-.57.57-1 .78-1.71 1.35a7.6 7.6 0 0 1-1.61.83c-2.14.68-6.09-1.4-8.53-2.28"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M700.23 375.57a6.1 6.1 0 0 1-1.93 2.13c-.41.41-.88.83-1.35 1.3s-1 .78-1.71 1.3a8 8 0 0 1-1.61.83c-2.19.67-6-1.25-8.53-2.13"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M700.23 375.57a6.7 6.7 0 0 1-1.93 2.08c-.41.36-.88.83-1.35 1.24s-1.09.73-1.71 1.25a8 8 0 0 1-1.61.83c-2.19.68-6-1.09-8.53-2"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M700.23 375.57a6.9 6.9 0 0 1-1.93 2 16 16 0 0 1-1.4 1.25 15 15 0 0 1-1.71 1.19 5.2 5.2 0 0 1-1.56.78c-2.24.68-6-.83-8.53-1.76"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M700.23 375.57a6.7 6.7 0 0 1-1.93 1.92 16 16 0 0 1-1.4 1.14 8.7 8.7 0 0 1-1.71 1.2 9 9 0 0 1-1.56.78c-2.29.67-5.93-.68-8.53-1.61"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M700.23 375.57a6.9 6.9 0 0 1-1.93 1.87 36 36 0 0 1-3.11 2.28 15 15 0 0 1-1.56.73c-2.29.68-5.88-.52-8.53-1.45"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M700.23 375.57a6.3 6.3 0 0 1-1.93 1.76 16 16 0 0 1-1.4 1.1 16 16 0 0 1-1.71 1.14 15 15 0 0 1-1.56.73c-2.34.67-5.88-.37-8.53-1.3"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M700.23 375.57a7.5 7.5 0 0 1-1.93 1.71c-.41.31-.88.68-1.4 1a13 13 0 0 1-1.77 1.09 8 8 0 0 1-1.5.68c-2.39.73-5.82-.16-8.53-1.09"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="M700.23 375.57a7.9 7.9 0 0 1-1.93 1.66 15 15 0 0 1-1.4 1 16 16 0 0 1-1.77 1 6.5 6.5 0 0 1-1.56.67c-2.33.73-5.76 0-8.47-.93"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="M700.23 375.57a9 9 0 0 1-1.93 1.56 15 15 0 0 1-1.4 1 11 11 0 0 1-1.77 1 14 14 0 0 1-1.56.68c-2.39.72-5.71.2-8.47-.78"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M700.23 375.52a7.5 7.5 0 0 1-1.93 1.56 16 16 0 0 1-1.4.93c-.57.37-1.14.63-1.77 1l-1.56.62a14.53 14.53 0 0 1-8.47-.62"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M700.23 375.52a6.9 6.9 0 0 1-1.93 1.48c-.41.26-.88.57-1.4.88a16 16 0 0 1-1.82.94 16 16 0 0 1-1.51.57 14 14 0 0 1-8.47-.42"
          className="El_Salvador_svg__cls-53"
        />
        <path
          d="M700.23 375.52a10 10 0 0 1-1.93 1.4 13 13 0 0 1-1.45.89 18 18 0 0 1-1.77.88 12 12 0 0 1-1.51.57 13.93 13.93 0 0 1-8.47-.26"
          className="El_Salvador_svg__cls-53"
        />
        <path
          d="M700.23 375.52a11.5 11.5 0 0 1-1.93 1.35c-.41.26-.88.52-1.45.83a14 14 0 0 1-1.77.83 14 14 0 0 1-1.51.58 14.33 14.33 0 0 1-8.47-.11"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M700.23 375.52s-7.75 6.08-15.13 3.48"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M700.54 351.61s-1.51 9.72-2.08 11.12c-.52 1.25-3.59 6.81-8.26 8.11"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M700.54 351.61s-1.61 9.61-2.24 11c-.52 1.25-3.38 6.55-8.16 8.16"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M700.49 351.56s-1.66 9.56-2.29 11c-.52 1.25-3.22 6.24-8.05 8.21"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M700.49 351.56s-1.77 9.51-2.39 10.92a17.55 17.55 0 0 1-8 8.26"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M700.43 351.56s-1.82 9.44-2.43 10.81a18.26 18.26 0 0 1-7.9 8.32"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M700.43 351.56s-1.92 9.36-2.6 10.76a19 19 0 0 1-7.74 8.37"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M700.43 351.5s-2 9.3-2.7 10.71a19.9 19.9 0 0 1-7.64 8.42"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M700.38 351.5s-2.08 9.25-2.75 10.66-2.29 4.78-7.54 8.47"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M700.38 351.5s-2.18 9.15-2.86 10.55-2.13 4.52-7.48 8.53"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M700.33 351.45s-2.23 9.15-3 10.5-1.87 4.21-7.33 8.63"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M700.33 351.45s-2.39 9.05-3.06 10.45-1.72 3.9-7.23 8.63"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M700.27 351.45s-2.44 9-3.11 10.35-1.56 3.63-7.18 8.68"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M700.27 351.39s-2.54 8.94-3.22 10.29-1.4 3.38-7.07 8.79"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M699.92 345.63s-1.25 13.72-11 17.52"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M699.92 345.63a36.3 36.3 0 0 1-2.55 8.68c-1.56 3.28-4.16 7-8.47 8.78"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M699.87 345.63a32.8 32.8 0 0 1-2.6 8.63c-1.46 3-4 6.91-8.37 8.83"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M699.87 345.63a36 36 0 0 1-2.7 8.53c-1.41 2.8-3.95 6.86-8.27 8.88"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M699.81 345.63a34 34 0 0 1-2.81 8.47c-1.25 2.6-3.79 6.76-8.11 8.89"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M699.81 345.63a37.6 37.6 0 0 1-2.91 8.37c-1.15 2.39-3.74 6.7-8 9"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M699.76 345.63a36.3 36.3 0 0 1-3 8.32c-1.09 2.13-3.64 6.6-7.9 9"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M699.76 345.58a39 39 0 0 1-3.07 8.32c-1 1.87-3.53 6.5-7.79 9"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M699.76 345.58a44.4 44.4 0 0 1-3.17 8.22c-.94 1.71-3.43 6.44-7.69 9"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M699.7 345.58a40 40 0 0 1-3.22 8.16c-.83 1.46-3.33 6.35-7.59 9.1"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M699.7 345.58a42 42 0 0 1-3.38 8.06c-.73 1.25-3.17 6.29-7.43 9.15"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M699.65 345.58a37 37 0 0 1-3.43 8c-.62 1-3.07 6.18-7.33 9.14"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M699.65 345.58c-.1.37-2 5.77-3.53 7.9-.57.78-3 6.14-7.23 9.25"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M699.81 341.83s-2.86 11-10.81 13.73"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M699.81 341.83a29.3 29.3 0 0 1-3.69 7.7c-1.72 2.54-4.21 5-7.12 6"
          className="El_Salvador_svg__cls-22"
        />
        <path
          d="M699.81 341.79a31 31 0 0 1-3.74 7.64c-1.82 2.59-4.37 5.19-7.07 6.13"
          className="El_Salvador_svg__cls-48"
        />
        <path
          d="M699.81 341.74a31.5 31.5 0 0 1-3.85 7.59c-1.87 2.65-4.47 5.35-7 6.18"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="M699.76 341.68a31.6 31.6 0 0 1-3.9 7.59c-1.92 2.65-4.62 5.45-6.86 6.23"
          className="El_Salvador_svg__cls-25"
        />
        <path
          d="M699.76 341.68a32.5 32.5 0 0 1-4 7.48c-2 2.71-4.73 5.62-6.81 6.29"
          className="El_Salvador_svg__cls-50"
        />
        <path
          d="M699.76 341.63a33.2 33.2 0 0 1-4 7.43c-2.08 2.81-4.94 5.77-6.76 6.4"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M699.76 341.57a34 34 0 0 1-4.16 7.43c-2.13 2.86-5 5.93-6.65 6.5"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M699.7 341.57a32.4 32.4 0 0 1-4.21 7.33c-2.18 2.86-5.2 6-6.55 6.5"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M699.7 341.52a33.5 33.5 0 0 1-4.31 7.28c-2.24 2.91-5.3 6.24-6.45 6.6"
          className="El_Salvador_svg__cls-57"
        />
        <path
          d="M699.7 341.48a35.5 35.5 0 0 1-4.37 7.22c-2.28 3-5.5 6.39-6.39 6.7"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="M699.7 341.42a38.7 38.7 0 0 1-4.47 7.22c-2.34 3-5.61 6.5-6.29 6.7"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M699.65 341.42a38.3 38.3 0 0 1-4.52 7.12 52.7 52.7 0 0 1-6.18 6.8"
          className="El_Salvador_svg__cls-52"
        />
        <path
          d="M699.65 341.37a41 41 0 0 1-4.62 7.07 73 73 0 0 1-6.14 6.91"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M699.65 341.32a44.2 44.2 0 0 1-4.68 7c-2.54 3.17-6.08 7-6.08 7M678.56 356.86l-5.46 1M678 361l-4.88-2.07"
          className="El_Salvador_svg__cls-21"
        />
        <path d="m678.61 357-5.47.84" className="El_Salvador_svg__cls-37" />
        <path d="m678.61 357.22-5.51.68" className="El_Salvador_svg__cls-38" />
        <path d="m678.56 357.43-5.51.47" className="El_Salvador_svg__cls-30" />
        <path d="M678.56 357.63 673 358" className="El_Salvador_svg__cls-29" />
        <path d="m678.56 357.85-5.62.1" className="El_Salvador_svg__cls-39" />
        <path d="M678.5 358.05h-5.61" className="El_Salvador_svg__cls-26" />
        <path d="m678.5 358.21-5.67-.2" className="El_Salvador_svg__cls-25" />
        <path d="m678.5 358.41-5.72-.36" className="El_Salvador_svg__cls-40" />
        <path d="m678.45 358.63-5.71-.58" className="El_Salvador_svg__cls-34" />
        <path d="m678 360.76-5-1.93" className="El_Salvador_svg__cls-37" />
        <path d="m678.09 360.55-5.1-1.83" className="El_Salvador_svg__cls-38" />
        <path
          d="m678.09 360.34-5.15-1.66"
          className="El_Salvador_svg__cls-30"
        />
        <path
          d="m678.14 360.13-5.25-1.56"
          className="El_Salvador_svg__cls-29"
        />
        <path d="m678.19 359.92-5.36-1.4" className="El_Salvador_svg__cls-39" />
        <path
          d="m678.19 359.72-5.41-1.31"
          className="El_Salvador_svg__cls-26"
        />
        <path d="m678.25 359.46-5.51-1.1" className="El_Salvador_svg__cls-25" />
        <path d="m678.29 359.25-5.61-1" className="El_Salvador_svg__cls-40" />
        <path d="m678.29 359-5.66-.83" className="El_Salvador_svg__cls-34" />
        <path d="m678.34 358.83-5.76-.73" className="El_Salvador_svg__cls-18" />
        <path
          d="M673.36 398.8s2.91.16 3.17.26 11.85-.2 11.85-.2"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M673.3 398.85s2.86.26 3.27.37 11.7-.32 11.7-.32"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M673.3 398.9s2.75.36 3.33.47 11.53-.42 11.53-.42"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M673.25 399s2.7.41 3.43.57 11.44-.52 11.44-.52"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M673.25 399s2.6.57 3.54.73 11.22-.63 11.22-.63"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M673.25 399s2.5.62 3.59.83 11.07-.73 11.07-.73"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M673.2 399.06s2.45.72 3.69 1 10.92-.88 10.92-.88"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M673.2 399.12a36 36 0 0 0 3.75 1.09c1.35.26 10.81-.94 10.81-.94"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M673.14 399.16a33 33 0 0 0 3.85 1.2c1.51.31 10.65-1 10.65-1"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M673.14 399.21a22 22 0 0 0 3.9 1.3c1.66.36 10.5-1.14 10.5-1.14"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M687.45 399.43s-8.53 1.61-10.35 1.24a20.5 20.5 0 0 1-4-1.4"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M671.18 405.39s-5.46.83-5.67.78l-3.27-.21-2.65-.62"
          className="El_Salvador_svg__cls-34"
        />
        <path
          d="M671.49 405.3s-5.61.88-6 .78c-.2-.06-3-.21-3.17-.21s-2.49-.57-2.49-.57"
          className="El_Salvador_svg__cls-24"
        />
        <path
          d="M671.8 405.14a58 58 0 0 1-6.34.83c-.31-.05-2.86-.21-3.12-.21s-2.28-.52-2.28-.52"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M672.11 405s-5.87 1-6.7.89c-.42-.05-2.7-.21-3-.21l-2.08-.42"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M672.43 404.88s-6 1.09-7 .88c-.52-.1-2.6-.21-3-.26s-1.87-.31-1.87-.31"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M672.74 404.72s-6.19 1.2-7.38.94c-.63-.11-2.39-.21-2.86-.26a14 14 0 0 1-1.67-.26"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M673.05 404.57s-6.29 1.29-7.69 1c-.78-.15-2.29-.26-2.81-.31s-1.45-.21-1.45-.21"
          className="El_Salvador_svg__cls-31"
        />
        <path
          d="M673.36 404.46s-6.45 1.35-8.06 1a13.3 13.3 0 0 0-2.7-.32l-1.3-.1"
          className="El_Salvador_svg__cls-37"
        />
        <path
          d="m670.86 405.56-5.3.73-3.38-.17-2.86-.73"
          className="El_Salvador_svg__cls-58"
        />
        <path
          d="M673.67 404.3s-6.6 1.46-8.42 1.09a21.4 21.4 0 0 0-3.69-.36M647.58 405.08l-5.14-1.87a5.67 5.67 0 0 1-3.59-4.42"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M647.94 404.05s-2.08-.83-3.79-1.45c-4.58-1.72-4.06-3.9-4.06-3.9"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="m648.25 404.25-4.1-1.56a11.6 11.6 0 0 1-2.13-1 5.6 5.6 0 0 1-1.62-1.46 3.15 3.15 0 0 1-.41-1.51"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M648.56 404.52s-3.37-1.3-4.41-1.67a18 18 0 0 1-2.08-.93 10.4 10.4 0 0 1-1.72-1.46 7 7 0 0 1-.52-1.71"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="m648.88 404.72-4.73-1.72c-.37-.1-1.82-.72-2-.83a19 19 0 0 1-1.82-1.51 11.3 11.3 0 0 1-.57-1.87"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M649.19 405s-4.68-1.76-5-1.87c-.16-.1-1.93-.72-2-.83a18 18 0 0 1-1.87-1.5c-.11-.16-.68-2-.68-2"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="m647.94 405.14-5.56-2.08a6.2 6.2 0 0 1-2.49-1.87 7.2 7.2 0 0 1-.94-2.39"
          className="El_Salvador_svg__cls-38"
        />
        <path
          d="M648.36 405.14s-5-1.82-6-2.23a6.9 6.9 0 0 1-2.34-1.77 8.5 8.5 0 0 1-.88-2.34"
          className="El_Salvador_svg__cls-29"
        />
        <path
          d="M648.72 405.19s-5.72-2.19-6.45-2.39a9.9 9.9 0 0 1-2.23-1.72 12 12 0 0 1-.83-2.28"
          className="El_Salvador_svg__cls-26"
        />
        <path
          d="M649.09 405.19s-6.5-2.44-6.86-2.55a22 22 0 0 1-2.13-1.64c-.16-.26-.78-2.23-.78-2.23"
          className="El_Salvador_svg__cls-40"
        />
        <path
          d="m649.5 405.18-7.33-2.7-2-1.49-.73-2.2"
          className="El_Salvador_svg__cls-18"
        />
        <path
          d="M641 398.8s3 .16 3.33.26 12.32-.2 12.32-.2"
          className="El_Salvador_svg__cls-23"
        />
        <path
          d="M640.92 398.85s3 .26 3.43.37 12.16-.32 12.16-.32"
          className="El_Salvador_svg__cls-49"
        />
        <path
          d="M640.92 398.9s2.86.36 3.48.47 12-.42 12-.42"
          className="El_Salvador_svg__cls-19"
        />
        <path
          d="M640.92 399s2.76.41 3.54.57 11.85-.52 11.85-.52"
          className="El_Salvador_svg__cls-35"
        />
        <path
          d="M640.87 399s2.71.57 3.64.73 11.7-.63 11.7-.63"
          className="El_Salvador_svg__cls-39"
        />
        <path
          d="M640.87 399s2.6.62 3.69.83 11.59-.73 11.59-.73"
          className="El_Salvador_svg__cls-36"
        />
        <path
          d="M640.83 399.06s2.54.72 3.79 1 11.43-.88 11.43-.88"
          className="El_Salvador_svg__cls-20"
        />
        <path
          d="M640.83 399.12a36 36 0 0 0 3.89 1.09c1.41.26 11.23-.94 11.23-.94"
          className="El_Salvador_svg__cls-51"
        />
        <path
          d="M640.77 399.16a35 35 0 0 0 4 1.2c1.56.31 11.07-1 11.07-1"
          className="El_Salvador_svg__cls-32"
        />
        <path
          d="M640.77 399.21a24 24 0 0 0 4.05 1.3c1.72.36 10.91-1.14 10.91-1.14"
          className="El_Salvador_svg__cls-33"
        />
        <path
          d="M655.69 399.43s-8.94 1.61-10.81 1.24a22.6 22.6 0 0 1-4.16-1.4"
          className="El_Salvador_svg__cls-21"
        />
        <path
          d="M684.48 348.9c.15-1.51.2-3 .2-3.84 0-6.19.78-10.87.11-17.36-.52-5.09-1.77-11.8-1.51-17.31.1-1.56-.21-3.12-.26-4.62l-25.1 28.17M694.05 394.17a6.3 6.3 0 0 0 2.18-2.65 26 26 0 0 0 1.09-4.32c.31-1.29.31-2.75.62-4.1s2.19-5.67 2.24-7.43c.21-5.67 2.08-9.51 1.61-15.7-.31-4.78-1.4-11.28-.88-16.27a29 29 0 0 0-.11-4.26l-28.22 18.66M638.38 398.7c-.21.62.42 1.82.63 2.23l.57.78c.31.68.26.52.83 1a13 13 0 0 0 1 .78 3.06 3.06 0 0 0 1.3.78 40 40 0 0 1 5 1.4c1.92.58.88.47 2.34.84.72.15 2.18.72 2.91.83 1.3.2 1.5.41 2.86.72a36 36 0 0 0 10.29.37c1.4-.11 4.83-.83 6-1.67 2.14-1.5 6.81-2.07 8.89-3.53.31-.21 1.61-.83 1.87-1.09 2-1.66 3.64-2.13 5.77-3.48"
          className="El_Salvador_svg__cls-13"
        />
        <path
          d="m671.9 357.12 28.64-18.71.52.78-28.48 18.91z"
          className="El_Salvador_svg__cls-59"
        />
        <path
          d="M701 338.1c.2-1.09-.11-2.55-.89-2.71a2.4 2.4 0 0 0-1-.1c-.47 0-.58.16-.78.52-.42 1 .78 1.61 1.61 1.92.21.06.78.16.88.42.16.41 0 .26.16.41-.16-.05-.21-.2-.37-.31-.62-.36-1.24-.46-2.13-.88a1.5 1.5 0 0 1-.31-2.08 2.66 2.66 0 0 1 2.49 0 4 4 0 0 1 .68 3.28c0-.26-.42-.21-.36-.52Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M701.47 338.61c1.09-.05 2.5.42 2.55 1.2a3.5 3.5 0 0 1 0 1c0 .46-.21.57-.62.67-1 .31-1.51-.93-1.67-1.82-.05-.2-.05-.78-.31-.93s-.31-.11-.41-.21c0 .16.2.26.26.36.25.68.31 1.36.62 2.29a1.45 1.45 0 0 0 2 .52 2.48 2.48 0 0 0 .32-2.44 4 4 0 0 0-3.21-1.05c.2.05.15.46.46.41Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M701.68 338.15a.58.58 0 0 1 .15.83c-.1.26-.57.31-.78.2a.84.84 0 0 1-.41-1.14c.26-.36.67-.05 1 .11Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M707.71 334.35a19.3 19.3 0 0 1-5.45 1.25 7 7 0 0 1-.63 2.75s2.19-.42 3.17.1c0 0 1.3-3 2.91-4.1Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M705.27 335.86a6.7 6.7 0 0 1-2.18.52 2.8 2.8 0 0 1-.26 1.09 2.54 2.54 0 0 1 1.24 0 4.7 4.7 0 0 1 1.2-1.66Z"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="M701.47 340.48s-.57-1-.72-1.35c-.11-.21 0 1.2-.47 1.35a6.46 6.46 0 0 0-.83 3.17 2.89 2.89 0 0 0 2.65.16c.41-.26.1-1-.05-1.67a5.3 5.3 0 0 0-.58-1.66Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M700.9 339.7c0 .16-.11.78 0 .68 0-.26-.32.26-.37.36a6.8 6.8 0 0 0-.73 2.86"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="M700.65 341a8 8 0 0 0-.47 2.81l-.11-.11M700.69 342.1a9 9 0 0 0-.2 1.66s.31.21.36.21"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="m657.14 333.21 25.57-28.43.52.62-25.31 28.54z"
          className="El_Salvador_svg__cls-59"
        />
        <path
          d="M682.5 304.79c0-1.15-.68-2.5-1.46-2.45a2.4 2.4 0 0 0-1 .11c-.47.1-.52.31-.63.72-.2 1 1.09 1.36 2 1.46.21 0 .83-.05 1 .21s.11.26.26.36c-.15 0-.31-.15-.41-.21a24 24 0 0 0-2.34-.36c-.68-.1-1.09-1.45-.73-1.92a2.56 2.56 0 0 1 2.39-.57 3.84 3.84 0 0 1 1.42 3.06c-.06-.26-.42-.16-.47-.41Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M683.07 305.14c1.1-.31 2.55-.15 2.81.58a3.2 3.2 0 0 1 .21 1 .68.68 0 0 1-.47.84c-.88.52-1.66-.58-2-1.41-.1-.21-.26-.72-.52-.83-.41-.1-.31 0-.41-.1.05.15.2.21.31.31.41.62.62 1.19 1.14 2.08a1.53 1.53 0 0 0 2.08.05 2.65 2.65 0 0 0-.31-2.44 3.58 3.58 0 0 0-3.33-.32c.21-.05.26.37.52.27Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M683.18 304.63c.37.05.42.52.37.78a.6.6 0 0 1-.73.36c-.42-.15-.83-.52-.68-1s.68-.21 1-.16Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M688.12 299.53a18.4 18.4 0 0 1-4.94 2.49 7.1 7.1 0 0 1 0 2.81 7.2 7.2 0 0 1 3.12-.63s.52-3.17 1.82-4.67Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M686.14 301.61a7.9 7.9 0 0 1-2 1 2.6 2.6 0 0 1 0 1.09 3 3 0 0 1 1.24-.21 4.6 4.6 0 0 1 .73-1.87Z"
          className="El_Salvador_svg__cls-7"
        />
        <path
          d="M683.54 307s-.78-.84-1-1.15.36 1.15-.1 1.46a6.26 6.26 0 0 0 0 3.27 2.83 2.83 0 0 0 2.54-.52c.37-.31-.1-1-.41-1.56a4.4 4.4 0 0 0-.94-1.5Z"
          className="El_Salvador_svg__cls-14"
        />
        <path
          d="M682.81 306.39c0 .1.05.52.05.62-.05.32-.31.42-.36.78a11.3 11.3 0 0 0 .1 2.6M682.92 307.43a7.5 7.5 0 0 0 .1 3c.05 0-.1 0-.1-.05M683.07 309.25a4 4 0 0 1 .21 1.15c.05-.06.26.15.31.1"
          className="El_Salvador_svg__cls-7"
        />
      </g>
      <path
        d="m636.46 297.92-60.24 100.77h120.52Z"
        style={{
          stroke: "#000",
          strokeMiterlimit: 2.61,
          fill: "#fc0",
          strokeWidth: ".42px",
        }}
      />
      <path
        d="m636.46 304.47-54.36 90.95h108.77Z"
        style={{
          fill: "#fff",
          strokeMiterlimit: 2.61,
          strokeWidth: ".13px",
          stroke: "#fff",
        }}
      />
      <path
        d="m598.21 368.39-16.11 27h108.77l-16.16-27Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "#007e93",
          stroke: "#007e93",
          strokeWidth: ".25px",
        }}
      />
      <path
        d="M627 320.37a13.63 13.63 0 0 1 9.31-3.28h.26c3.53.06 7.12.89 9.4 3.28"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#086aad",
        }}
      />
      <path
        d="M626.94 320.48c2.5-2.34 5.72-3.23 9.36-3.28h.26c3.64 0 7.22.89 9.51 3.33"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#0863aa",
        }}
      />
      <path
        d="M626.9 320.63c2.49-2.44 5.76-3.32 9.45-3.38h.27c3.63.06 7.27.94 9.56 3.44"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#095fa8",
        }}
      />
      <path
        d="M626.79 320.74c2.49-2.44 5.87-3.38 9.56-3.38h.31c3.69 0 7.33.94 9.62 3.54"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#0a58a5",
        }}
      />
      <path
        d="M626.74 320.84c2.44-2.5 5.92-3.38 9.67-3.43h.26c3.79 0 7.43 1 9.72 3.63"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#0a52a2",
        }}
      />
      <path
        d="M626.64 320.94c2.45-2.54 6-3.43 9.77-3.43h.32c3.84.06 7.48 1 9.82 3.69"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#0b4d9f",
        }}
      />
      <path
        d="M626.58 321.1c2.45-2.6 6-3.53 9.88-3.53h.26c3.95.05 7.53 1 9.92 3.79"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#0c479d",
        }}
      />
      <path
        d="M625.91 322.19c2.86-3 6.4-3.9 10.61-3.9h.25c4.63 0 8.58 1.61 10.87 4.84"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#270a7f",
        }}
      />
      <path
        d="M626 322c2.81-2.91 6.34-3.79 10.55-3.84h.26c4.52.05 8.42 1.56 10.76 4.73"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#241183",
        }}
      />
      <path
        d="M626.07 321.93c2.75-2.91 6.24-3.8 10.39-3.8h.26c4.47.06 8.37 1.46 10.71 4.63"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#221786",
        }}
      />
      <path
        d="M626.12 321.83c2.7-2.86 6.23-3.74 10.29-3.79h.26c4.41 0 8.26 1.4 10.65 4.52"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#1f1f8a",
        }}
      />
      <path
        d="M626.22 321.68c2.6-2.76 6.14-3.69 10.19-3.69h.21c4.36 0 8.21 1.24 10.6 4.36"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#1a258d",
        }}
      />
      <path
        d="M626.27 321.57c2.55-2.76 6.14-3.64 10.08-3.69h.27c4.26.05 8.1 1.19 10.44 4.26"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#172d91",
        }}
      />
      <path
        d="M626.32 321.46c2.49-2.7 6.08-3.64 10-3.64h.26c4.21 0 8 1.09 10.39 4.11"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#143393",
        }}
      />
      <path
        d="M626.43 321.3c2.44-2.65 6-3.53 9.87-3.58h.21c4.16 0 8 1 10.34 4"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#113b97",
        }}
      />
      <path
        d="M630.48 314.45a9.65 9.65 0 0 1 6-1.61 10.35 10.35 0 0 1 5.93 1.51"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff0a00",
        }}
      />
      <path
        d="M630.43 314.55a9.83 9.83 0 0 1 6-1.61 10.47 10.47 0 0 1 6 1.5"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#f10",
        }}
      />
      <path
        d="M630.38 314.66a10.1 10.1 0 0 1 6.08-1.67 11 11 0 0 1 6.08 1.56"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff1500",
        }}
      />
      <path
        d="M630.33 314.81a9.88 9.88 0 0 1 6.14-1.71 11 11 0 0 1 6.13 1.56"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff1a00",
        }}
      />
      <path
        d="M630.27 314.92a10 10 0 0 1 6.19-1.71 11.2 11.2 0 0 1 6.18 1.55"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff2000",
        }}
      />
      <path
        d="M630.23 315a10.18 10.18 0 0 1 6.23-1.77 11.06 11.06 0 0 1 6.24 1.66"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff2700",
        }}
      />
      <path
        d="M630.17 315.12a10.23 10.23 0 0 1 6.28-1.76 11.13 11.13 0 0 1 6.29 1.66"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff2f00",
        }}
      />
      <path
        d="M630.12 315.23a10.1 10.1 0 0 1 6.34-1.77 11.5 11.5 0 0 1 6.39 1.67"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#f30",
        }}
      />
      <path
        d="M630.07 315.33a10.3 10.3 0 0 1 6.39-1.82 11.8 11.8 0 0 1 6.45 1.71"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff3c00",
        }}
      />
      <path
        d="M630 315.43a10.53 10.53 0 0 1 6.44-1.81 12 12 0 0 1 6.5 1.71"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff4100",
        }}
      />
      <path
        d="M630 315.54a10.6 10.6 0 0 1 6.5-1.82 12 12 0 0 1 6.55 1.72"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff4600",
        }}
      />
      <path
        d="M628.56 317.88a13.9 13.9 0 0 1 8-2.34 13.35 13.35 0 0 1 8 2.39"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fff500",
        }}
      />
      <path
        d="M628.67 317.72a13.4 13.4 0 0 1 7.85-2.29 12.76 12.76 0 0 1 7.89 2.4"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ffeb00",
        }}
      />
      <path
        d="M628.72 317.61a13.4 13.4 0 0 1 7.79-2.28 13 13 0 0 1 7.85 2.34"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ffe000",
        }}
      />
      <path
        d="M628.82 317.46a13.26 13.26 0 0 1 7.7-2.24 13 13 0 0 1 7.74 2.29"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ffd600",
        }}
      />
      <path
        d="M628.87 317.36a13.16 13.16 0 0 1 7.64-2.23 13.4 13.4 0 0 1 7.69 2.23"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ffcf00",
        }}
      />
      <path
        d="M629 317.21a12.85 12.85 0 0 1 7.54-2.19 12.54 12.54 0 0 1 7.58 2.24"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ffc400",
        }}
      />
      <path
        d="M629 317.1a13.92 13.92 0 0 1 15 0"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ffba00",
        }}
      />
      <path
        d="M629.14 316.94a12.6 12.6 0 0 1 7.38-2.13 12.9 12.9 0 0 1 7.43 2.13"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ffb000",
        }}
      />
      <path
        d="M629.18 316.84a12.17 12.17 0 0 1 7.33-2.14 12.5 12.5 0 0 1 7.33 2.14"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ffa600",
        }}
      />
      <path
        d="M629.29 316.68a12.1 12.1 0 0 1 7.23-2.08 12.24 12.24 0 0 1 7.22 2.08"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff9c00",
        }}
      />
      <path
        d="M629.34 316.58a12 12 0 0 1 7.17-2.08 12.47 12.47 0 0 1 7.17 2"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff9100",
        }}
      />
      <path
        d="M629.45 316.42a12 12 0 0 1 7.07-2 12.53 12.53 0 0 1 7.07 2"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff8700",
        }}
      />
      <path
        d="M629.49 316.32a11.56 11.56 0 0 1 7-2 12.46 12.46 0 0 1 7 2"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff7d00",
        }}
      />
      <path
        d="M629.6 316.17a11.37 11.37 0 0 1 6.91-2 12.47 12.47 0 0 1 6.92 1.92"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff7500",
        }}
      />
      <path
        d="M629.65 316.06a11.3 11.3 0 0 1 6.86-2 12.1 12.1 0 0 1 6.81 1.87"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff6b00",
        }}
      />
      <path
        d="M629.76 315.9a11 11 0 0 1 6.75-1.92 12 12 0 0 1 6.76 1.87"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff6100",
        }}
      />
      <path
        d="M629.81 315.79a10.94 10.94 0 0 1 6.7-1.92 12 12 0 0 1 6.65 1.82"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff5700",
        }}
      />
      <path
        d="M628.3 318.14a14 14 0 0 1 8.21-2.44 13.6 13.6 0 0 1 8.16 2.49"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ebf605",
        }}
      />
      <path
        d="M628.25 318.3a14.79 14.79 0 0 1 16.53.05"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#d6ec09",
        }}
      />
      <path
        d="M628.14 318.45a13.37 13.37 0 0 1 8.37-2.6 13.66 13.66 0 0 1 8.31 2.6"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#c2e30e",
        }}
      />
      <path
        d="M628.05 318.61a13.2 13.2 0 0 1 8.47-2.65 13.46 13.46 0 0 1 8.36 2.65"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#add912",
        }}
      />
      <path
        d="M628 318.76a13.1 13.1 0 0 1 8.47-2.7 13.92 13.92 0 0 1 8.52 2.65"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#99cf16",
        }}
      />
      <path
        d="M627.89 318.92a13 13 0 0 1 8.57-2.81c3.12 0 6.5.94 8.58 2.76"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#85c61a",
        }}
      />
      <path
        d="M627.83 319.08a12.62 12.62 0 0 1 8.63-2.86 14 14 0 0 1 8.68 2.75"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#70bc1f",
        }}
      />
      <path
        d="M627.72 319.23a12.65 12.65 0 0 1 8.73-3 13.77 13.77 0 0 1 8.73 2.86"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#5cb323",
        }}
      />
      <path
        d="M627.63 319.33a12.64 12.64 0 0 1 8.83-3 14.2 14.2 0 0 1 8.84 2.85"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#47a928",
        }}
      />
      <path
        d="M627.16 320.17a13.3 13.3 0 0 1 9.35-3.17c3.43 0 7 .88 9.31 3.11"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#0d74a4",
        }}
      />
      <path
        d="M627.21 320.11a13.07 13.07 0 0 1 9.3-3.23c3.43 0 7 .94 9.25 3.12"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#127a97",
        }}
      />
      <path
        d="M627.27 320a13.06 13.06 0 0 1 9.25-3.17c3.38 0 7 .93 9.2 3.07"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#17808b",
        }}
      />
      <path
        d="M627.31 319.9a13 13 0 0 1 9.2-3.12c3.33 0 6.92.94 9.1 3"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#1a847d",
        }}
      />
      <path
        d="M627.36 319.85a12.8 12.8 0 0 1 9.1-3.17c3.38 0 6.91 1 9.09 3"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#1e8a6d",
        }}
      />
      <path
        d="M627.42 319.75a12.66 12.66 0 0 1 9.05-3.12c3.32 0 6.86 1 9 3"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#238f5e",
        }}
      />
      <path
        d="M627.47 319.7a12.46 12.46 0 0 1 9-3.12c3.28 0 6.81 1 9 3"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#2b944e",
        }}
      />
      <path
        d="M627.52 319.59a12.4 12.4 0 0 1 8.94-3.07c3.22 0 6.81 1 8.94 2.91"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#2f9b3e",
        }}
      />
      <path
        d="M642.34 314.24a10.2 10.2 0 0 0-5.88-1.51 9.9 9.9 0 0 0-5.92 1.61"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "red",
        }}
      />
      <path
        d="M647.79 323.34c-2.39-3.38-6.45-5-11.23-5-4.31 0-7.79.94-10.76 3.95"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#2a007c",
        }}
      />
      <path
        d="M645.87 320.17c-2.29-2.24-5.87-3.12-9.35-3.12-3.69 0-6.81.88-9.41 3.22"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#0671b0",
        }}
      />
      <path
        d="M646.76 321.57c-2.45-3-6.19-3.9-10.29-3.9-3.85 0-7.54.88-10 3.53"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#0c419a",
        }}
      />
      <path
        d="M644.62 318.08a13.5 13.5 0 0 0-8.1-2.44 14.27 14.27 0 0 0-8.11 2.34"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff0",
        }}
      />
      <path
        d="M643.05 315.54a12.2 12.2 0 0 0-6.6-1.77 10.47 10.47 0 0 0-6.55 1.93"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#ff4d00",
        }}
      />
      <path
        d="M645.34 319.33a14.14 14.14 0 0 0-8.89-2.91 12.42 12.42 0 0 0-8.88 3.06"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#33a02c",
        }}
      />
      <path
        d="M625.45 322.81a24.3 24.3 0 0 1 11-2.7 25.14 25.14 0 0 1 11.33 3.22l11.54 19.28a22.9 22.9 0 1 1-45.79.11l11.91-19.91Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fef2ec",
        }}
      />
      <path
        d="M636.47 320.37a25.16 25.16 0 0 1 11.17 3.22c.05 0 11.38 19 11.38 19a22.58 22.58 0 1 1-45.16.11c0-.06 11.69-19.6 11.74-19.6a23.76 23.76 0 0 1 10.87-2.75Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fef2ea",
        }}
      />
      <path
        d="M636.41 321a23.8 23.8 0 0 1 10.91 3.12c.1.05 11.07 18.35 11.07 18.5a22 22 0 1 1-43.92.11c0-.16 11.28-19 11.39-19.08a23.3 23.3 0 0 1 10.55-2.65Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fef0e6",
        }}
      />
      <path
        d="M636.41 321.62a23.1 23.1 0 0 1 10.6 3c.21.1 10.81 17.77 10.81 18a21.39 21.39 0 1 1-42.77.06c0-.26 10.91-18.4 11.12-18.56a22.6 22.6 0 0 1 10.24-2.54Z"
        className="El_Salvador_svg__cls-133"
      />
      <path
        d="M636.41 322.5a22.06 22.06 0 0 1 10.18 2.91c.31.21 10.29 16.84 10.29 17.26a20.45 20.45 0 1 1-40.9.05c0-.42 10.24-17.57 10.6-17.72a21.7 21.7 0 0 1 9.83-2.5Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fee8dc",
        }}
      />
      <path
        d="M636.41 323.12a21.3 21.3 0 0 1 9.87 2.81c.42.26 10 16.22 10 16.74a19.83 19.83 0 1 1-39.65.05c0-.52 9.82-17 10.29-17.21a21 21 0 0 1 9.51-2.39Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fee6d5",
        }}
      />
      <path
        d="M636.41 324a20.66 20.66 0 0 1 9.4 2.7c.57.32 9.51 15.28 9.51 16a18.92 18.92 0 1 1-37.83.1c0-.73 9.25-16.11 9.82-16.47a19.9 19.9 0 0 1 9.1-2.29Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fee3cf",
        }}
      />
      <path
        d="M636.41 324.63a19.7 19.7 0 0 1 9.14 2.6c.63.37 9.2 14.66 9.2 15.44a18.32 18.32 0 1 1-36.64.1c0-.83 8.84-15.54 9.46-15.9a19.1 19.1 0 0 1 8.84-2.24Z"
        className="El_Salvador_svg__cls-137"
      />
      <path
        d="M636.41 325.26a19 19 0 0 1 8.83 2.49c.68.42 8.89 14.09 8.89 15a17.7 17.7 0 1 1-35.39 0c0-.94 8.42-15 9.14-15.38a18.8 18.8 0 0 1 8.53-2.13Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fedec6",
        }}
      />
      <path
        d="M636.41 329.21a14.6 14.6 0 0 1 6.86 1.92c1.24.73 6.86 10.09 6.86 11.64a13.73 13.73 0 1 1-27.45 0c0-1.55 5.77-11.17 7.07-11.9a14.34 14.34 0 0 1 6.66-1.66Z"
        className="El_Salvador_svg__cls-139"
      />
      <path
        d="M636.41 329.47a13.9 13.9 0 0 1 6.7 1.93c1.3.78 6.71 9.77 6.71 11.38a13.41 13.41 0 1 1-26.82.05c0-1.66 5.56-10.91 6.91-11.69a13.74 13.74 0 0 1 6.5-1.67Z"
        className="El_Salvador_svg__cls-139"
      />
      <path
        d="M636.41 331a12.25 12.25 0 0 1 6 1.72c1.51.88 5.93 8.21 5.93 10.08a11.91 11.91 0 1 1-23.81.05c0-1.92 4.58-9.46 6.14-10.34a11.83 11.83 0 0 1 5.77-1.51Z"
        className="El_Salvador_svg__cls-140"
      />
      <path
        d="M636.41 331.28a11.7 11.7 0 0 1 5.82 1.67c1.56.93 5.77 7.89 5.77 9.82a11.59 11.59 0 1 1-23.18.05c0-2 4.36-9.15 6-10.08a11.8 11.8 0 0 1 5.62-1.46Z"
        className="El_Salvador_svg__cls-140"
      />
      <path
        d="M636.47 320.68a24.45 24.45 0 0 1 11 3.17c.06 0 11.23 18.66 11.23 18.76a22.27 22.27 0 1 1-44.54.11c0-.11 11.49-19.28 11.54-19.34a23.4 23.4 0 0 1 10.76-2.7Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fef0e9",
        }}
      />
      <path
        d="M636.41 321.3a23.7 23.7 0 0 1 10.75 3.07c.16.1 11 18.09 11 18.29a21.7 21.7 0 1 1-43.4.06c0-.21 11.12-18.71 11.28-18.82a22.66 22.66 0 0 1 10.4-2.6Z"
        className="El_Salvador_svg__cls-133"
      />
      <path
        d="M636.41 321.93a23 23 0 0 1 10.44 3c.26.16 10.66 17.46 10.66 17.77a21.08 21.08 0 1 1-42.15.06c0-.32 10.65-18.14 10.91-18.3a22.3 22.3 0 0 1 10.14-2.49Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#feebdf",
        }}
      />
      <path
        d="M636.41 322.19a22.76 22.76 0 0 1 10.34 3c.26.16 10.45 17.15 10.45 17.52a20.77 20.77 0 1 1-41.53.05c0-.37 10.45-17.83 10.76-18a22.2 22.2 0 0 1 10-2.49Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#feebdd",
        }}
      />
      <path
        d="M636.41 322.81a22 22 0 0 1 10 2.86c.36.21 10.13 16.53 10.13 17a20.14 20.14 0 1 1-40.28.05c0-.47 10-17.26 10.45-17.46a21 21 0 0 1 9.67-2.45Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fee8d9",
        }}
      />
      <path
        d="M636.41 323.44a21.2 21.2 0 0 1 9.71 2.75c.47.26 9.83 15.9 9.83 16.48a19.54 19.54 0 1 1-39.08.1c0-.63 9.66-16.74 10.13-17a20.7 20.7 0 0 1 9.41-2.33Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fee6d3",
        }}
      />
      <path
        d="M636.41 323.75a20.6 20.6 0 0 1 9.56 2.7c.52.31 9.67 15.59 9.67 16.21a19.23 19.23 0 1 1-38.46.11c0-.68 9.46-16.42 10-16.74a20.7 20.7 0 0 1 9.26-2.28Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fee3d2",
        }}
      />
      <path
        d="M636.41 324.32a20 20 0 0 1 9.25 2.65c.62.37 9.4 15 9.4 15.7a18.63 18.63 0 1 1-37.26.1c0-.78 9-15.85 9.67-16.16a19.36 19.36 0 0 1 8.94-2.29Z"
        className="El_Salvador_svg__cls-137"
      />
      <path
        d="M636.41 325a19.64 19.64 0 0 1 9 2.54c.62.42 9 14.4 9 15.23a18 18 0 1 1-36 0c0-.88 8.63-15.28 9.31-15.64a18.86 18.86 0 0 1 8.68-2.18Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fedec8",
        }}
      />
      <path
        d="M636.41 325.57a18.94 18.94 0 0 1 8.68 2.44c.72.47 8.73 13.77 8.73 14.71a17.39 17.39 0 1 1-34.77 0c0-1 8.21-14.65 9-15.12a18.1 18.1 0 0 1 8.37-2.08Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fddbc5",
        }}
      />
      <path
        d="M636.41 325.83a18.3 18.3 0 0 1 8.52 2.44c.78.47 8.57 13.47 8.57 14.45a17.1 17.1 0 1 1-34.19 0c0-1 8.05-14.39 8.89-14.86a18.06 18.06 0 0 1 8.21-2.08Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fddbc2",
        }}
      />
      <path
        d="M636.41 326.14a17.6 17.6 0 0 1 8.36 2.39c.84.52 8.42 13.15 8.42 14.19a16.79 16.79 0 1 1-33.57.06c0-1.09 7.85-14.09 8.68-14.61a17.8 17.8 0 0 1 8.11-2Z"
        className="El_Salvador_svg__cls-150"
      />
      <path
        d="M636.41 326.45a17.5 17.5 0 0 1 8.21 2.34c.88.52 8.26 12.84 8.26 13.93a16.48 16.48 0 1 1-33 0c0-1.14 7.64-13.77 8.52-14.29a17.2 17.2 0 0 1 8-2Z"
        className="El_Salvador_svg__cls-150"
      />
      <path
        d="M636.41 326.77a16.85 16.85 0 0 1 8.05 2.28c.94.57 8.11 12.53 8.11 13.67a16.17 16.17 0 1 1-32.33 0c0-1.19 7.43-13.51 8.37-14a16.5 16.5 0 0 1 7.8-2Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdd6bc",
        }}
      />
      <path
        d="M636.41 327.08a16.8 16.8 0 0 1 7.9 2.23c1 .57 8 12.22 8 13.41a15.85 15.85 0 1 1-31.7 0c0-1.24 7.17-13.2 8.21-13.77a16.5 16.5 0 0 1 7.64-1.92Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdd6b9",
        }}
      />
      <path
        d="M636.41 327.39a16.5 16.5 0 0 1 7.79 2.18c1 .63 7.8 11.9 7.8 13.15a15.57 15.57 0 1 1-31.13 0c0-1.3 7-12.94 8-13.51a16.25 16.25 0 0 1 7.54-1.87Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdd4b8",
        }}
      />
      <path
        d="M636.41 327.65a16.6 16.6 0 0 1 7.64 2.18c1 .63 7.64 11.59 7.64 12.89a15.4 15.4 0 0 1-15.28 15.39 15.24 15.24 0 0 1-15.23-15.33c0-1.36 6.76-12.63 7.85-13.26a16.2 16.2 0 0 1 7.38-1.87Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdd4b6",
        }}
      />
      <path
        d="M636.41 328a15.9 15.9 0 0 1 7.48 2.13c1.09.63 7.48 11.28 7.48 12.63a15 15 0 1 1-29.93.06c0-1.35 6.6-12.32 7.74-13a16 16 0 0 1 7.23-1.82Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdd2b2",
        }}
      />
      <path
        d="M636.41 328.28a15.2 15.2 0 0 1 7.32 2.07c1.15.68 7.33 11 7.33 12.43a14.66 14.66 0 1 1-29.31 0c0-1.41 6.39-12.06 7.59-12.69a14.8 14.8 0 0 1 7.07-1.81Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdd1b0",
        }}
      />
      <path
        d="M636.41 328.59a15.36 15.36 0 0 1 7.17 2c1.19.68 7.17 10.66 7.17 12.17a14.35 14.35 0 1 1-28.69 0c0-1.46 6.19-11.75 7.43-12.43a14.7 14.7 0 0 1 6.92-1.76Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdd0b0",
        }}
      />
      <path
        d="M636.41 328.9a14.66 14.66 0 0 1 7 2c1.25.73 7 10.4 7 11.9a14 14 0 1 1-28.06 0c0-1.5 6-11.43 7.22-12.16a14.4 14.4 0 0 1 6.81-1.71Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdd0ad",
        }}
      />
      <path
        d="M636.41 329.78a13.66 13.66 0 0 1 6.6 1.88c1.3.77 6.49 9.45 6.49 11.12a13.1 13.1 0 1 1-26.19.05c0-1.72 5.35-10.65 6.75-11.43a13.7 13.7 0 0 1 6.35-1.61Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdcaa6",
        }}
      />
      <path
        d="M636.41 330.1a13.5 13.5 0 0 1 6.44 1.82c1.35.83 6.34 9.14 6.34 10.86a12.81 12.81 0 1 1-25.62.05c0-1.77 5.2-10.34 6.6-11.17a13.3 13.3 0 0 1 6.24-1.56Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdcaa4",
        }}
      />
      <path
        d="M636.41 330.41a13 13 0 0 1 6.29 1.76c1.4.84 6.23 8.84 6.23 10.61a12.53 12.53 0 1 1-25 .05c0-1.82 5-10 6.45-10.87a12.8 12.8 0 0 1 6.08-1.55Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdc8a4",
        }}
      />
      <path
        d="M636.41 330.72a13 13 0 0 1 6.13 1.71c1.45.89 6.08 8.53 6.08 10.35a12.22 12.22 0 1 1-24.43.05c0-1.87 4.78-9.77 6.29-10.61a12.75 12.75 0 0 1 5.93-1.5Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdc8a1",
        }}
      />
      <path
        d="M636.41 331.59a11.65 11.65 0 0 1 5.66 1.61c1.61.94 5.61 7.59 5.61 9.57a11.28 11.28 0 1 1-22.55.05c0-2 4.16-8.89 5.77-9.82a11.5 11.5 0 0 1 5.51-1.41Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdc39b",
        }}
      />
      <path
        d="M636.41 331.9a11 11 0 0 1 5.51 1.56c1.66 1 5.45 7.28 5.45 9.36a11 11 0 1 1-21.93 0c0-2.08 3.95-8.58 5.61-9.56a11.4 11.4 0 0 1 5.36-1.36Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdc398",
        }}
      />
      <path
        d="M636.41 332.22a11.26 11.26 0 0 1 5.4 1.5c1.67 1 5.25 7 5.25 9.1a10.66 10.66 0 1 1-21.31 0c0-2.13 3.69-8.32 5.46-9.31a10.86 10.86 0 0 1 5.2-1.29Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdc097",
        }}
      />
      <path
        d="M636.41 332.54a10.65 10.65 0 0 1 5.25 1.45c1.71 1 5.09 6.71 5.09 8.84a10.37 10.37 0 1 1-20.74 0c0-2.18 3.54-8 5.35-9a10.3 10.3 0 0 1 5-1.3Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdc095",
        }}
      />
      <path
        d="M636.41 332.79a10.6 10.6 0 0 1 5.09 1.46c1.77 1 4.94 6.39 4.94 8.57a10.06 10.06 0 1 1-20.12 0c0-2.23 3.33-7.69 5.15-8.73a10.6 10.6 0 0 1 4.94-1.3Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdbe92",
        }}
      />
      <path
        d="M636.41 333.1a10 10 0 0 1 4.93 1.41c1.77 1.09 4.78 6.08 4.78 8.31a9.74 9.74 0 1 1-19.48 0c0-2.29 3.11-7.43 5-8.47a10 10 0 0 1 4.79-1.25Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdbe90",
        }}
      />
      <path
        d="M636.41 333.41a9.4 9.4 0 0 1 4.78 1.36c1.82 1.09 4.67 5.76 4.67 8.05a9.46 9.46 0 1 1-18.91 0c0-2.34 2.91-7.12 4.83-8.21a9.8 9.8 0 0 1 4.63-1.2Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdbb8f",
        }}
      />
      <path
        d="M636.41 333.73A9.34 9.34 0 0 1 641 335c1.87 1.15 4.52 5.46 4.52 7.8a9.15 9.15 0 1 1-18.29 0c0-2.39 2.7-6.81 4.68-7.95a9 9 0 0 1 4.5-1.12Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fdbb8d",
        }}
      />
      <path
        d="M636.41 334a8.75 8.75 0 0 1 4.47 1.24c1.92 1.15 4.36 5.15 4.36 7.54a8.84 8.84 0 1 1-17.67 0c0-2.44 2.5-6.55 4.52-7.69a9 9 0 0 1 4.32-1.09Z"
        className="El_Salvador_svg__cls-171"
      />
      <path
        d="M636.41 334.35a8.7 8.7 0 0 1 4.31 1.19c2 1.2 4.21 4.84 4.21 7.28a8.53 8.53 0 1 1-17 0 10.47 10.47 0 0 1 4.32-7.38 8.16 8.16 0 0 1 4.21-1.09Z"
        className="El_Salvador_svg__cls-171"
      />
      <path
        d="M636.41 334.61a8.43 8.43 0 0 1 4.21 1.2 9.66 9.66 0 0 1 4 7 8.24 8.24 0 1 1-16.48 0 9.6 9.6 0 0 1 4.21-7.12 8.23 8.23 0 0 1 4.06-1.09Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fcb687",
        }}
      />
      <path
        d="M636.41 334.92a7.8 7.8 0 0 1 4.05 1.15 8.81 8.81 0 0 1 3.85 6.75 7.93 7.93 0 1 1-15.85 0 8.79 8.79 0 0 1 4-6.86 7.57 7.57 0 0 1 3.9-1Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fcb685",
        }}
      />
      <path
        d="M636.41 335.23a7.65 7.65 0 0 1 3.89 1.1 8 8 0 0 1 3.69 6.49 7.61 7.61 0 1 1-15.22.05 8.06 8.06 0 0 1 3.89-6.65 7.5 7.5 0 0 1 3.75-1Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fcb485",
        }}
      />
      <path
        d="M636.41 350.15a7.31 7.31 0 1 0-7.33-7.28 7.3 7.3 0 0 0 7.33 7.28Z"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".17px",
          stroke: "#fcb482",
        }}
      />
      <path
        d="M636.47 350.21a7.31 7.31 0 1 0-7.33-7.33 7.31 7.31 0 0 0 7.33 7.33Z"
        style={{
          fill: "#fff",
          strokeMiterlimit: 2.61,
          strokeWidth: ".13px",
          stroke: "#fff",
        }}
      />
      <path
        d="m638 335.7.83-3.89M637.24 335.61l.41-4M636.47 335.55v-4M635.74 335.61l-.42-4M635 335.7l-.84-3.89M634.23 335.92l-1.25-3.8M633.5 336.17l-1.61-3.63M632.82 336.48l-2-3.43M632.14 336.9l-2.33-3.17M631.58 337.41l-2.71-3M631 337.94l-3-2.66M630.54 338.56l-3.23-2.33M630.07 339.19l-3.43-2M629.76 339.86l-3.64-1.61M629.45 340.59l-3.75-1.25M629.23 341.32l-3.84-.84M629.14 342.1l-4-.42M629.08 342.88h-4M629.14 343.61l-4 .4M629.23 344.39l-3.89.82M629.45 345.1l-3.8 1.26M629.71 345.84l-3.64 1.61M630.07 346.52l-4.22 2.6M630.48 347.19l-8.63 6.13M631 347.76l-9.2 8.16M631.47 348.33l-7.59 8.48M632.09 348.81l-5.77 7.73M632.72 349.27l-6 10.45M633.4 349.58l-3.33 7.59M634.12 349.9l-3.38 10.44M634.85 350.1l-1.45 7M635.63 350.21l-1 10.8M637.14 350.21l.42 3.94M637.92 350.1l2.33 10.18M638.65 349.9l2 6M639.37 349.63l4.63 10M640.1 349.27l4.93 8.52M640.72 348.85l7.13 9.36M641.34 348.39l6.24 7.22M641.87 347.87l9.25 8.41M642.34 347.24l5 3.64M642.8 346.61l3.43 2M643.11 345.94l3.65 1.61M643.43 345.21l3.73 1.25M643.63 344.48l3.84.84M643.74 343.7l4 .42M643.79 342.92h4M643.74 342.19l4-.4M643.63 341.42l3.9-.83M643.43 340.7l3.79-1.25M643.16 340l3.64-1.62M642.85 339.24l3.44-2M642.43 338.61l3.18-2.33M641.92 338l3-2.65M641.4 337.47l2.65-3M640.78 337l2.33-3.16M640.16 336.54l2-3.44M639.47 336.23l1.62-3.64M638.74 335.92l1.26-3.75M636.47 326.24v-3.07M633 326.61l-.62-3M629.71 327.65l-1.26-2.75M626.69 329.41l-1.82-2.49M624.09 331.7l-2.29-2M622.07 334.56l-2.71-1.56M620.61 337.73l-2.91-1M619.88 341.1l-3.07-.31M619.88 344.59l-3.07.31M620.61 348l-3 .93M650.85 351.25l2.66 1.56M652.25 348.08l2.91.93M653 344.7l3.07.31M653 341.21l3.07-.31M652.25 337.79l3-.94M650.85 334.61l2.66-1.56M648.83 331.81l2.29-2.09M646.29 329.47l1.76-2.5M643.27 327.7l1.25-2.8M639.94 326.61l.62-3"
        className="El_Salvador_svg__cls-177"
      />
      <path
        d="M640.72 346.3a4.8 4.8 0 0 0-1.66-.57 22 22 0 0 0-4.47.16 3.3 3.3 0 0 0-1.15.72 3.8 3.8 0 0 0 2.18.89 8.3 8.3 0 0 0 3.23-.26 8 8 0 0 0 1.87-.94Z"
        className="El_Salvador_svg__cls-4"
      />
      <path
        d="M633.65 345.21a11.8 11.8 0 0 1 1.51-4.57 11 11 0 0 0-.73 1.35s-.78.42-1.25-.16-.2-.67.16-1.4c.31-.57.26-1.14.67-1.51s.68-.41 1.67-.41a2.48 2.48 0 0 1 2.44 1.24c.73 1 1.14 1.93 1.51 2.45a6 6 0 0 1 .83 2.86l.26 1.24a4.8 4.8 0 0 0-1.67-.57 22 22 0 0 0-4.46.16 3.3 3.3 0 0 0-1.15.72s-.41-.93.21-1.4Z"
        className="El_Salvador_svg__cls-4"
      />
      <path
        d="M633.65 345.21s.78-.47 3.43-.41c3.07.05 3.17.26 3.38.46"
        className="El_Salvador_svg__cls-7"
      />
      <path
        d="M636.3 356.65v-10.76s.36-.31 1.19 0v10.66s.26 8.16-.62 8.1c-1 0-.57-1.87-.57-8Z"
        className="El_Salvador_svg__cls-14"
      />
      <path
        d="m625.18 347.61.21.41-2.08.89.31.72-.31.11c-.21-.47-.36-.62-.88-.52l-.16-.31zM622.94 346.72a.92.92 0 0 1-.36-.57 1 1 0 0 1 .78-1.25 1.06 1.06 0 0 1 1.35.89.93.93 0 0 1-.62 1.19l-.11-.41a.57.57 0 0 0 .37-.78.67.67 0 0 0-.89-.47.7.7 0 0 0-.52.83.78.78 0 0 0 .47.52l.05.31-1.76.16-.37-1.61.42-.06.31 1.3h.88ZM622.12 340.9a.68.68 0 0 0-.73.73c0 .31 0 .78.47.83a.45.45 0 0 0 .46-.36l.32-.94a.77.77 0 0 1 .88-.62c.78 0 .93.78.88 1.35a1.43 1.43 0 0 1-.36.93 1 1 0 0 1-.89.26l.06-.41c.57.05.78-.42.83-.83s0-.83-.47-.89-.47.11-.62.63l-.21.67c-.1.21-.26.68-.83.63a1 1 0 0 1-.94-1.2c.11-1.14.78-1.19 1.15-1.19zM622 338.87l.94.32.57-1.72.36.16-.57 1.66 1 .36.62-1.87.37.11-.73 2.28-3.12-1 .73-2.29.41.16ZM624.1 334.07a1.08 1.08 0 0 0-.64.49l-.71 1.23 2.73 1.73.26-.34-1.19-.75.52-.86a1 1 0 0 0-.3-1.38.85.85 0 0 0-.67-.12m.18.49a.7.7 0 0 1 .23.11.5.5 0 0 1 .11.79l-.41.67-.9-.52.49-.75a.48.48 0 0 1 .48-.3M627.88 334.25l-.25.31-2.08-2-.78.78-.26-.26 1.82-1.93.31.26-.78.83ZM629 333.31l-1.93-2.6.31-.26 2 2.6ZM628.92 329.88l.47.89 1.61-.83.16.36-1.56.83.47.94 1.76-.89.16.31-2.13 1.15-1.51-2.91 2.13-1.09.16.36ZM635 330.77l-.42-1.87a3 3 0 0 0-.16-.78l-.31 2.85-.41.11-1.51-2.5a3 3 0 0 0 .21.78l.41 1.93h-.41l-.73-3.17.62-.11 1.51 2.5.31-2.91.63-.16.67 3.23H635ZM636 327.45l-.15 3.26h1.38c.73.05 1.16-.34 1.16-.86a.75.75 0 0 0-.56-.82.71.71 0 0 0 .45-.68c0-.46-.24-.84-.86-.89h-1.44Zm.49.45.71.07c.46 0 .63.14.63.45s-.25.47-.67.41h-.75Zm-.08 1.35.79.07c.31 0 .67.11.67.52s-.26.53-.67.53l-.83-.08v-1ZM639.67 327.75l-.86 3.18.41.11.34-1.35 1.05.3c.52.16.46.46.41.72a1.8 1.8 0 0 0-.15.78l.52.15c-.1-.1-.09-.16 0-.37l.07-.56c.16-.42 0-.57-.15-.68.21-.1.53-.17.64-.63.21-.68-.27-1-.79-1.13Zm.41.56.94.34c.21.05.53.13.37.6s-.4.38-.71.33l-.9-.26ZM643.53 329.62l-.52.83 1.56.94-.21.31-1.56-.88-.52.93 1.66 1-.15.31-2.08-1.19 1.61-2.81 2.08 1.2-.21.36ZM647.45 332l-2.45 2.07.83 1.05a1.49 1.49 0 0 0 2.17 0 1.38 1.38 0 0 0 .33-2.09l-.86-1Zm0 .71.48.6c.37.42.31.87-.26 1.39s-1.09.45-1.46 0l-.49-.56 1.73-1.46ZM649.71 335.65l-.93.47.83 1.56-.37.21-.77-1.61-1 .46.88 1.77-.36.16-1.09-2.13 2.91-1.46 1.09 2.13-.37.16ZM648.56 341.48v-.42l2.24-.31-.11-.73h.32c.15.52.2.67.72.73l.05.31-3.17.47ZM649.59 342.46a.9.9 0 0 0-.75.3 1.27 1.27 0 0 0-.26.78.94.94 0 0 0 .93 1.09.75.75 0 0 0 .82-.45.64.64 0 0 0 .64.41c.42.05.86-.21.86-.93a.86.86 0 0 0-.82-1 .62.62 0 0 0-.64.45.85.85 0 0 0-.78-.65m0 .52a.52.52 0 0 1 .48.64.5.5 0 0 1-.56.56c-.47 0-.52-.38-.52-.64a.53.53 0 0 1 .6-.54Zm1.42.15c.21 0 .46.11.41.53s-.26.52-.41.52a.61.61 0 0 1-.49-.6.47.47 0 0 1 .48-.45ZM650.54 345.32a1 1 0 0 1 .88 1.35 1 1 0 0 1-1.19.73c-.52-.1-.68-.52-.83-1.09l-.11-.37c-.1-.46-.31-.62-.46-.67l-.42 1.72-.36-.11.52-2.13a1.49 1.49 0 0 1 1.09 1l.1.47c.1.36.21.67.62.72.21.11.58 0 .68-.46s-.36-.73-.57-.78v-.42ZM647.38 348.43l.21-.41 2 1 .31-.68.32.1c-.21.52-.26.73.15 1l-.1.32-2.91-1.36Z"
        className="El_Salvador_svg__cls-178"
      />
      <path
        d="m636.46 304.47-54.36 90.95h108.77Z"
        style={{
          stroke: "#000",
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".29px",
        }}
      />
      <path
        d="M639.37 384.19a9.44 9.44 0 0 0 4.83.1c2.34-.57 4.52-1.92 7.27-1.66 2 .21 4.68 1.92 8 1.92s4.31-1.14 7.12-1.71a10 10 0 0 1 5.09.26c2.44.47 3.69 1.87 7.79 1.56"
        className="El_Salvador_svg__cls-7"
      />
      <path
        d="M597.43 388.1a9.75 9.75 0 0 1 7.48-1.41c3.23.68 4.63 1.51 8.06 1.46 2.55 0 4.73-1.77 7.33-1.77 4.31 0 4.47.88 8.26 1.61a8.3 8.3 0 0 0 3.22 0 14.2 14.2 0 0 0 3.79-1.3c1.2-.62 4.21-.52 5.72-.36a11.2 11.2 0 0 1 4.37 1.45 9.35 9.35 0 0 0 4.83.11c2.34-.68 4.52-2.19 7.33-1.87 2 .2 4.67 2.13 7.9 2.13s4.36-1.3 7.12-1.93c2-.46 3-.2 5.14.26 2.39.57 3.69 2.13 7.8 1.77"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          stroke: "#fff",
          strokeWidth: ".48px",
        }}
      />
      <path
        d="M591.3 385a11.26 11.26 0 0 1 7.48-1.25c3.22.63 4.63 1.4 8.05 1.35 2.55-.05 4.73-1.61 7.33-1.61 4.32 0 4.47.83 8.27 1.46a11.6 11.6 0 0 0 3.22 0 14.1 14.1 0 0 0 3.79-1.2c1.14-.52 4.21-.41 5.72-.31a12 12 0 0 1 4.36 1.3 10.75 10.75 0 0 0 4.84.1c2.34-.62 4.52-1.92 7.32-1.66 2 .21 4.68 1.92 7.91 1.87s4.36-1.14 7.12-1.71c2-.42 3-.16 5.14.26 2.39.52 3.69 1.92 7.8 1.55"
        className="El_Salvador_svg__cls-181"
      />
      <path
        d="M585.68 393.92a9.48 9.48 0 0 1 7.53-1.56c3.17.78 4.58 1.71 8 1.66 2.54 0 4.78-2 7.33-2 4.36 0 4.46 1 8.26 1.82a9 9 0 0 0 3.27 0 13 13 0 0 0 3.75-1.51c1.19-.63 4.2-.52 5.76-.37a10.3 10.3 0 0 1 4.32 1.62 9.1 9.1 0 0 0 4.88.1c2.34-.78 4.52-2.39 7.28-2.08 2 .26 4.68 2.39 7.95 2.39s4.31-1.45 7.07-2.18c2-.52 3-.21 5.14.31 2.45.62 3.69 2.39 7.8 2"
        style={{
          strokeMiterlimit: 2.61,
          fill: "none",
          stroke: "#fff",
          strokeWidth: ".61px",
        }}
      />
      <path
        d="M587.14 388.81a11.25 11.25 0 0 1 7.54-1.24c3.22.62 4.62 1.35 8.05 1.3a10.4 10.4 0 0 0 3.28-.68"
        className="El_Salvador_svg__cls-181"
      />
      <path
        d="M603.61 383.52a11.6 11.6 0 0 1 4.21-.88c4.36 0 1.61.05 5.4.72 1 .16 3.75.21 4.53-.57M655.8 395.11a17 17 0 0 0 3.79-1.19c1.15-.52 4.16-.47 5.72-.31a15 15 0 0 1 4.37 1.24 9.34 9.34 0 0 0 4.83.11c2.34-.57 4.52-1.92 7.33-1.66 2 .2 4.67 1.92 7.9 1.92"
        className="El_Salvador_svg__cls-183"
      />
      <path
        d="M662.5 383.1c3.22 0 4.31-1.14 7.12-1.71 2-.42 3-.16 5.09.26 2.44.46 3.69 1.92 7.79 1.55"
        className="El_Salvador_svg__cls-181"
      />
      <path
        d="M585.83 394.23a11.5 11.5 0 0 1 7.54-1.25c3.22.63 4.63 1.4 8 1.35 2.55-.05 4.73-1.61 7.33-1.61 4.32 0 4.47.83 8.27 1.46a11.6 11.6 0 0 0 3.22 0A14.7 14.7 0 0 0 624 393c1.14-.52 4.16-.41 5.72-.26a11.7 11.7 0 0 1 4.36 1.25"
        className="El_Salvador_svg__cls-7"
      />
      <path
        d="M592.7 390.28a11.18 11.18 0 0 1 7.53-1.25c3.22.62 4.63 1.35 8 1.3 2.59-.05 4.78-1.61 7.32-1.56 4.37 0 4.53.78 8.32 1.45a10.9 10.9 0 0 0 3.22 0 17 17 0 0 0 3.8-1.19c1.14-.52 4.15-.47 5.71-.31A15.5 15.5 0 0 1 641 390a9.33 9.33 0 0 0 4.83.11c2.34-.57 4.52-1.93 7.33-1.66 2.13.2 4.83 1.92 7.9 1.92 3.22 0 4.36-1.15 7.12-1.72a10.4 10.4 0 0 1 5.14.26c2.39.47 3.69 1.87 7.75 1.51"
        style={{
          stroke: "#000",
          strokeMiterlimit: 2.61,
          fill: "none",
          strokeWidth: ".61px",
        }}
      />
      <path
        d="M594.16 375.15c.52.1 1.77-.89 2.13-1.15.52-.31.78-1.09 1.2-1.5a13.7 13.7 0 0 1 2.23-1.41 16.2 16.2 0 0 0 5.35-4.73 26.6 26.6 0 0 1 8.53-7.79 4.73 4.73 0 0 1 3.94.1 8 8 0 0 1 1.25.88 17.8 17.8 0 0 0 5.82 2.71c2.29.67 2.81 2.18 4.63 3.79a12.4 12.4 0 0 0 3 2c.1.06.36.47.47.52 1 .78 2.18 1.41 3.06 2.19 1.67 1.51 3.23 3 4.78 4.62.26.26.37.78.63 1a15.1 15.1 0 0 0 3.79 3c1.46.72 2.76 1.66 4.11 2.49-13.83.52-26.56-.36-40.44 0-.36.05-.46 0-2.54 0-1 0-1.67.05-2.71.05-4.2-.05-8.21-.05-13.14-.1l3.95-6.7Z"
        className="El_Salvador_svg__cls-185"
      />
      <path
        d="M648.47 381.5a40 40 0 0 0-3.54-2.14 14.8 14.8 0 0 1-3.79-3c-.26-.21-.36-.73-.62-1a99 99 0 0 0-4.78-4.62c-.89-.78-2-1.41-3.07-2.19-.1-.05-.36-.46-.47-.52a12.7 12.7 0 0 1-3-2c-1.19-1.09-1.82-2.08-2.81-2.86l.06-.05a11.3 11.3 0 0 1 1.87-1.15 4.27 4.27 0 0 1 4.31.78 14.4 14.4 0 0 0 4.83 2.29c1.93.57 2.4 1.82 3.9 3.12a8.6 8.6 0 0 0 2.45 1.66 5 5 0 0 0 .36.47 32 32 0 0 1 2.6 1.82c1.35 1.25 2.65 2.5 4 3.85.21.2.26.62.52.83a13 13 0 0 0 3.17 2.49c1.19.57 2.23 1.35 3.38 2-3.12.15-6.19.15-9.25.15h-.11Z"
        className="El_Salvador_svg__cls-185"
      />
      <path
        d="M636.14 364.65c.42.11.89.26 1.35.42 1.93.57 2.4 1.82 3.9 3.12a9 9 0 0 0 2.44 1.66c.06 0 .26.37.37.47a32 32 0 0 1 2.6 1.82c1.35 1.25 2.65 2.49 4 3.84.2.21.26.63.52.84a13 13 0 0 0 3.17 2.49 27 27 0 0 1 2.81 1.69c2.54 0 5.09 0 7.74-.16a32 32 0 0 0-3.12-1.87 11.8 11.8 0 0 1-2.86-2.29c-.21-.15-.26-.52-.46-.73-1.2-1.24-2.4-2.33-3.64-3.48a27 27 0 0 0-2.29-1.66 2.7 2.7 0 0 1-.36-.42 9.2 9.2 0 0 1-2.24-1.5c-1.35-1.2-1.77-2.34-3.53-2.86a13.7 13.7 0 0 1-4.37-2 4.8 4.8 0 0 0-.93-.68 3.64 3.64 0 0 0-3-.1 15 15 0 0 0-2.08 1.4Z"
        className="El_Salvador_svg__cls-185"
      />
      <path
        d="M648.83 367.61a13 13 0 0 0 1.25 1.3 9.2 9.2 0 0 0 2.23 1.51 2.6 2.6 0 0 0 .36.41 26 26 0 0 1 2.33 1.67c1.25 1.14 2.44 2.23 3.64 3.48.21.21.26.57.47.73a11.6 11.6 0 0 0 2.86 2.29c.72.36 1.35.78 2 1.19h-.05c3 0 6 0 9.1-.1a21 21 0 0 0-2.5-1.51 13.3 13.3 0 0 1-2.34-1.87 7 7 0 0 1-.36-.63c-1-1-1.92-1.87-2.91-2.8a23 23 0 0 0-1.87-1.35 2.4 2.4 0 0 1-.32-.31 9 9 0 0 1-1.82-1.2c-1.09-1-1.4-1.92-2.8-2.34a11.1 11.1 0 0 1-3.59-1.66 4.4 4.4 0 0 0-.73-.52 3.07 3.07 0 0 0-2.44-.11 13.6 13.6 0 0 0-2.49 1.77v.05Z"
        className="El_Salvador_svg__cls-185"
      />
      <path
        d="M672.38 379.67a12 12 0 0 0-1.87-1.09 12.5 12.5 0 0 1-2.34-1.87c-.16-.15-.21-.41-.37-.62-1-1-1.92-1.87-2.91-2.81-.57-.52-1.24-.88-1.87-1.35a1.8 1.8 0 0 1-.31-.31 8.2 8.2 0 0 1-1.82-1.2c-.94-.83-1.3-1.61-2.23-2.13h.05a9 9 0 0 1 1.5-1 2.52 2.52 0 0 1 2.13.05 3.5 3.5 0 0 1 .63.47 9.6 9.6 0 0 0 3.07 1.4c1.19.36 1.45 1.14 2.39 2a6 6 0 0 0 1.56 1c0 .06.15.26.26.32a11 11 0 0 1 1.61 1.14c.83.78 1.66 1.56 2.49 2.39.16.16.16.42.31.52a9.4 9.4 0 0 0 2 1.56c.78.42 1.46.88 2.18 1.3-2.18.1-4.31.1-6.44.1v.05Z"
        className="El_Salvador_svg__cls-185"
      />
      <path
        d="M612.29 359.46c.68-.11.37-.26 1 .15M611.05 360.28c.73-.1 1-.57 1.51.05M610.37 360.76a1.52 1.52 0 0 1 1.5.21M609.65 361.59a2.42 2.42 0 0 1 1.61.1M608.81 362.21c.73-.21 1 .31 1.82.16M607.92 363.1c.47 0 .63-.16 1 0a3 3 0 0 0 .94.1M606.94 364a9 9 0 0 1 1.14 0 2 2 0 0 0 1.09 0M606.36 364.81a3.77 3.77 0 0 1 2.08.21M605 366.73a2.63 2.63 0 0 1 2.08 0M590.52 381.59c2.86-.47 6.23.05 9.09-.36M605.38 365.79c.73-.26.57-.15 1.3-.1s1 .21 1.25.1M604.23 367.46a3.26 3.26 0 0 1 2.34.05M606.11 368.24a7.4 7.4 0 0 0-2.44 0M605.49 369.07a4.3 4.3 0 0 0-2.55-.1M601.79 369.7a8.8 8.8 0 0 1 3.07.1M600.91 370.52a8 8 0 0 1 3.33.06M599.87 371.15c1.15-.06 2.24-.06 3.38-.11.16 0 .52-.15.73.11M603.61 371.77a28.6 28.6 0 0 1-5.15.15M602.68 372.66a13 13 0 0 1-2.24.2 1.7 1.7 0 0 0-.47-.15 6.35 6.35 0 0 0-2.6.26M597 373.59a1.5 1.5 0 0 1 1.14-.16c1.09.16 2.13 0 3.17.26a2.1 2.1 0 0 0 .83.26M596.39 374a11.3 11.3 0 0 1 2.33.05 14 14 0 0 0 3 .52h-.11M595.66 374.58a12.8 12.8 0 0 1 2.44.32c1.09.2 2.18-.11 3.22.2M594.67 375.1c1.09.47 2.24 0 3.38.26s2.08.15 3.12.36M593.94 375.93a33 33 0 0 1 5 .31 5.2 5.2 0 0 0 1.82.21M593.38 376.66c1.61.31 3.27 0 4.88.46a10.8 10.8 0 0 0 2.29.31h-.1M592.7 377.9a2 2 0 0 1 .52-.15 34 34 0 0 0 3.89.05 8.4 8.4 0 0 1 3.23.21h-.11M592.12 378.74c2.6-.26 5.25.1 7.85 0M591.66 379.52c2.75.31 5.5.05 8.21.26M591.25 380.35c1.19.26 2.39-.11 3.58.15a7.1 7.1 0 0 0 2.55.16 15.4 15.4 0 0 1 2.24-.05M610.74 369.23h.26M610.47 369.54c.11 0 .26-.16.32 0M610.16 370h.57M609.9 370.32h.73M609.43 370.79a10 10 0 0 0 1.2.1h-.11M609 371.41c.47-.16 1 0 1.46-.16h-.11M608.4 372.14h1.87M608.08 372.61a9 9 0 0 1 2.08.05h-.06M607.67 373.28a9.6 9.6 0 0 1 2.44.1M607.2 374c.52-.05.94.26 1.46.36a2.7 2.7 0 0 0 1.14-.05M607.05 374.58a9.4 9.4 0 0 0 2.39.37M606.58 375.21a5.1 5.1 0 0 1 2 .31 2.7 2.7 0 0 0 .88.05h-.05M605.69 376.19a4 4 0 0 1 2.71.15c.31.11.62 0 1 0h-.1M605.59 376.81a4.14 4.14 0 0 1 3 .11 1.8 1.8 0 0 0 .52 0M605 377.54c1.3.26 2.65-.15 3.95.21M604.6 378.12c1 .41 2.19 0 3.33.31a1.64 1.64 0 0 0 1.09-.05M603.87 378.9a2.65 2.65 0 0 1 1.41-.16 28 28 0 0 0 3.53.36M603.3 379.72c.26-.05.52.16.73.11 1.61-.26 3.22 0 4.78-.11M602.89 380.35c1.25.46 2.55 0 3.9.36a2.9 2.9 0 0 0 1.77 0M602.42 381.23a60 60 0 0 1 6 .21M613.34 370.21c.2 0 .36.16.57.11M613.07 370.79a1.7 1.7 0 0 1 .73-.11M612.87 371.3a3.4 3.4 0 0 1 1 .11M612.61 372a5 5 0 0 1 1.29.11M612.25 372.76c.57-.15 1.09.05 1.66-.1M612.19 373.28a5.3 5.3 0 0 0 1.61.1v-.1M611.87 374.1a2.77 2.77 0 0 1 1.46.11.78.78 0 0 0 .57-.11M611.83 374.84c.67-.26 1.35.15 2.08 0M611.52 375.72c.78-.05 1.5.11 2.28 0M611.25 376.39c.31-.1.68-.31 1-.15a5.3 5.3 0 0 0 1.56.15M611.1 377.18c.88-.31 1.82.21 2.7-.26M611 378a2.3 2.3 0 0 1 1.3.05 4.2 4.2 0 0 0 1.61-.05M610.74 378.79a21.5 21.5 0 0 1 3.22-.05l-.05.05M610.11 379.52c1.35-.11 2.76-.26 4.11-.26M610.27 380.35a34 34 0 0 1 4.63-.21M610 381.18c1.5.21 1.82-.1 3.32-.15.26 0 1.56-.26 1.82-.31a4.4 4.4 0 0 1 .89 0M610 381.59c2.28-.21 4.62.21 7-.36M600.08 381.34h1.81M608.92 381.59c.2.11.46-.1.62.11M617.6 381.44c1.87-.21 3.79.36 5.67 0M616.65 380.81a7 7 0 0 1 3.43.11c.11 0 .11.26.21.31a15.8 15.8 0 0 0 3.07-.05M610 380.72h-1.2M602.58 380.45c-.83.06-1.66.06-2.49.16M618.22 362.94h.37M618.38 363.46a.7.7 0 0 0 .47-.06M618.47 364.29c.06-.05.06-.15.11-.15a1.8 1.8 0 0 1 .52-.05M618.69 364.81c.26-.16.57-.05.88-.05M619.67 365.28a1.46 1.46 0 0 0-.83.15M619.21 366.16a1.13 1.13 0 0 1 .79-.16M620.4 366.63h-1.19M619.56 367.25c.42 0 .84.11 1.15-.15M621 368a5 5 0 0 0-1.3.11M620 368.86a2.73 2.73 0 0 0 1.41-.26M621.54 369.07a5.8 5.8 0 0 1-1.35.37M620.45 370.21c.57-.31 1.25 0 1.82-.26M622.43 370.68a4.2 4.2 0 0 0-1.41.05c-.15 0-.26.16-.46.16M620.92 372a2.35 2.35 0 0 1 1.14-.36c.05-.26.31 0 .42-.16a1.8 1.8 0 0 1 .52 0M623.25 372.3a9 9 0 0 0-2.07.2M621.39 373.39a8.6 8.6 0 0 1 2.39-.42M621.45 374.37a15.7 15.7 0 0 0 2.65-.52M624.72 374.48a9.2 9.2 0 0 0-2.91.46M622 375.83c.15.05.26.16.41.1a6.2 6.2 0 0 1 2.81-.57M625.49 376a6.7 6.7 0 0 1-3.06.37c-.11 0-.21.1-.37.15M622.43 377.18c1.14-.15 2.23-.21 3.38-.36M626.54 377.54c-.94.16-1.82-.05-2.71.16a10 10 0 0 0-1.19.31M622.79 378.74c.15 0 .36.05.46-.05 1.15-.68 2.45-.47 3.69-.52M627.31 378.9a9.4 9.4 0 0 0-3.17.1 3 3 0 0 1-1.14.36M623.36 380.14c.57-.1 1.09-.36 1.61-.47a29 29 0 0 1 3.59-.05M628.56 380.25a3.8 3.8 0 0 0-2 0 15.2 15.2 0 0 1-3 .57M624.09 381.34a20 20 0 0 0 2.45-.57 8.5 8.5 0 0 1 2 0M624.14 381.81c1.25-.21 2.5 0 3.74-.42.42-.16.89.1 1.35.05M629.23 381c2.08.15 4.16-.26 6.19.21M629.65 381.59c.26.05.47-.15.62-.15 1.72 0 3.43.05 5.15.15M634.8 377.18h.26M634.9 377.75c.21.1.41-.26.62 0M635.05 378.37h1.09M635.36 379.26c.37-.42.89 0 1.25-.26M635.63 380.09c.47-.41 1.14.06 1.61-.36M635.74 380.72c.67-.21 1.4 0 2.07-.37M636 381.34c1-.47 2.23.21 3.22-.52M636.09 381.85c1.3-.41 2.66 0 3.95-.05M640.87 381.81a59 59 0 0 1 6.92 0M639.89 381c2 .21 5.09 0 7.64.21M628.67 365.32c.15 0 1.56-.26 1.66-.26M629.14 365.7a3 3 0 0 0 1.76-.26M629.81 366.37a8 8 0 0 1 1.24-.26c.16-.05.37 0 .57-.05M630.33 366.73a14 14 0 0 1 2.19-.11M632.92 367.1a7 7 0 0 0-1.87.21M632.2 368a4.8 4.8 0 0 1 1.56-.31M634.54 368.3c-.42 0-1.3.1-1.77.1M633.65 369.07a4.2 4.2 0 0 0 1.56-.36M636.05 369.48c-.47 0-1.09 0-1.72.1M635.11 370.21a6.8 6.8 0 0 0 1.82-.15M637.56 370.42a7 7 0 0 1-1.56.36M636.77 371.52c.46-.31 1.29-.11 1.87-.31M639.27 371.88a7 7 0 0 0-1.56.05c-.16.05-.21.15-.47.15M641.14 373.28a10 10 0 0 0-2.24.21M639.63 374.27a11.7 11.7 0 0 1 2.44-.41M641.45 376.45a4 4 0 0 0 1.09-.15 9.4 9.4 0 0 1 2.6-.32M645.82 376.5c-1.51.26-2.08.31-3.22.42a2.3 2.3 0 0 0-.63.15M642.65 377.54c1.14-.2 2.8-.15 4-.31M647.85 377.85c-.94.16-2 0-2.91.21-.42.05-1.2.11-1.62.21M644.41 379a1.4 1.4 0 0 0 .47-.05c.93-.62 2.44-.52 3.79-.52M649.51 379.05a21 21 0 0 0-2.81.16 9 9 0 0 1-1.35.26M646.44 380.14c1.2-.21 3.49-.47 2.14-.36a23 23 0 0 1 2.8-.11M651.74 380.19a6.8 6.8 0 0 0-2.29.05 4.2 4.2 0 0 1-2.13.37M648.05 381a9.3 9.3 0 0 0 1.71-.26 10 10 0 0 1 2.24-.11M648.47 381.28a12.5 12.5 0 0 1 2.81 0 10 10 0 0 0 1.14-.05M628.25 364.81a1.62 1.62 0 0 1 1.09-.21c-.16-.21.26 0 .36-.1s.32-.05.52-.05M627.63 364.19a1.9 1.9 0 0 1 1.14-.11c-.16-.26.31 0 .36-.15s.37 0 .57 0M638 372.92c.37-.16.32-.26.83-.16-.15-.26.58 0 .63-.15s.62-.06.83-.06M640.16 375a14 14 0 0 0 2.59-.57M644 375.36c-1 .16-2.44.05-3.22.47M628.92 363.3c-.94-.05-1.09.26-1.77.26M639.16 365.9c.16 0 1.2-.21 1.35-.21M639.58 366.32c.62-.16 1.09 0 1.46-.26M640.1 366.83a6.4 6.4 0 0 1 1-.15 1.9 1.9 0 0 1 .52-.05M640.62 367.3a11 11 0 0 1 1.87-.16M642.85 367.61a6.6 6.6 0 0 0-1.77.26M641.76 368.45a5.4 5.4 0 0 1 1.87-.26M644.36 368.7c-.42 0-1.56.11-2 .16M643.05 369.39a5.3 5.3 0 0 0 1.93-.32M645.71 369.79c-.41 0-1.14 0-1.71.11M644.52 370.48a6.1 6.1 0 0 0 2-.21M647.12 370.63a8.7 8.7 0 0 1-1.72.42M646.34 371.61c.41-.26 1.24-.1 1.76-.26M648.67 372a5.7 5.7 0 0 0-1.4.06c-.16 0-.21.15-.42.1M650.39 373.28a8.4 8.4 0 0 0-2 .21M649 374.21a8 8 0 0 1 2.29-.41M650.85 376.24a3.4 3.4 0 0 0 .83-.16 10.2 10.2 0 0 1 2.45-.36M654.7 376.24a17 17 0 0 1-2.91.36 2 2 0 0 0-.63.16M651.79 377.18c1-.15 2.6-.15 3.64-.26M656.58 377.49c-.83.11-1.82 0-2.65.16-.37.1-1.15.1-1.51.21M653.45 378.52a1.1 1.1 0 0 0 .42 0c.83-.57 2.23-.47 3.53-.47M658.14 378.58a19 19 0 0 0-2.6.16c-.58.05-1.25.26-1.41.26M655 379.57c1.09-.21 3.48-.42 2.23-.32a22 22 0 0 1 2.6-.1M660.16 379.67a5.8 5.8 0 0 0-2.08 0 5.7 5.7 0 0 1-2.29.37M656.42 380.41c.78-.11 1.25-.11 1.93-.26a8.6 8.6 0 0 1 2.08-.11M657.2 380.81a9.7 9.7 0 0 1 2.55-.2 8 8 0 0 0 1-.11M638.54 365.48c.31-.16.21-.26.67-.21s.63.05.68-.1.31-.05.47-.05M637.81 365.07c.31-.15.36-.31.83-.26s.67 0 .73-.15.31 0 .52 0M647.63 372.92c.31-.16.16-.21.62-.16-.1-.21.52 0 .58-.1s.57-.05.78-.05M649.51 374.84c.78-.21 1.72-.21 2.39-.47M653 375.21c-.88.15-2-.06-2.7.31M639.21 364.08a3.37 3.37 0 0 0-2.13.73M649.87 368.65c.1 0 1.35-.2 1.4-.2M650.29 369c.47-.11 1.14-.06 1.4-.26M650.76 369.33l1-.16c.1-.05.26 0 .41 0M651.16 369.7a15 15 0 0 1 1.67-.16M653.14 369.9a3.9 3.9 0 0 0-1.4.21M652.47 370.52a4.7 4.7 0 0 1 1.25-.21M654.23 370.74c-.26 0-1.19.1-1.51.1M653.3 371.25a4.2 4.2 0 0 0 1.45-.26M655.32 371.57c-.36 0-.93.05-1.35.05M654.39 372.08a4.9 4.9 0 0 0 1.56-.16M656.42 372.24a6.5 6.5 0 0 1-1.35.26M655.54 373c.31-.21 1.24-.06 1.61-.16M657.61 373.23a4.2 4.2 0 0 0-1.15 0 .76.76 0 0 1-.36.05M658.91 374.27a9.3 9.3 0 0 0-1.76.21M657.72 374.9a9.6 9.6 0 0 1 1.87-.26M659 376.45a5 5 0 0 0 .88-.05 8.5 8.5 0 0 1 1.88-.26M662.24 376.55c-1 .15-1.45.21-2.28.26l-.58.05M659.8 377.23c.83-.16 2.18-.1 3-.21M663.65 377.49c-.63.11-1.41 0-2 .11a12 12 0 0 1-1.3.15M661 378.32c.1 0 .83-.21.88-.21 1-.1 1.4-.21 2.39-.26M664.83 378.32c-.93 0-1.3.05-2 .1-.47.06-1.25.32-1.36.32M662.29 379.15c.68-.16 2.7-.37 1.87-.31.89-.06 1-.06 2-.11M666.4 379.15a5.4 5.4 0 0 0-1.61 0 6 6 0 0 1-1.87.31M663.43 379.72a11 11 0 0 0 1.56-.21 8.4 8.4 0 0 1 1.61-.1M664 380a9.5 9.5 0 0 1 2.13-.15 5 5 0 0 0 .83-.05M649.61 368.3c.26-.11.36-.27.72-.21s.47.05.47 0 .26-.06.42-.06M649.19 367.92a1.33 1.33 0 0 1 .67-.2c.37 0 .52 0 .57-.06s.26-.05.37-.05M656.58 374a1 1 0 0 1 .72-.11c-.15-.15.37 0 .42-.1s.42 0 .57 0M658.23 375.46a10.7 10.7 0 0 0 1.82-.42M660.94 375.72a8 8 0 0 0-2.24.26M650.29 367.19c-.68-.05-.83.21-1.25.52M659.58 369.07c.11 0 1.2-.15 1.3-.15M660 369.43a6 6 0 0 0 1.3-.26M660.36 369.74l1-.15h.37M660.83 370.26a7 7 0 0 1 1.46-.31M662.6 370.26a4.4 4.4 0 0 0-1.45.26M661.72 370.89a3.7 3.7 0 0 1 1.4-.2M663.65 371.05a8 8 0 0 0-1.56.16M662.6 371.52a4.2 4.2 0 0 0 1.46-.26M664.63 371.77c-.31 0-1.09.1-1.51.15M663.74 372.3a4.3 4.3 0 0 0 1.46-.16M665.62 372.39a11 11 0 0 1-1.45.26M664.83 373.12c.26-.21 1.09-.1 1.46-.21M666.71 373.34a7 7 0 0 0-1 .05 1 1 0 0 1-.41.05M667.91 374.27a8.3 8.3 0 0 0-1.61.21M666.71 374.94a9.6 9.6 0 0 1 1.87-.31M668 376.34c.1 0 .72-.1.83-.1a7.2 7.2 0 0 1 1.71-.21M671 376.39a17 17 0 0 1-2.08.26 1.7 1.7 0 0 0-.52.05M668.69 377.12c.78-.1 2.08-.2 2.8-.26M672.32 377.28c-.63.05-1.35 0-1.93.1s-1.14.11-1.19.16M669.83 378c.1 0 .78-.16.83-.16.93-.1 1.3-.2 2.23-.26M673.41 378c-.89.05-1.2.05-1.82.1s-1.15.32-1.3.32M671 378.79c.68-.11 2.55-.37 1.77-.26a9.6 9.6 0 0 1 1.82-.11M674.87 378.79a4.7 4.7 0 0 0-1.51 0 4.5 4.5 0 0 1-1.71.26M672.11 379.3a7.3 7.3 0 0 0 1.46-.2 6.3 6.3 0 0 1 1.43-.1M672.53 379.61a13 13 0 0 1 2-.15 4 4 0 0 0 .73 0M659.38 368.76c.21-.1.26-.21.63-.15s.41 0 .46-.06.21-.05.37-.05M659 368.45c.26-.1.26-.21.63-.16s.46 0 .52-.1.2-.05.36-.05M665.78 374a1.07 1.07 0 0 1 .62-.11c-.1-.15.36 0 .42 0a1.6 1.6 0 0 1 .52-.05M667.23 375.36a9 9 0 0 0 1.76-.31M669.83 375.61a10.3 10.3 0 0 0-2.24.21M660 367.77a1.51 1.51 0 0 0-1.19.46"
        className="El_Salvador_svg__cls-186"
      />
      <path
        d="m589 448.73.9 6.66a3.5 3.5 0 0 0-4.15 1.92c-1.25 2.49-.15 4.37 2.25 5.57l3.22 1.65 6-11.64-2.4-1.2-2.39 4.67h-.05l-.52-6.17Zm.9 8.79a4 4 0 0 1 1.24.42l.3.15-1.68 3.18-.3-.15c-1.09-.57-1.82-1.25-1.2-2.54a1.63 1.63 0 0 1 1.66-1.06ZM577.94 448.27l3.48 2.34 1.98-2.91-3.64-2.44 1.24-1.87 5.83 3.95-7.28 10.81-5.82-3.9 1.25-1.82 3.64 2.39 1.61-2.39-3.54-2.34zM576.22 439.59l-3.22 3.68-1-.83c-2.08-1.82-4.17-1.74-6 .34-1.92 2.28-1.21 4.28 1 6.11l2.73 2.34 8.46-9.91Zm-6.63 4.24a2.9 2.9 0 0 1 1.5.82l.42.29-2.36 2.75-.38-.31c-1-.83-1.55-1.61-.55-2.81a1.6 1.6 0 0 1 1.37-.74M560.16 442.76l-1.76-2 5.4-4.94c1.2-1 2.81-2.7 1.3-4.36s-3.33-.26-4.52.83l-5.41 4.88-1.76-1.92 5.77-5.25c2.39-2.13 5.09-2.7 7.53 0s1.61 5.4-.78 7.54l-5.77 5.24ZM555.38 418.08a3.52 3.52 0 0 0-2.33.67 3.17 3.17 0 0 0-1.34 3.82 2.82 2.82 0 0 0-2.78.44c-2.13 1.46-2.08 3.27-.63 5.36l1.87 2.69 10.83-7.38-2.36-3.4a4.51 4.51 0 0 0-3.26-2.2m0 2.8c.78-.07 1.35.56 1.9 1.34l.34.42-2.77 1.87-.22-.3c-.68-1-1.38-2.14-.08-3a1.75 1.75 0 0 1 .79-.33Zm-3.82 3.79c.48 0 .89.31 1.27.89l.19.26-2.55 1.76-.18-.26c-.58-.83-.74-1.61.3-2.28a1.56 1.56 0 0 1 .93-.37ZM549.56 409.3l1.93-1.05 3.06 5.62-11.48 6.24-1.3-2.34 9.56-5.14zM549.36 403.38l1.03 2.43-11.95 5.26-1.04-2.44zM535.94 394.32a4 4 0 0 0-.41 3.28c.83 2.39 3.38 3.07 5.56 2.39a4 4 0 0 0 .68-7.59l2.85-.93a6.8 6.8 0 0 1 1.72 2.7 6.7 6.7 0 0 1-4.37 8.42 6.78 6.78 0 0 1-8.73-4.21 7 7 0 0 1-.2-3.12zM542.2 376.86l-12.28 7.45.37 2 14.11 2.84-.52-2.73-2.88-.63-.86-4.65 2.59-1.53Zm-4 5.43.57 3.15-4.94-.6v-.09ZM535.31 352.46a6.22 6.22 0 0 0-6.32 6.06l-.3 3.74 13 1.05.3-3.75a6.36 6.36 0 0 0-6-7.06 3.7 3.7 0 0 0-.68-.04m-.49 3a5.4 5.4 0 0 1 .9 0c2.34.16 3.86 1.45 3.59 4.41v.39l-7.82-.65v-.37c.22-2.42 1.34-3.65 3.33-3.79ZM538.8 342.2l-.83 4.11 3.49.72.88-4.26 2.13.42-1.4 6.91-12.79-2.7 1.4-6.86 2.19.46-.89 4.27 2.81.57.88-4.11zM544.26 326.04l-1.56 3.95 3.28 1.25 1.61-4.06 2.08.78-2.55 6.55-12.21-4.73 2.59-6.55 2.09.78-1.62 4.11 2.65 1.03 1.56-3.94zM552.11 318.09l1.98.98-2.92 5.72-11.64-5.98 1.2-2.33 9.66 4.93zM554 300.94a2.65 2.65 0 0 0-2.08 1 1.6 1.6 0 0 0 .16 2.23c1.76 1.3 4.26-3.58 7.79-.93a4.19 4.19 0 0 1 .89 6.23 4.75 4.75 0 0 1-4.53 1.82l-.26-2.34a2.68 2.68 0 0 0 3-.83 1.69 1.69 0 0 0-.47-2.49c-1.09-.83-2.13 0-3.12.62-1.56 1-3 1.51-4.62.31a3.87 3.87 0 0 1-.84-5.51 5.84 5.84 0 0 1 3.38-2.13l.73 2ZM559.87 289.49l-1.46 1.51 6 13.14 1.94-2-1.2-2.7 3.26-3.36 2.73 1.12 1.95-2Zm2.06 3.71 4.15 1.91-2 2.13-2.17-4ZM578.62 287.84l1.4 1.71-4.99 4.06-8.21-10.19 2.08-1.66 6.81 8.42zM581.79 272.71l2.44-1.5 2.7 14.13-1.3.84-11.59-8.53 2.39-1.56 7.49 5.72.05-.05zM593.48 266.36l-1.87.9.67 14.41 2.55-1.16-.12-3 4.27-1.9 2.09 2.1 2.59-1.17Zm.53 4.26 3.22 3.33-2.71 1.2-.52-4.45ZM608.05 261.83a7.1 7.1 0 0 0-2.1.34l-3.59 1.05 3.64 12.49 3.56-1a6.38 6.38 0 0 0 4.53-8.12 6.21 6.21 0 0 0-6.06-4.76Zm-.09 2.73c1.63.06 2.72 1 3.26 2.89.68 2.23 0 4.07-2.88 4.9l-.38.14-2.17-7.49.37-.14a6.2 6.2 0 0 1 1.84-.3ZM623.72 258.05c-.23 0-.5 0-.74.07a6.86 6.86 0 1 0 7.6 5.92 6.72 6.72 0 0 0-6.86-5.99m-.29 2.92a3.83 3.83 0 0 1 4.08 3.36c.2 1.78-1 4.22-3.08 4.53s-3.89-1.82-4.15-3.59a3.83 3.83 0 0 1 3.15-4.27ZM634.54 257.45l-.14 13.07h2.6l.05-5.25 3.22 5.32h3.21l-3.77-5.53a3.44 3.44 0 0 0 2.8-3.59c0-2.82-1.81-4-4.46-4h-3.59Zm2.7 2.32h.37c1.24 0 2.23.3 2.18 1.76s-.94 1.83-2.29 1.83h-.3v-3.59ZM665.15 268.66l-4.11-1.04-.83 3.43 4.26 1.09-.57 2.13-6.81-1.71 3.18-12.68 6.8 1.71-.52 2.18-4.26-1.09-.67 2.81 4.05.99zM677.26 274.59l3.27-8.16 2.44.98-4.93 12.37-1.77-.73-3.27-11.12h-.06l-3.27 8.21-2.44-.93 4.99-12.47 1.76.67 3.23 11.18zM692.79 285.5l-1.19 1.87-5.41-3.38 6.97-11.07 2.23 1.41-5.77 9.19zM705.44 281l-12.58 7.08 2.17 1.75 2.59-1.45 3.63 3-.9 2.8 2.2 1.77 4.5-13.67Zm-2 3.79-1.5 4.33-2.27-1.83ZM725 301.47 711.1 305l1.6 2.25 2.92-.69 2.73 3.79-1.6 2.5 1.68 2.29 7.82-12.05zm-2.8 3.15-2.59 3.81-1.71-2.43ZM725.91 329.62l-1.2-2.39 6.76-4.62-8.79.93-.41-.78 6.03-6.39v-.05l-7.8 2.6-1.19-2.39 12.99-4.01.88 1.67-6.18 6.86 9.09-.99.88 1.71zM734.38 336.95l-1.36-4-3.32 1.14 1.4 4.16-2.13.73-2.23-6.71 12.37-4.15 2.28 6.65-2.13.73-1.4-4.16-2.7.93 1.35 3.95zM742.68 339.62 730 342.31l.52 2.58 5.13-1.08h.08l-4.5 4.37.71 3.12 4.57-4.88a3.39 3.39 0 0 0 4.08 1.92c2.76-.58 3.5-2.59 2.92-5.25Zm-1.6 3.14.07.33c.26 1.25.18 2.29-1.27 2.55s-2-.54-2.22-1.83l-.07-.3ZM732.4 356.55l-.31-2.6 12.99-1.51.31 2.6zM742.53 369.17a3.9 3.9 0 0 0 1.36-3c-.06-2.54-2.34-3.95-4.58-3.89a4 4 0 0 0-2.91 7l-3 .06a7.1 7.1 0 0 1-.83-3.07 6.68 6.68 0 0 1 6.65-6.76 6.79 6.79 0 0 1 7.12 6.6 6.6 6.6 0 0 1-.73 3l-3.07.05ZM732.92 371.63l-.3 2.76 2.58 1.43-.57 4.67-2.91.67-.3 2.81 13.92-3.41.26-2.1Zm4.37 5.34 4.09 1.88-4.46 1ZM733.38 409.09a4.1 4.1 0 0 0 2.39-2.28c.94-2.39-.62-4.58-2.7-5.41a4.22 4.22 0 0 0-5.56 2.08 4.1 4.1 0 0 0 .21 3.33l-2.86-1.09a7.3 7.3 0 0 1 .42-3.17 6.88 6.88 0 0 1 12.78 5.09 6.9 6.9 0 0 1-1.82 2.55zM724.76 417.41l1.98-3.69-3.12-1.72-2.08 3.9-1.92-1.09 3.32-6.18 11.49 6.23-3.33 6.18-1.97-1.09 2.13-3.84-2.55-1.35-2.02 3.69zM715.98 427.7l7.12 5.14-1.56 2.18-10.77-7.89 1.11-1.51 11.58-.42h.05l-7.17-5.25 1.56-2.13 10.81 7.9-1.09 1.56-11.59.36zM715.15 438.71l1.92-1.97 1.56 1.51-5.61 5.87-1.56-1.51 1.87-1.98-7.86-7.53 1.82-1.92zM701.62 436.94l-2.06 1.64 3.37 4.09-5.93-1.88-2.48 2 6.48 1.76a3.47 3.47 0 0 0 .19 4.57c1.76 2.13 4 1.83 6 .12l2.73-2.29Zm2.5 7.33 2.29 2.77-.26.19c-1 .83-1.87 1.21-2.8.11s-.45-2 .59-2.84ZM693.46 443.71l-2.39 1.5.52 2.92-4 2.47-2.31-1.76-2.4 1.5 11.48 8.66 1.73-1.07-2.63-14.2Zm-1.46 6.85 1.16 4.35h-.07l-3.6-2.78ZM675.7 456.07l-.94-1.98 5.77-2.75 5.61 11.85-2.39 1.09-4.62-9.77z"
        className="El_Salvador_svg__cls-15"
      />
    </g>
  </svg>
);
export default SvgElSalvador;
